import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** ISO8601 Date string */
  Date: { input: any; output: any; }
  /** Postgres Interval value */
  Interval: { input: any; output: any; }
  /** A bounded JSON object */
  JSON: { input: unknown; output: unknown; }
  LowercaseStringValue: { input: any; output: any; }
  /** Expression representing some range, can be single number e.g. 1 or range e.g. 1-3 */
  RangeExp: { input: any; output: any; }
  /** JS regular expression */
  RegExp: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AccessToken = {
  __typename?: 'AccessToken';
  baseUser?: Maybe<BaseUser>;
  consent?: Maybe<Scalars['Boolean']['output']>;
  expireAt?: Maybe<Scalars['Date']['output']>;
  revoked?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<AccessTokenStatus>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum AccessTokenStatus {
  ConsentNotFound = 'CONSENT_NOT_FOUND',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED',
  Valid = 'VALID'
}

export type AdditionalRespondentDataFromTeamio = {
  __typename?: 'AdditionalRespondentDataFromTeamio';
  addedOn?: Maybe<Scalars['String']['output']>;
  channelId: Scalars['ID']['output'];
  managers?: Maybe<Array<Scalars['String']['output']>>;
  position?: Maybe<Scalars['String']['output']>;
  recruiter?: Maybe<Scalars['String']['output']>;
};

/** Aggregate of answers by their values */
export type AggregateAnswersByValue = {
  __typename?: 'AggregateAnswersByValue';
  /** Count of answers with same value|text */
  count: Scalars['Int']['output'];
  /** Text of answer */
  text: Scalars['String']['output'];
  /** Answer value, not null for SelectAnswer */
  value?: Maybe<Scalars['Int']['output']>;
};

export type AiCallLogData = {
  __typename?: 'AiCallLogData';
  data: Array<AiCallLogEntry>;
  totalCount: Scalars['Int']['output'];
};

export type AiCallLogDetail = {
  __typename?: 'AiCallLogDetail';
  cachedInputTokens?: Maybe<Scalars['Int']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Date']['output'];
  deployment: Scalars['String']['output'];
  durationMs?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  languageId?: Maybe<Scalars['ID']['output']>;
  model: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['ID']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  reasoningTokens?: Maybe<Scalars['Int']['output']>;
  respondentId?: Maybe<Scalars['ID']['output']>;
  responseText?: Maybe<Scalars['String']['output']>;
  retries: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  stream: Scalars['Boolean']['output'];
  surveyId?: Maybe<Scalars['ID']['output']>;
  systemPrompt?: Maybe<Scalars['String']['output']>;
  useCase: Scalars['String']['output'];
  userPrompt: Scalars['String']['output'];
};

export type AiCallLogEntry = {
  __typename?: 'AiCallLogEntry';
  cost?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Date']['output'];
  deployment: Scalars['String']['output'];
  durationMs?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  model: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['ID']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  promptPreview: Scalars['String']['output'];
  responsePreview?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  stream: Scalars['Boolean']['output'];
  useCase: Scalars['String']['output'];
};

/** AI use-case configuration row — hot-swappable, picked up by the API/worker within ~60s (SysAdmin only) */
export type AiGenerationConfig = {
  __typename?: 'AiGenerationConfig';
  deployment: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jsonMode: Scalars['Boolean']['output'];
  maxOutputTokens?: Maybe<Scalars['Int']['output']>;
  model: Scalars['String']['output'];
  reasoningEffort?: Maybe<Scalars['String']['output']>;
  systemPrompt?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Date']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  useCase: Scalars['String']['output'];
};

/** Partial override on top of a saved AiGenerationConfig row — used for both saving and as an unsaved test draft */
export type AiGenerationConfigInput = {
  deployment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  jsonMode?: InputMaybe<Scalars['Boolean']['input']>;
  maxOutputTokens?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  reasoningEffort?: InputMaybe<Scalars['String']['input']>;
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type AiGenerationConfigTestInput = {
  /** Unsaved form state, tested as an override without persisting anything */
  draft?: InputMaybe<AiGenerationConfigInput>;
  testPrompt: Scalars['String']['input'];
  useCase: Scalars['String']['input'];
};

export type AiGenerationTestResult = {
  __typename?: 'AiGenerationTestResult';
  cachedTokens?: Maybe<Scalars['Int']['output']>;
  costUsd?: Maybe<Scalars['Float']['output']>;
  durationMs: Scalars['Int']['output'];
  /** Provider or config error message; present instead of throwing so the test button can show it inline */
  error?: Maybe<Scalars['String']['output']>;
  inputTokens?: Maybe<Scalars['Int']['output']>;
  outputText?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  reasoningTokens?: Maybe<Scalars['Int']['output']>;
};

export type AiModelPricing = {
  __typename?: 'AiModelPricing';
  cachedInputCostPerToken?: Maybe<Scalars['Float']['output']>;
  fetchedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  inputCostPerToken: Scalars['Float']['output'];
  manualOverride: Scalars['Boolean']['output'];
  model: Scalars['String']['output'];
  outputCostPerToken: Scalars['Float']['output'];
  source: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum AiSurveySummaryAbInteractionAction {
  Exposed = 'EXPOSED',
  SelectedA = 'SELECTED_A',
  SelectedB = 'SELECTED_B',
  WholeAbSummaryRevealed = 'WHOLE_AB_SUMMARY_REVEALED'
}

export type AiSurveySummaryAbInteractionInput = {
  accessToken: Scalars['String']['input'];
  action: AiSurveySummaryAbInteractionAction;
  answersTotal?: InputMaybe<Scalars['Int']['input']>;
  experimentId: Scalars['ID']['input'];
  freeTextAnswersTotal?: InputMaybe<Scalars['Int']['input']>;
  languageCode: Scalars['String']['input'];
  surveyQuestionsTotal?: InputMaybe<Scalars['Int']['input']>;
  surveyRespondentsAnswered?: InputMaybe<Scalars['Int']['input']>;
  viewerSysAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiSurveySummaryAbTestData = {
  __typename?: 'AiSurveySummaryAbTestData';
  experimentId?: Maybe<Scalars['ID']['output']>;
  layout?: Maybe<AiSurveySummaryAbTestLayout>;
  left?: Maybe<AiSurveySummaryAbTestVariantStream>;
  mode: AiSurveySummaryAbTestMode;
  right?: Maybe<AiSurveySummaryAbTestVariantStream>;
  single?: Maybe<AiSurveySummaryData>;
};

export enum AiSurveySummaryAbTestLayout {
  ALeft = 'A_LEFT',
  BLeft = 'B_LEFT'
}

export enum AiSurveySummaryAbTestMode {
  Ab = 'AB',
  Single = 'SINGLE'
}

export type AiSurveySummaryAbTestVariantStream = {
  __typename?: 'AiSurveySummaryAbTestVariantStream';
  done: Scalars['Boolean']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  variantKey: AiSurveySummaryAbVariantKey;
};

export enum AiSurveySummaryAbVariantKey {
  A = 'A',
  B = 'B'
}

export type AiSurveySummaryCacheClearResult = {
  __typename?: 'AiSurveySummaryCacheClearResult';
  cacheCleared: Scalars['Boolean']['output'];
  limitReached: Scalars['Boolean']['output'];
};

export type AiSurveySummaryData = {
  __typename?: 'AiSurveySummaryData';
  done: Scalars['Boolean']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type AiTranslateNodeInput = {
  choices: Array<Scalars['String']['input']>;
  questionIndex: Scalars['Int']['input'];
  questionText: Scalars['String']['input'];
  statements: Array<Scalars['String']['input']>;
};

export type AiTranslateTopicNodesResult = {
  __typename?: 'AiTranslateTopicNodesResult';
  description?: Maybe<Scalars['String']['output']>;
  limitReached: Scalars['Boolean']['output'];
  nodes: Array<AiTranslatedNode>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AiTranslatedNode = {
  __typename?: 'AiTranslatedNode';
  choices: Array<Scalars['String']['output']>;
  questionIndex: Scalars['Int']['output'];
  questionText: Scalars['String']['output'];
  statements: Array<Scalars['String']['output']>;
  /** false when the node could not be fully translated (partial failure) — the client should skip it and leave it for retry */
  translated: Scalars['Boolean']['output'];
};

export enum AiUsageGroupBy {
  Day = 'DAY',
  Model = 'MODEL',
  Organization = 'ORGANIZATION',
  UseCase = 'USE_CASE'
}

export type AiUsageRow = {
  __typename?: 'AiUsageRow';
  avgDurationMs: Scalars['Float']['output'];
  calls: Scalars['Int']['output'];
  costUsd: Scalars['Float']['output'];
  errors: Scalars['Int']['output'];
  inputTokens: Scalars['Int']['output'];
  /** The group's key: a use case, model, organization id, or ISO day depending on groupBy */
  key?: Maybe<Scalars['String']['output']>;
  /** Populated only when grouping by ORGANIZATION; null means no organization */
  organizationName?: Maybe<Scalars['String']['output']>;
  outputTokens: Scalars['Int']['output'];
};

/** Special rule that always matches given input */
export type AlwaysMatchingRule = Rule & {
  __typename?: 'AlwaysMatchingRule';
  /** anonymity */
  anonymity?: Maybe<AnonymityLevel>;
  /** id of rule */
  id: Scalars['ID']['output'];
  /** Is from default - rule is created from question default rule */
  isFromDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Next state that FSM will transition to */
  nextQuestion: QuestionDefinition;
  /** Rule Operator */
  operator?: Maybe<RuleOperator>;
  /** Order of rule */
  order: Scalars['Int']['output'];
  /** Original rule value */
  origValue: Scalars['String']['output'];
};

/** Pair anonymityLevel -> label */
export type Anonymity = {
  __typename?: 'Anonymity';
  /** Label that will be shown in UI for this anonymity level */
  label: Scalars['String']['output'];
  /** AnonymityLevel */
  level: AnonymityLevel;
};

/** Tuple of desired anonymity and ui presentable label */
export type AnonymityChoice = {
  __typename?: 'AnonymityChoice';
  /** Text associated with this choice */
  text: Scalars['String']['output'];
  /** Anonymity that will be set if user selects this choice */
  value: AnonymityChoiceValue;
};

/**
 * Set anonymity of channel to which value?
 * This should extend AnonymityLevel enum but IDL doesn't support that nor scalar unions
 */
export enum AnonymityChoiceValue {
  /** Do NOT change anonymity */
  Cancel = 'CANCEL',
  /** We can identify respondent directly */
  None = 'NONE',
  /** Only respondent's organization is known */
  Organization = 'ORGANIZATION'
}

/** Level of anonymity, answers in particular channel have */
export enum AnonymityLevel {
  /** We can identify respondent directly */
  None = 'NONE',
  /** Only respondent's organization is known */
  Organization = 'ORGANIZATION'
}

/** Survey anonymity settings */
export type AnonymitySettings = {
  __typename?: 'AnonymitySettings';
  /** Allowed anonymity levels that can be set via setChannelAnonymity. */
  allowedLevels?: Maybe<Array<AnonymityLevel>>;
  /** Default anonymity for channels that are created from this survey. */
  default?: Maybe<AnonymityLevel>;
};

/** Union of all answer types. Should be interface extending Message type, but graphql doesn't allow that */
export type Answer = FreeTextAnswer | SelectAnswer;

/**
 * Question definition that can be answered.
 * Better would be if this extended QuestionDefinition interface
 * but graphql doesn't allow interfaces extend interfaces
 */
export type Answerable = {
  /**
   * Answers to this question.
   * Optionaly can return only answers for given channel or survey
   */
  answers: AnswersConnection;
  /** ID of question */
  id: Scalars['ID']['output'];
  /** Question wording */
  text: Scalars['String']['output'];
};


/**
 * Question definition that can be answered.
 * Better would be if this extended QuestionDefinition interface
 * but graphql doesn't allow interfaces extend interfaces
 */
export type AnswerableAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

/** The connection type for Answer. */
export type AnswersConnection = {
  /** Aggregate of answers by value */
  aggregate?: Maybe<Array<AggregateAnswersByValue>>;
  /** A list of edges. */
  edges?: Maybe<Array<AnswersEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AnswersEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The answer at the end of the edge. */
  node: Answer;
};

export type ArielAiChatAttachmentInput = {
  dataBase64: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type ArielAiChatData = {
  __typename?: 'ArielAiChatData';
  done: Scalars['Boolean']['output'];
  error?: Maybe<ArielAiChatError>;
  patch?: Maybe<Array<ArielAiNodeData>>;
  text: Scalars['String']['output'];
};

export type ArielAiChatError = {
  __typename?: 'ArielAiChatError';
  code: ArielAiChatErrorCode;
  message: Scalars['String']['output'];
  validationErrors?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ArielAiChatErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  AttachmentInvalid = 'ATTACHMENT_INVALID',
  GenerationFailed = 'GENERATION_FAILED',
  ValidationFailed = 'VALIDATION_FAILED'
}

export type ArielAiChatMessageInput = {
  attachments?: InputMaybe<Array<ArielAiChatAttachmentInput>>;
  content: Scalars['String']['input'];
  role: ArielAiChatRole;
};

export enum ArielAiChatRole {
  Assistant = 'ASSISTANT',
  User = 'USER'
}

export type ArielAiComment = {
  __typename?: 'ArielAiComment';
  id?: Maybe<Scalars['ID']['output']>;
  originator?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ArielAiCommentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  originator?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ArielAiNodeChoice = {
  __typename?: 'ArielAiNodeChoice';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ArielAiNodeChoiceInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ArielAiNodeData = {
  __typename?: 'ArielAiNodeData';
  answersToHighlight?: Maybe<Array<ArielAiNodeChoice>>;
  choices: Array<ArielAiNodeChoice>;
  commentGroupId?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<ArielAiComment>>;
  input: Scalars['Boolean']['output'];
  isQuestionTrigger: Scalars['Boolean']['output'];
  isRankingScale?: Maybe<Scalars['Boolean']['output']>;
  isRequired: Scalars['Boolean']['output'];
  metrics: Array<Metrics>;
  outputs: Array<ArielAiNodeOutput>;
  position?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  questionIndex: Scalars['Int']['output'];
  questionText: Scalars['String']['output'];
  randomizeOrder?: Maybe<Scalars['Boolean']['output']>;
  range?: Maybe<ArielAiSelectedRange>;
  reportOrder?: Maybe<Scalars['Int']['output']>;
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  statementIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  statements?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: Scalars['String']['output'];
};

export type ArielAiNodeDataInput = {
  answersToHighlight?: InputMaybe<Array<ArielAiNodeChoiceInput>>;
  choices: Array<ArielAiNodeChoiceInput>;
  commentGroupId?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Array<ArielAiCommentInput>>;
  input: Scalars['Boolean']['input'];
  isQuestionTrigger: Scalars['Boolean']['input'];
  isRankingScale?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired: Scalars['Boolean']['input'];
  metrics: Array<Metrics>;
  outputs: Array<ArielAiNodeOutputInput>;
  position?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  questionIndex: Scalars['Int']['input'];
  questionText: Scalars['String']['input'];
  randomizeOrder?: InputMaybe<Scalars['Boolean']['input']>;
  range?: InputMaybe<SelectedRange>;
  reportOrder?: InputMaybe<Scalars['Int']['input']>;
  showEscapeOption?: InputMaybe<Scalars['Boolean']['input']>;
  statementIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statements?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: Scalars['String']['input'];
};

export type ArielAiNodeOutput = {
  __typename?: 'ArielAiNodeOutput';
  key: Scalars['String']['output'];
  targetQuestionIndex?: Maybe<Scalars['Int']['output']>;
};

export type ArielAiNodeOutputInput = {
  key: Scalars['String']['input'];
  targetQuestionIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type ArielAiSelectedRange = {
  __typename?: 'ArielAiSelectedRange';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

/** Rule that can match aray of integers. */
export type ArrayRule = Rule & {
  __typename?: 'ArrayRule';
  /** anonymity */
  anonymity?: Maybe<AnonymityLevel>;
  /** id of rule */
  id: Scalars['ID']['output'];
  /** Is from default - rule is created from question default rule */
  isFromDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Next state that FSM will transition to if this rule matches */
  nextQuestion: QuestionDefinition;
  /** rule operator */
  operator?: Maybe<RuleOperator>;
  /** Order of rule */
  order: Scalars['Int']['output'];
  /** Original rule value */
  origValue: Scalars['String']['output'];
  /** Expression for this rule */
  value?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type BaseUser = {
  __typename?: 'BaseUser';
  /** users first name */
  firstname?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  /** users last name */
  surname?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type BasicSurveyInfo = {
  __typename?: 'BasicSurveyInfo';
  /** Date when was the survey archived, null if not archived */
  archivedAt?: Maybe<Scalars['Date']['output']>;
  endsAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Indicates if the survey is public */
  public?: Maybe<Scalars['Boolean']['output']>;
  sendAt: Scalars['Date']['output'];
  seqDate?: Maybe<Scalars['Date']['output']>;
  status: SurveyStatus;
};

export enum BusinessUnit {
  Central = 'CENTRAL',
  South = 'SOUTH'
}

export type CategoryCode = {
  __typename?: 'CategoryCode';
  code: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  translations?: Maybe<Array<CategoryCodeTranslation>>;
};

/** Category code translation */
export type CategoryCodeTranslation = {
  __typename?: 'CategoryCodeTranslation';
  language: Language;
  name: Scalars['String']['output'];
};

/**
 * Channel represents one conversation of respondent with BOT.
 * Can have various levels of anonymity, default is inherited from parent topic.
 */
export type Channel = {
  __typename?: 'Channel';
  /** True if channel has at least one alert-raising answer */
  alert: Scalars['Boolean']['output'];
  /** Allowed anonymity levels that can be set via setChannelAnonymity. */
  allowedAnonymities: Array<AnonymityLevel>;
  /** Allowed languages for channel */
  allowedLanguages: Array<Language>;
  /** Level of anonymity this channel currently have */
  anonymityLevel: AnonymityLevel;
  /** True if changing anonymity is disabled */
  anonymityLocked: Scalars['Boolean']['output'];
  /** True if channel has at least one respondent message */
  answered: Scalars['Boolean']['output'];
  containsOriginalAnonymity: Scalars['Boolean']['output'];
  /** When this channel was created */
  createdAt: Scalars['Date']['output'];
  /** True if channel was created dissabled */
  disabled: Scalars['Boolean']['output'];
  /** Reason why this channel was disabled, if known */
  disabledReason?: Maybe<ChannelDisabledReason>;
  /** end of underlying survey */
  endsAt?: Maybe<Scalars['Date']['output']>;
  /** Channel events */
  events?: Maybe<Array<ChannelEvent>>;
  /** Date of FINISHED event if exists */
  finishedAt?: Maybe<Scalars['Date']['output']>;
  /** Channel ID */
  id: Scalars['ID']['output'];
  /** True if events contain FINISHED event */
  isFinished: Scalars['Boolean']['output'];
  isFinishedByRespondent: Scalars['Boolean']['output'];
  /** True if channel was already opened */
  isOpen: Scalars['Boolean']['output'];
  /** Channel language */
  language: Language;
  lastRemindedAt?: Maybe<Scalars['Date']['output']>;
  /** All sent messages in chronological order */
  messages?: Maybe<Array<Message>>;
  /** Date of first OPENED event if exists */
  openedAt?: Maybe<Scalars['Date']['output']>;
  /** If survey for channel is public */
  public: Scalars['Boolean']['output'];
  reactions?: Maybe<Array<Reaction>>;
  remainingQuestions: Scalars['Int']['output'];
  /** Respondent of the channel */
  respondent?: Maybe<Respondent>;
  /** start of underlying survey */
  sendAt: Scalars['Date']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  /** Parent survey */
  survey: Survey;
  /** flag if underlying survey is finished */
  surveyFinished: Scalars['Boolean']['output'];
  /**
   * Target of this channel based on anonymityLevel
   * Whole Organization, single team or in case of no anonymity responder himself
   * Currently it's set after channel is finished,
   * before finishing it points to respondent to whom this channel was sent
   */
  target: ChannelTarget;
  /** Indicates wheter survey runs in test mode or not */
  testing?: Maybe<Scalars['Boolean']['output']>;
  /** name of channel topic */
  topicName: Scalars['String']['output'];
  totalQuestions: Scalars['Int']['output'];
};

/** Reason why a channel was disabled */
export enum ChannelDisabledReason {
  /** Response was manually deactivated */
  Manual = 'MANUAL',
  /** Response was filled too quickly (below minimum filling time) */
  TooFast = 'TOO_FAST'
}

/** Channel event what else to say? */
export type ChannelEvent = {
  __typename?: 'ChannelEvent';
  /** Parent channel */
  channel: Channel;
  /** When this event happened */
  createdAt: Scalars['Date']['output'];
  /** ID of event */
  id: Scalars['ID']['output'];
  /** type of event */
  type: ChannelEventType;
};

/** Channel event type */
export enum ChannelEventType {
  /** Channel has been anonymized */
  Anonymized = 'ANONYMIZED',
  /** Channel finished */
  Finished = 'FINISHED',
  /** Some channel messages were deleted */
  MessagesDeleted = 'MESSAGES_DELETED',
  /** Channel opened */
  Opened = 'OPENED',
  /** SourceId for channel was set */
  SetSourceId = 'SET_SOURCE_ID'
}

export type ChannelOverview = {
  __typename?: 'ChannelOverview';
  respondents?: Maybe<Array<PublicRespondent>>;
  user?: Maybe<OverviewUser>;
};

/**
 * For what most particular entity this channel answers.
 * e.g. Respondent can choose that he wants to be completely anonymous
 * so channel will target Organization and his answers won't be trackable
 * to him
 */
export type ChannelTarget = Organization | Respondent | Team;

/** Side of conversation */
export enum ChannelUserType {
  /** Message was sent by BOT */
  Bot = 'BOT',
  /** Message was sent by respondent */
  Respondent = 'RESPONDENT'
}

export type ChannelWithStartingMessages = {
  __typename?: 'ChannelWithStartingMessages';
  channel: Channel;
  displayLinkToOneplace?: Maybe<Scalars['Boolean']['output']>;
  messages?: Maybe<Array<Message>>;
  someReport?: Maybe<Scalars['Boolean']['output']>;
  someUnfilledChannel?: Maybe<Scalars['Boolean']['output']>;
  /** Created messages */
  startingMessages?: Maybe<Array<Message>>;
};

export type ChoiceAnswer = {
  choice: Scalars['String']['input'];
  count: Scalars['Int']['input'];
};

export type Comment = {
  __typename?: 'Comment';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  originator?: Maybe<User>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CommentGroup = {
  __typename?: 'CommentGroup';
  comments?: Maybe<Array<Comment>>;
  id: Scalars['ID']['output'];
  positionX: Scalars['Int']['output'];
  positionY: Scalars['Int']['output'];
  topicId: Scalars['ID']['output'];
};

/** Comment "question" that doesn't expect answer, instead will immediately send following question */
export type CommentQuestionDefinition = QuestionDefinition & {
  __typename?: 'CommentQuestionDefinition';
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rule what question will be sent next. Always should be single value. */
  rules: Array<AlwaysMatchingRule>;
  /** How many choices user needs to select */
  selectedRange?: Maybe<Scalars['RangeExp']['output']>;
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};

/** Respondent contact */
export type Contact = {
  __typename?: 'Contact';
  /** Parsed phone number */
  phoneNumber?: Maybe<PhoneNumber>;
  /** Contact Source */
  source?: Maybe<ContactSource>;
  /** Type of contact */
  type: ContactType;
  /** Contact information */
  value: Scalars['String']['output'];
};

/** Respondent contact */
export type ContactInput = {
  /** Type of contact */
  contactType: ContactType;
  /** Contact Source */
  source: ContactSource;
  /** Contact information */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Type of contact source */
export enum ContactSource {
  /** Contact was created via admin or internal */
  Primary = 'PRIMARY',
  /** Contact was created when respondent answered question of type EMAIL or SMS contact */
  Respondent = 'RESPONDENT'
}

/** Type of contact */
export enum ContactType {
  /** Email type */
  Email = 'EMAIL',
  /** SMS type */
  Sms = 'SMS'
}

export type ConversationSubjectInput = {
  id: Scalars['ID']['input'];
  type: ConversationSubjectType;
};

/** Type of allowed conversataion subject for organization */
export enum ConversationSubjectType {
  /** Specific topic */
  Topic = 'TOPIC',
  /** Set of topics */
  TopicGroup = 'TOPIC_GROUP'
}

export type CreateCommentGroupInput = {
  comment?: InputMaybe<CreateCommentInput>;
  positionX: Scalars['Int']['input'];
  positionY: Scalars['Int']['input'];
  topicId: Scalars['ID']['input'];
};

export type CreateCommentInput = {
  commentGroupId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type CreateOrganizationInput = {
  /** Allowed survey languages for organization. Code is ISO 639-1 */
  allowedLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  boughtCredits?: InputMaybe<Scalars['Float']['input']>;
  /** Business unit of the organization */
  businessUnit?: InputMaybe<BusinessUnit>;
  /** Source channel */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** CIN (IČO) for integration with other systems */
  companyId?: InputMaybe<Scalars['String']['input']>;
  /** Allowed topics or topic groups for organization */
  conversationSubjects?: InputMaybe<Array<ConversationSubjectInput>>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** Organization country code. ISO 3166-1 alpha-2 */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Custom organization name */
  customName?: InputMaybe<Scalars['String']['input']>;
  /** External ID for integration with other systems (Teamio etc.) */
  externalUid?: InputMaybe<Scalars['String']['input']>;
  garantEmail?: InputMaybe<Scalars['String']['input']>;
  /** ID of organizations group */
  groupOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  /** is organization inactive after create */
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  /** Licence count */
  licenceCount?: InputMaybe<Scalars['Int']['input']>;
  /** custom attribute do DB */
  microlearningAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minimal team size to generate report */
  minimalTeamSizeToGenerateReport?: InputMaybe<Scalars['Int']['input']>;
  /** Minimal team size to keep anonymity */
  minimalTeamSizeToKeepAnonymity?: InputMaybe<Scalars['Int']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  /** ID of originator */
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  /** Name of organization purchased product name */
  product?: InputMaybe<Scalars['String']['input']>;
  productHistorySurveyTypes?: InputMaybe<Array<ProductHistorySurveyTypeInput>>;
  /** Organization language code */
  selfRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization name */
  systemName: Scalars['String']['input'];
  testOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  transferredCredits?: InputMaybe<Scalars['Float']['input']>;
  trialProduct?: InputMaybe<Scalars['Boolean']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Organization valid period */
  validPeriod: Scalars['Int']['input'];
};

export type CreateProcessStepInput = {
  candidateLanguageCode?: InputMaybe<Scalars['String']['input']>;
  copyTg?: InputMaybe<Scalars['Boolean']['input']>;
  customFieldsCheck?: InputMaybe<Array<CustomFieldsCheckInput>>;
  endOffsetMins?: InputMaybe<Scalars['Int']['input']>;
  eventDateField?: InputMaybe<Scalars['String']['input']>;
  payloadCheck?: InputMaybe<Array<PayloadCheckInput>>;
  previousEventsCheck?: InputMaybe<Array<PreviousEventsCheckInput>>;
  processTopicGroupId: Scalars['ID']['input'];
  remindersOffsetMins?: InputMaybe<Array<Scalars['Int']['input']>>;
  startOffsetMins?: InputMaybe<Scalars['Int']['input']>;
  stepTopicGroupId: Scalars['ID']['input'];
  triggeredOn?: InputMaybe<Scalars['String']['input']>;
  useEmailFromNote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProductVersionInput = {
  boughtCredits?: InputMaybe<Scalars['Float']['input']>;
  licenceCount?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  product: Scalars['String']['input'];
  productHistorySurveyTypes?: InputMaybe<Array<InputMaybe<ProductHistorySurveyTypeInput>>>;
  transferredCredits?: InputMaybe<Scalars['Float']['input']>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
  validFrom: Scalars['Date']['input'];
  validPeriod: Scalars['Int']['input'];
};

/** Parameters for createPublicSurvey mutation */
export type CreatePublicSurveyInput = {
  /** Descriptor for anonymity related behaviour. Pass null for defaults */
  anonymity?: InputMaybe<SurveyAnonymityInput>;
  endsAt?: InputMaybe<Scalars['Date']['input']>;
  /** Language of public survey */
  language: Scalars['String']['input'];
  /** Owner of survey. Will came later from auth probably */
  organizationId: Scalars['ID']['input'];
  reportNote?: InputMaybe<Scalars['String']['input']>;
  reportParams?: InputMaybe<Scalars['String']['input']>;
  /** Topic to start */
  topicId: Scalars['ID']['input'];
};

export type CreateSalesOrganizationInput = {
  adminEmail: Scalars['String']['input'];
  adminName: Scalars['String']['input'];
  adminSurname: Scalars['String']['input'];
  ignoreOrgAdminAlreadyExists?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  respondentsCount: Scalars['Int']['input'];
  vatNumber: Scalars['String']['input'];
};

export type CreateSurveyGroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  topicGroupId: Scalars['ID']['input'];
};

/** Parameters for createSurvey mutation */
export type CreateSurveyInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  /** Descriptor for anonymity related behaviour. Pass null for defaults */
  anonymity?: InputMaybe<SurveyAnonymityInput>;
  /** Conversation subject to start */
  conversationSubjectId: Scalars['ID']['input'];
  /** Conversation subject type */
  conversationSubjectType: ConversationSubjectType;
  /** Custom topic ID */
  customTopicId?: InputMaybe<Scalars['ID']['input']>;
  /** When survey ends. Must be later than sendAt */
  endsAt?: InputMaybe<Scalars['Date']['input']>;
  forceActivation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Language of survey. Topic must have translation for this language */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Recipients for empty organization to be de-deleted or created */
  newRecipientEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Owner of survey. Will came later from auth probably */
  organizationId: Scalars['ID']['input'];
  /** Only allowed channels for these recipients */
  recipientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Teams that will answer in this survey.
   * If null, whole organization will answer
   */
  recipients?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Reminders to be sent at specified time. */
  reminders?: InputMaybe<Array<SurveyReminderInput>>;
  /** ID of report definition */
  reportDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  reportNote?: InputMaybe<Scalars['String']['input']>;
  reportParams?: InputMaybe<Scalars['String']['input']>;
  respondentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When survey sends out invitation emails and becomes ONGOING */
  sendAt?: InputMaybe<Scalars['Date']['input']>;
  /** Survey invitation and reminders will be send to both contacts - email and sms */
  sendEmailSms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reference date for the survey group respondents */
  seqDate?: InputMaybe<Scalars['Date']['input']>;
  /** Id of survey group for the survey */
  surveyGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates wheter survey runs in test mode or not */
  testing?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeTemplateUid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  changedPassword?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  consent?: InputMaybe<Scalars['Boolean']['input']>;
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  systemRole?: InputMaybe<UserSysRole>;
  username: Scalars['String']['input'];
};

export type CreditHistory = {
  __typename?: 'CreditHistory';
  createdAt: Scalars['Date']['output'];
  creditsUsed: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  type: Scalars['String']['output'];
  user?: Maybe<User>;
};

export enum CreditHistoryType {
  Exit = 'EXIT',
  Hiring = 'HIRING',
  ManualDeduction = 'MANUAL_DEDUCTION',
  Onboarding = 'ONBOARDING',
  OneTime = 'ONE_TIME',
  Process = 'PROCESS',
  PublicSurvey = 'PUBLIC_SURVEY',
  Pulser = 'PULSER'
}

export type CreditsToReturn = {
  __typename?: 'CreditsToReturn';
  creditsToReturn?: Maybe<Scalars['Int']['output']>;
  respondentId: Scalars['ID']['output'];
};

export type CronJob = {
  __typename?: 'CronJob';
  createdAt?: Maybe<Scalars['Date']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  jobKey: Scalars['String']['output'];
  runAt?: Maybe<Scalars['Date']['output']>;
  taskIdentifier: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  workerTask?: Maybe<Job>;
};

export type CronJobInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  runAt?: InputMaybe<Scalars['Date']['input']>;
  taskIdentifier: Scalars['String']['input'];
};

export enum Currency {
  Czk = 'CZK',
  Eur = 'EUR'
}

export type CustomFieldsCheck = {
  __typename?: 'CustomFieldsCheck';
  key: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type CustomFieldsCheckInput = {
  key: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type DateRangeInput = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export type DatesForNewSurvey = {
  __typename?: 'DatesForNewSurvey';
  /** When survey will end. When it ends it will finish all channels */
  endsAt?: Maybe<Scalars['Date']['output']>;
  /** Time when reminder will be send */
  reminderAt?: Maybe<Scalars['Date']['output']>;
  /** Time when second reminder will be send */
  secondReminderAt?: Maybe<Scalars['Date']['output']>;
  /** Time when this survey is scheduled to be send */
  sendAt: Scalars['Date']['output'];
};

export type DeleteMessagesResult = {
  __typename?: 'DeleteMessagesResult';
  deletedMessages: Array<Message>;
  remainingQuestions: Scalars['Int']['output'];
};

export type EmailContactQuestionDefinition = Answerable & QuestionDefinition & {
  __typename?: 'EmailContactQuestionDefinition';
  /**
   * Answers to this question.
   * Optionaly can return only answers for given channel or survey
   */
  answers: SelectAnswersConnection;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** Email */
  email: Scalars['String']['output'];
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<RangeRule>;
  /** How many choices user needs to select */
  selectedRange?: Maybe<Scalars['RangeExp']['output']>;
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};


export type EmailContactQuestionDefinitionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Message that ends the channel, after this message channel is closed and sending messages to it will fail */
export type EndingMessage = Message & {
  __typename?: 'EndingMessage';
  anonymityLevel: AnonymityLevel;
  anonymousInReport?: Maybe<Scalars['Boolean']['output']>;
  /** When message was created */
  createdAt: Scalars['Date']['output'];
  /** Entity that sent this message, bot or respondent */
  createdBy: ChannelUserType;
  /** ID of message */
  id: Scalars['ID']['output'];
  isLast?: Maybe<Scalars['Boolean']['output']>;
  /** Channel to which message was sent */
  sentOn: Channel;
  /** Message text */
  text?: Maybe<Scalars['String']['output']>;
};

export type EndingQuestionDefinition = Answerable & QuestionDefinition & {
  __typename?: 'EndingQuestionDefinition';
  /**
   * Answers to this question.
   * Optionaly can return only answers for given channel or survey
   */
  answers: SelectAnswersConnection;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<AlwaysMatchingRule>;
  /** How many choices user needs to select */
  selectedRange?: Maybe<Scalars['RangeExp']['output']>;
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};


export type EndingQuestionDefinitionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

export type ErrorReportInput = {
  browserData: Scalars['String']['input'];
  /** Error report from browser to slack */
  componentStack: Scalars['String']['input'];
  email: Scalars['String']['input'];
  error: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  systemRole?: InputMaybe<UserSysRole>;
  url: Scalars['String']['input'];
};

export type FeEventPayload = {
  detail?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  orgRole?: InputMaybe<UserOrgRole>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  questionIndex?: InputMaybe<Scalars['Int']['input']>;
  reportAccess?: InputMaybe<Scalars['String']['input']>;
  reportAccessId?: InputMaybe<Scalars['ID']['input']>;
  respondentId?: InputMaybe<Scalars['ID']['input']>;
  surveyGroupId?: InputMaybe<Scalars['ID']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

export enum FeEventType {
  AdminReopenSurvey = 'ADMIN_REOPEN_SURVEY',
  AdminSendReminder = 'ADMIN_SEND_REMINDER',
  AnalyzeKeyWords = 'ANALYZE_KEY_WORDS',
  BulkAddRespondentsInSurvey = 'BULK_ADD_RESPONDENTS_IN_SURVEY',
  DownloadChart = 'DOWNLOAD_CHART',
  DownloadRespondentDetail = 'DOWNLOAD_RESPONDENT_DETAIL',
  DownloadRespondentPartialDetail = 'DOWNLOAD_RESPONDENT_PARTIAL_DETAIL',
  HideKeyWords = 'HIDE_KEY_WORDS',
  OneplaceLoaded = 'ONEPLACE_LOADED',
  ReportAiKeywordsFilter = 'REPORT_AI_KEYWORDS_FILTER',
  ReportAiSurveySummaryOpened = 'REPORT_AI_SURVEY_SUMMARY_OPENED',
  ReportExport = 'REPORT_EXPORT',
  ReportReopenSurvey = 'REPORT_REOPEN_SURVEY',
  ReportSendReminder = 'REPORT_SEND_REMINDER',
  ShowKeyWords = 'SHOW_KEY_WORDS',
  SurveyGroupChangeDate = 'SURVEY_GROUP_CHANGE_DATE',
  TeamioOnboardingCandidateClicked = 'TEAMIO_ONBOARDING_CANDIDATE_CLICKED',
  TeamioOnboardingPageLoaded = 'TEAMIO_ONBOARDING_PAGE_LOADED',
  TeamioOnboardingParticipantReportOpened = 'TEAMIO_ONBOARDING_PARTICIPANT_REPORT_OPENED',
  TeamioOnboardingRespondentCreated = 'TEAMIO_ONBOARDING_RESPONDENT_CREATED',
  TeamioOnboardingRespondentRemoved = 'TEAMIO_ONBOARDING_RESPONDENT_REMOVED',
  TeamioOnboardingSummaryReportOpened = 'TEAMIO_ONBOARDING_SUMMARY_REPORT_OPENED',
  TeamioOpenForm = 'TEAMIO_OPEN_FORM',
  TeamioOpenFormFail = 'TEAMIO_OPEN_FORM_FAIL',
  TeamioOpenFormSuccess = 'TEAMIO_OPEN_FORM_SUCCESS',
  TopLevelReportOpen = 'TOP_LEVEL_REPORT_OPEN'
}

export enum Features {
  /** generate keywords using ChatGPT */
  AiKeywords = 'aiKeywords',
  /** enable ai summary of respondent in process reports */
  AiSummaryOfRespondent = 'ai_summary_of_respondent',
  /** generate summary for survey and phase report */
  AiSummaryOfSurveyAndPhase = 'ai_summary_of_survey_and_phase',
  /** ai summary - A/B testing */
  AiSummaryOfSurveyAndPhaseAbTest = 'ai_summary_of_survey_and_phase_ab_test',
  /** enable AI translation in topic editor */
  AiTranslation = 'ai_translation',
  /** allow duplicate contacts for respondents in organization import via API */
  AllowDuplicateImportContacts = 'allow_duplicate_import_contacts',
  /** AI chat assistant in Ariel topic editor */
  ArielAi = 'ariel_ai',
  /** all new reports are automatically approved if they fit some rules */
  AutomaticApprovedProcessReports = 'automatic_approved_process_reports',
  /** all new reports are automatically approved if they fit some rules */
  AutomaticApprovedStandaloneReports = 'automatic_approved_standalone_reports',
  /** enables creating and editing of topics */
  CreateAndEditTopics = 'create_and_edit_topics',
  /** add another sheet to excel report with data that can be used to easily uncover anonymized respondents */
  DangerouslyRemoveAnonymityInExcel = 'dangerously_remove_anonymity_in_excel',
  /** disabled employee management - used for companies that are only using API to update employees */
  DisableEmployeeManagement = 'disable_employee_management',
  /** display table with respondent answers in report */
  DisplayTableWithRespondentAnswers = 'display_table_with_respondent_answers',
  /** enable external API tasks */
  EnableExternalApi = 'enable_external_api',
  /** enable SMS as a preferred contact method for hiring */
  HiringPreferredContactSms = 'hiring_preferred_contact_sms',
  KeepPeopleInProcessSurveyDuringImport = 'keep_people_in_process_survey_during_import',
  /** enable 2FA login to admim */
  Login_2fa = 'login_2fa',
  /** enable Pulser module in Admin */
  PulserModule = 'pulser_module',
  ReportReactionToMessage = 'report_reaction_to_message',
  ReportReactionToWholeConversation = 'report_reaction_to_whole_conversation',
  /** remove respondents from process survey in report */
  ReportRemoveRespondentFromProcessSurvey = 'report_remove_respondent_from_process_survey',
  /** require login in reports */
  RequireLoginInReports = 'require_login_in_reports',
  /** Survey invitation and reminders will be send to both contacts - email and sms */
  SendEmailSms = 'send_email_sms',
  /** send an email to help increase response rate */
  SendEmailToIncreaseResponseRate = 'send_email_to_increase_response_rate',
  SendInfoOnboardingEmail = 'send_info_onboarding_email',
  /** send invitation to respondents from report */
  SendInvitationFromReport = 'send_invitation_from_report',
  /** show Notification settings in Admin */
  ShowNotificationSettings = 'show_notification_settings',
  /** control if the respondents will see link to the Oneplace after finishing the conversation */
  ShowOneplaceLinkFromChat = 'show_oneplace_link_from_chat',
  /** combined with sso_forced: users whose email domain is not in allowedEmailDomains are completely blocked from logging in, even via other organizations that would otherwise permit password login (SysAdmins excluded) */
  SsoExclusive = 'sso_exclusive',
  /** users of the organization can ONLY log in via SSO; password and magic-link login are hidden (SysAdmins excluded) */
  SsoForced = 'sso_forced',
  /** show 'Log in with SSO' as an additional login option for users of the organization */
  SsoLogin = 'sso_login',
  /** log events from Teamio for candidates */
  TeamioEventLogging = 'teamio_event_logging',
  /** flags company as teamio Onboarding */
  TeamioOnboardingV2 = 'teamio_onboarding_v2',
  /** organization is migrated to Teamio - used by Teamio user sync, NOT by login (see sso_login / sso_forced) */
  TeamioSso = 'teamio_sso'
}

/** File type for graphql-upload */
export type File = {
  __typename?: 'File';
  /** Unique ID of file - name */
  id?: Maybe<Scalars['String']['output']>;
  /** File name */
  name?: Maybe<Scalars['String']['output']>;
  /** URL of the file */
  url?: Maybe<Scalars['String']['output']>;
};

export type Filter = {
  name: Scalars['String']['input'];
};

/** Answer to plain text question */
export type FreeTextAnswer = Message & {
  __typename?: 'FreeTextAnswer';
  anonymityLevel: AnonymityLevel;
  anonymousInReport?: Maybe<Scalars['Boolean']['output']>;
  /** When message was created */
  createdAt: Scalars['Date']['output'];
  /** Entity that sent this message, bot or respondent */
  createdBy: ChannelUserType;
  /** ID of message */
  id: Scalars['ID']['output'];
  isLast?: Maybe<Scalars['Boolean']['output']>;
  /** Answer is to this question */
  question: Question;
  remainingQuestions: Scalars['Int']['output'];
  /** Response on answer */
  response?: Maybe<Array<Message>>;
  /** Channel to which message was sent */
  sentOn: Channel;
  /** Display value of answer */
  text: Scalars['String']['output'];
  /** Value of answer, for this Answer type, it's equal to text field */
  value: Scalars['String']['output'];
};

/** The connection type for FreeTextAnswer. */
export type FreeTextAnswersConnection = AnswersConnection & {
  __typename?: 'FreeTextAnswersConnection';
  /** Aggregate of answers by value */
  aggregate?: Maybe<Array<AggregateAnswersByValue>>;
  /** A list of edges. */
  edges?: Maybe<Array<FreeTextAnswersEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FreeTextAnswersEdge = AnswersEdge & {
  __typename?: 'FreeTextAnswersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The plain text answer at the end of the edge. */
  node: FreeTextAnswer;
};

/** Free form field question */
export type FreeTextQuestionDefinition = Answerable & QuestionDefinition & {
  __typename?: 'FreeTextQuestionDefinition';
  /**
   * Answers to this question.
   * Optionaly can return only answers for given channel or survey
   */
  answers: FreeTextAnswersConnection;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<TextRule>;
  /** How many choices user needs to select */
  selectedRange?: Maybe<Scalars['RangeExp']['output']>;
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};


/** Free form field question */
export type FreeTextQuestionDefinitionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Template group attribute */
export enum GroupTemplateType {
  Uid = 'uid',
  UidAndType = 'uidAndType'
}

export type GroupTemplateValue = {
  __typename?: 'GroupTemplateValue';
  items: Array<MessageTemplate>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GroupedRespondents = {
  __typename?: 'GroupedRespondents';
  addedOn: Scalars['Date']['output'];
  creditsToReturn?: Maybe<Array<CreditsToReturn>>;
  deletedRespondents?: Maybe<Array<Scalars['ID']['output']>>;
  hasUnreadMessages?: Maybe<Array<HasUnreadMessages>>;
  hiringAdditionalData?: Maybe<Array<HiringAdditionalData>>;
  hiringSurveys?: Maybe<Array<Survey>>;
  metricQuestionsForRespondent: Array<MetricQuestionForRespondent>;
  respondents: Array<Respondent>;
  surveys: Array<Survey>;
  undeliveredInvitations?: Maybe<Array<Maybe<UndeliveredInvitations>>>;
};

export type HasUnreadMessages = {
  __typename?: 'HasUnreadMessages';
  respondentId: Scalars['ID']['output'];
  unreadMessages?: Maybe<Array<Scalars['ID']['output']>>;
};

export type HiringAdditionalData = {
  __typename?: 'HiringAdditionalData';
  isHired?: Maybe<Scalars['Boolean']['output']>;
  isRejected?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  recruiterName?: Maybe<Scalars['String']['output']>;
  respondentId: Scalars['ID']['output'];
  surveyId?: Maybe<Scalars['ID']['output']>;
};

export type HiringInfo = {
  __typename?: 'HiringInfo';
  managers: Array<HiringInfoItem>;
  positions: Array<HiringInfoItem>;
  recruiters: Array<HiringInfoItem>;
};

export type HiringInfoItem = {
  __typename?: 'HiringInfoItem';
  candidateIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type ICreateTestSurveyInput = {
  language: Scalars['String']['input'];
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
  topicId?: InputMaybe<Scalars['ID']['input']>;
};

export type ImportReportTranslationResult = {
  __typename?: 'ImportReportTranslationResult';
  inserted?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type ImportRespondentInput = {
  countryCallingCode?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  managerOfTeam: Array<Scalars['String']['input']>;
  otherEmail?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredContactType?: InputMaybe<ContactType>;
  surname: Scalars['String']['input'];
  surveyGroups?: InputMaybe<Array<NewRespondentSurveyGroupInput>>;
  surveyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  team?: InputMaybe<Scalars['String']['input']>;
};

export type IndustryCategory = {
  __typename?: 'IndustryCategory';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type Job = {
  __typename?: 'Job';
  attempts: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  lockedAt?: Maybe<Scalars['Date']['output']>;
  lockedBy?: Maybe<Scalars['String']['output']>;
  maxAttempts: Scalars['Int']['output'];
  payload?: Maybe<Scalars['String']['output']>;
  queueName?: Maybe<Scalars['String']['output']>;
  runAt?: Maybe<Scalars['Date']['output']>;
  taskIdentifier: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type JobQueue = {
  __typename?: 'JobQueue';
  lockedAt?: Maybe<Scalars['Date']['output']>;
  lockedBy?: Maybe<Scalars['String']['output']>;
  queueName: Scalars['ID']['output'];
};

export type KeyPoint = {
  __typename?: 'KeyPoint';
  answerIds: Array<Scalars['ID']['output']>;
  point: Scalars['String']['output'];
  sentiment: Sentiment;
};

export type Language = {
  __typename?: 'Language';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type LanguageFilterInput = {
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  product?: InputMaybe<Scalars['String']['input']>;
};

export type LinkToReport = {
  __typename?: 'LinkToReport';
  isOwned: Scalars['Boolean']['output'];
  link: Scalars['String']['output'];
  reportId: Scalars['ID']['output'];
  surveyGroupId: Scalars['ID']['output'];
};

export type MarketingChannel = {
  __typename?: 'MarketingChannel';
  code: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Message that was sent to channel */
export type Message = {
  anonymityLevel: AnonymityLevel;
  anonymousInReport?: Maybe<Scalars['Boolean']['output']>;
  /** When message was created */
  createdAt: Scalars['Date']['output'];
  /** Entity that sent this message, bot or respondent */
  createdBy: ChannelUserType;
  /** ID of message */
  id: Scalars['ID']['output'];
  /** Internal */
  isLast?: Maybe<Scalars['Boolean']['output']>;
  /** Channel to which message was sent */
  sentOn: Channel;
  /** Message text */
  text?: Maybe<Scalars['String']['output']>;
};

export type MessageData = {
  __typename?: 'MessageData';
  data: Array<MessageQueue>;
  totalCount: Scalars['Int']['output'];
};

export enum MessageEventType {
  Blocked = 'BLOCKED',
  BottomPixel = 'BOTTOM_PIXEL',
  Bounced = 'BOUNCED',
  Click = 'CLICK',
  Delayed = 'DELAYED',
  Delivered = 'DELIVERED',
  Error = 'ERROR',
  Injected = 'INJECTED',
  Spam = 'SPAM',
  TopPixel = 'TOP_PIXEL',
  Unsubscribed = 'UNSUBSCRIBED'
}

export type MessageFilterInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  sentAtFrom?: InputMaybe<Scalars['Date']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  undelivered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessageQueue = {
  __typename?: 'MessageQueue';
  body?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  htmlBody?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  messageStatus?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  processed?: Maybe<Scalars['Boolean']['output']>;
  recipient?: Maybe<Respondent>;
  sentAt?: Maybe<Scalars['Date']['output']>;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MessageStatus = {
  __typename?: 'MessageStatus';
  createdAt: Scalars['Date']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messageStatus?: Maybe<Scalars['String']['output']>;
  processed: Scalars['Boolean']['output'];
  respondentId: Scalars['ID']['output'];
  surveyId: Scalars['ID']['output'];
};

/** Message template that is send to respondent */
export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  /** Business unit this template belongs to (Central or South) */
  businessUnit: BusinessUnit;
  /** CTA Text for HTML emails */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** CTA URL for HTML emails */
  ctaUrl?: Maybe<Scalars['String']['output']>;
  /** Main body for HTML emails */
  description?: Maybe<Scalars['String']['output']>;
  /** Headline for HTML emails */
  headline?: Maybe<Scalars['String']['output']>;
  /** ID of message template */
  id: Scalars['ID']['output'];
  /** Language code of messageTemplate */
  languageCode: Scalars['String']['output'];
  /** Preheader for HTML emails */
  preheader?: Maybe<Scalars['String']['output']>;
  /** Message subject */
  subject?: Maybe<Scalars['String']['output']>;
  /** Message text */
  text: Scalars['String']['output'];
  /** Message type EMAIL or SMS */
  type: ContactType;
  /** String ID of message template */
  uid: Scalars['String']['output'];
};

/**  Input of Message template that is send to respondent */
export type MessageTemplateInput = {
  /** Business unit this template belongs to (Central or South) */
  businessUnit: BusinessUnit;
  /** CTA Text for HTML emails */
  ctaText?: InputMaybe<Scalars['String']['input']>;
  /** CTA URL for HTML emails */
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  /** Main body for HTML emails */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Headline for HTML emails */
  headline?: InputMaybe<Scalars['String']['input']>;
  /** Language code of messageTemplate */
  language: Scalars['String']['input'];
  /** Preheader for HTML emails */
  preheader?: InputMaybe<Scalars['String']['input']>;
  /** Message subject */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Message text */
  text: Scalars['String']['input'];
  /** Message type EMAIL or SMS */
  type?: InputMaybe<ContactType>;
  /** String ID of message template */
  uid: Scalars['String']['input'];
};

/** Rendered preview of a message template (placeholders left as-is) */
export type MessageTemplatePreview = {
  __typename?: 'MessageTemplatePreview';
  /** Plain-text body / SMS text */
  body?: Maybe<Scalars['String']['output']>;
  /** Rendered HTML email body (null for SMS or templates without HTML fields) */
  htmlBody?: Maybe<Scalars['String']['output']>;
  /** Rendered subject line */
  subject?: Maybe<Scalars['String']['output']>;
};

export enum MessageTemplateUid {
  Ending = 'ENDING',
  Reaction = 'REACTION',
  Reminder_1St = 'REMINDER_1ST',
  Reminder_2Nd = 'REMINDER_2ND',
  Reminder_3Rd = 'REMINDER_3RD',
  ReminderFromManager = 'REMINDER_FROM_MANAGER',
  Reopen = 'REOPEN',
  Welcome = 'WELCOME',
  WelcomeAnonymityMode = 'WELCOME_ANONYMITY_MODE'
}

export type MetricAnswer = {
  __typename?: 'MetricAnswer';
  topicGroupId: Scalars['ID']['output'];
  value?: Maybe<Scalars['Int']['output']>;
};

export type MetricQuestionForRespondent = {
  __typename?: 'MetricQuestionForRespondent';
  answers: Array<MetricAnswer>;
  respondentId: Scalars['ID']['output'];
};

export enum Metrics {
  ChatSatisfaction = 'chat_satisfaction',
  LockedQuestion = 'locked_question',
  OnboardingFeeling = 'onboarding_feeling'
}

/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type Mutation = {
  __typename?: 'Mutation';
  /** Approve reports for sent to managers */
  acceptReports: Scalars['Boolean']['output'];
  /** Adds respondents as survey group respondent from defined date or from now */
  addRespondentsToSurveyGroup: Scalars['Boolean']['output'];
  /** create displayFilters for select questions in widgets */
  addWidgetDisplayFilters?: Maybe<Scalars['Boolean']['output']>;
  /** AI batch translation of topic nodes using Azure OpenAI */
  aiTranslateTopicNodes: AiTranslateTopicNodesResult;
  /** approve report definition */
  approveReportDefinition: Scalars['Boolean']['output'];
  /** Approve a survey report for client visibility and emails (Internal only) */
  approveSurveyReport: Survey;
  /** assign allowed organization to signeed user */
  assignOrganization: Scalars['Boolean']['output'];
  /** Change password for user */
  changePassword: BaseUser;
  clearAiSurveySummaryCache: AiSurveySummaryCacheClearResult;
  cloneProcessStep: ProcessStep;
  cloneProcessTopicGroup?: Maybe<TopicGroup>;
  cloneTopicWithTopicGroup?: Maybe<Topic>;
  confirmEmail: Scalars['String']['output'];
  /** Creates, and opens channel on public survey */
  createChannel?: Maybe<ChannelWithStartingMessages>;
  createComment: CommentGroup;
  createCommentGroup: CommentGroup;
  /** Creates SectionStartingQuestions for topics without sections */
  createMissingTopicStructures?: Maybe<Scalars['Boolean']['output']>;
  /** Creates channel for new respondents not involved in ongoing survey */
  createNewRespondentChannels?: Maybe<Array<Maybe<Channel>>>;
  /** Create organization */
  createOrganization: Organization;
  createOrganizationSecret: OrganizationSecret;
  createProcessStep: ProcessStep;
  /** Create product version */
  createProductVersion: ProductVersion;
  /** Creates public survey */
  createPublicSurvey: Survey;
  createQuestionMetric: Scalars['Boolean']['output'];
  createQuestionTrigger: QuestionTrigger;
  createRespondent: Respondent;
  /** Create organization from sales form */
  createSalesOrganization: Organization;
  /** Creates survey */
  createSurvey: Survey;
  /** Creates survey group */
  createSurveyGroup: SurveyGroup;
  /** Create the metrics snapshot of a released survey that finished before snapshots existed (Internal only) */
  createSurveyMetricsSnapshot: SurveyMetricsSnapshot;
  /** Create and plans surveys for steps not planned for survey group */
  createSurveysForNewSteps: Scalars['Boolean']['output'];
  createSurveysForRespondents: Scalars['Boolean']['output'];
  /** Creates team */
  createTeam: Team;
  createTestOrganization?: Maybe<Scalars['Boolean']['output']>;
  /** Creates public survey */
  createTestSurvey: Scalars['String']['output'];
  createTopicGroup: TopicGroup;
  /** Create a new topic group with topic containing simple example */
  createTopicGroupFromDefault?: Maybe<TopicGroup>;
  /** Create user */
  createUser: User;
  /**
   * Delete messages from channel, starting from "fromMessageId".
   * Which must be message from respondent
   * Returns deleted messages.
   */
  deleteChannelMessages: DeleteMessagesResult;
  deleteCommentGroup: Scalars['Boolean']['output'];
  /** Delete organization logo (removes DB record, file stays in S3) */
  deleteOrganizationLogo: Scalars['Boolean']['output'];
  deleteOrganizationSecret: Scalars['Boolean']['output'];
  /** Delete the OIDC SSO configuration of an organization (SysAdmin only) */
  deleteOrganizationSsoConfig: Scalars['Boolean']['output'];
  deleteOrganizationSurvey: Scalars['Int']['output'];
  /** delete organization and anonymize all of it respondents */
  deleteOrganizationWithAnonymization: Organization;
  deleteProcessStep: Scalars['Boolean']['output'];
  /** delete product version */
  deleteProductVersion: Scalars['Int']['output'];
  deleteQuestionMetric: Scalars['Boolean']['output'];
  deleteQuestionTrigger?: Maybe<QuestionTrigger>;
  deleteRespondent: Scalars['Boolean']['output'];
  /** delete respondent and anonymize it */
  deleteRespondentWithAnonymization: Scalars['Boolean']['output'];
  /** Delete a survey attachment (removes DB record and the S3 object) */
  deleteSurveyAttachment: Scalars['Boolean']['output'];
  deleteSurveyGroup: Scalars['Boolean']['output'];
  deleteTeam: Scalars['Boolean']['output'];
  deleteTopic: Scalars['Boolean']['output'];
  deleteTopicGroup: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  disableFeature: Scalars['Boolean']['output'];
  enableFeature: Scalars['Boolean']['output'];
  generateAccessTokenForTeamio: Scalars['String']['output'];
  generateOtp: Scalars['Boolean']['output'];
  /** generate simple report definition from all questions in a topic and their translations */
  generateReportDefinition: Scalars['ID']['output'];
  /** grant access to all report recipients */
  grantReportAccessToRecipients: Scalars['Boolean']['output'];
  grantReportAccessesForSurveyGroup: Scalars['Boolean']['output'];
  importAnswers: Scalars['Boolean']['output'];
  importOrganization: Scalars['Boolean']['output'];
  importQuestions: Scalars['Boolean']['output'];
  importReportDefinition: PubReportDefinition;
  importReportTranslation: ImportReportTranslationResult;
  importTopic: Topic;
  importTranslation: Scalars['Boolean']['output'];
  /** Join two survey groups to one - target survey group */
  joinSurveyGroups: Scalars['Boolean']['output'];
  logAiSurveySummaryAbInteraction: Scalars['Boolean']['output'];
  /** Error report from browser to slack */
  logErrorReport: Scalars['Boolean']['output'];
  /** Log FE Event to EventLog */
  logFEEvent: Scalars['Boolean']['output'];
  /** Mark a translation as reviewed (sets translationStatus to null) */
  markTranslationAsReviewed: Scalars['Boolean']['output'];
  /** Opens channel. Should be called on each time respondent opens it in browser */
  openChannel?: Maybe<ChannelWithStartingMessages>;
  /** Registration - creates new user and new organization */
  registration?: Maybe<User>;
  /** delete planned cron jobs and initialize them again */
  reinitializeCronJobs: Scalars['Boolean']['output'];
  removeRespondentFromSurveyGroup: Scalars['Boolean']['output'];
  removeRespondentFromSurveyGroupWithDate: Scalars['Boolean']['output'];
  renameSurveyGroup: SurveyGroup;
  reopenSurvey: Survey;
  /** Reset password for user */
  resetPassword: Scalars['Boolean']['output'];
  saveReportDefinitionNewForSurvey: ReportDefinitionNewVersion;
  /** Connects a new report definition to the survey's topic. primary makes that connection the topic default */
  saveReportDefinitionNewForTopic: ReportDefinitionNewVersion;
  sendEmailConfirmation: Scalars['Boolean']['output'];
  sendInvitationAgain: Scalars['Boolean']['output'];
  /** Send magic link to email */
  sendMagicLink: Scalars['Boolean']['output'];
  sendNewReports: Scalars['Boolean']['output'];
  sendPreviewConversation: Scalars['Boolean']['output'];
  sendPreviewReport: Scalars['Boolean']['output'];
  /** Send a reaction to a channel or specific message inside a report context */
  sendReaction: Reaction;
  sendReportOpenMetrics: Scalars['Boolean']['output'];
  /** For scale question answers - one choice per statement with optional comment */
  sendScaleAnswer: Array<ScaleAnswer>;
  /**
   * For select,range,anonymity answers
   * value is index of one choice
   */
  sendSelectAnswer: SelectAnswer;
  /** Resend channel invitation or reminder to respondent */
  sendSurveyInvitation: MessageQueue;
  /** For Plain answers */
  sendTextAnswer: FreeTextAnswer;
  setCategoryCode: CategoryCode;
  /** Sets given channel anonymity to given level */
  setChannelAnonymity: Channel;
  setConsent: Scalars['Boolean']['output'];
  setFeatureAsDefault: Scalars['Boolean']['output'];
  setLanguageForRespondent?: Maybe<Respondent>;
  setManualDeduction: Scalars['Boolean']['output'];
  /** Creates message template with specified ID */
  setMessageTemplate: MessageTemplate;
  setPrimaryReportDefinitionNewForSurvey: ReportDefinitionNewVersion;
  /** Makes a saved version the primary report definition for the survey's topic. The version must already belong to the survey or the topic */
  setPrimaryReportDefinitionNewForTopic: ReportDefinitionNewVersion;
  /** Replaces the product / business unit availability of a public topic group (SysAdmin only) */
  setProductTopicGroups: TopicGroup;
  setRespondentNewAnswersNotifications: Scalars['Boolean']['output'];
  /** Set Survey status to archived */
  setSurveyArchived: Scalars['Boolean']['output'];
  /** Archive or dearchive all surveys connected to survey group */
  setSurveyGroupArchived: Scalars['Boolean']['output'];
  /** Include or exclude a survey's metrics snapshot from leaderboard and benchmark inputs (Internal only) */
  setSurveyMetricsSnapshotPublic: SurveyMetricsSnapshot;
  setTopicGroupDefaults: TopicGroup;
  setUserSummaryNotifications: Scalars['Boolean']['output'];
  /** Test-run an AI use case with optional unsaved draft overrides — provider/config errors land in the result, never thrown (SysAdmin only) */
  testAiGenerationConfig: AiGenerationTestResult;
  unlockGraphileJob: Scalars['Boolean']['output'];
  unlockGraphileJobQueue: Scalars['Boolean']['output'];
  unlockUser: Scalars['Boolean']['output'];
  unsetFeatureAsDefault: Scalars['Boolean']['output'];
  /** Update an AI use-case config's editable fields (SysAdmin only) */
  updateAiGenerationConfig: AiGenerationConfig;
  /** update anonymity of respondents, returning number of newly revealed respondents */
  updateAnonymity: Scalars['Int']['output'];
  updateComment: CommentGroup;
  updateCommentGroupPosition: CommentGroup;
  /** Update organization */
  updateOrganization: Organization;
  /** Updates Organization details */
  updateOrganizationConfig: OrganizationConfig;
  updateProcessStep: ProcessStep;
  /** Update product version */
  updateProductVersion: ProductVersion;
  updateReportAccessMetrics?: Maybe<Scalars['Boolean']['output']>;
  updateRespondent: Respondent;
  updateRespondentFromReport: Respondent;
  updateSurvey: Survey;
  updateTeam: Team;
  updateTopic: Topic;
  /** Update user */
  updateUser: User;
  /** Upload organization logo */
  uploadOrganizationLogo: OrganizationLogo;
  /** Upload one Pulser JSON file and enqueue the import job (SysAdmin only) */
  uploadPulserImport: PulserImport;
  /** Upload a document attachment to a survey */
  uploadSurveyAttachment: SurveyAttachment;
  /** Create or update the OIDC SSO configuration of an organization (SysAdmin only) */
  upsertOrganizationSsoConfig: OrganizationSsoConfig;
  /** Add topic group translation for topic code. Translation will be paired to topic Group via specified code automatically */
  upsertTopicGroupTranslation: TopicGroupTranslation;
  verifyPhoneNumbers: Array<TwilioLookUpResponse>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationAcceptReportsArgs = {
  reportAccepts: Array<ReportAccept>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationAddRespondentsToSurveyGroupArgs = {
  addedOn: Scalars['Date']['input'];
  respondents: Array<SurveyGroupRespondentImportInput>;
  runOngoingSteps?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationAddWidgetDisplayFiltersArgs = {
  questionDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  reportDefinitionId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationAiTranslateTopicNodesArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  nodes: Array<AiTranslateNodeInput>;
  sourceLang: Scalars['String']['input'];
  targetLang: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationApproveReportDefinitionArgs = {
  approved: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationApproveSurveyReportArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationAssignOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationChangePasswordArgs = {
  consent?: InputMaybe<Scalars['Boolean']['input']>;
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  newPassword: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationClearAiSurveySummaryCacheArgs = {
  accessToken: Scalars['String']['input'];
  hash: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCloneProcessStepArgs = {
  processStepId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCloneProcessTopicGroupArgs = {
  shallowClone?: InputMaybe<Scalars['Boolean']['input']>;
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCloneTopicWithTopicGroupArgs = {
  topicId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationConfirmEmailArgs = {
  deviceToken: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateChannelArgs = {
  accessKey: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateCommentGroupArgs = {
  input: CreateCommentGroupInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateNewRespondentChannelsArgs = {
  respondentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
  orgAdmin?: InputMaybe<RespondentInput>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateOrganizationSecretArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateProcessStepArgs = {
  input: CreateProcessStepInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateProductVersionArgs = {
  input: CreateProductVersionInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreatePublicSurveyArgs = {
  input: CreatePublicSurveyInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateQuestionMetricArgs = {
  identifier: Metrics;
  index: Scalars['Int']['input'];
  topicGroupId: Scalars['Int']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateQuestionTriggerArgs = {
  input: QuestionTriggerInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateRespondentArgs = {
  input: RespondentInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateSalesOrganizationArgs = {
  input: CreateSalesOrganizationInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateSurveyArgs = {
  input: CreateSurveyInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateSurveyGroupArgs = {
  input: CreateSurveyGroupInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateSurveyMetricsSnapshotArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateSurveysForNewStepsArgs = {
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateSurveysForRespondentsArgs = {
  addedOn: Scalars['Date']['input'];
  respondentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateTeamArgs = {
  organizationId: Scalars['ID']['input'];
  respondentId?: InputMaybe<Scalars['ID']['input']>;
  supervisorTeamId?: InputMaybe<Scalars['ID']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateTestOrganizationArgs = {
  name: Scalars['String']['input'];
  numberOfRespondents: Scalars['Int']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateTestSurveyArgs = {
  input: ICreateTestSurveyInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateTopicGroupArgs = {
  input: CreateTopicGroupInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateTopicGroupFromDefaultArgs = {
  description: Scalars['String']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  typeCode?: InputMaybe<TopicGroupTypeCode>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteChannelMessagesArgs = {
  channelId: Scalars['ID']['input'];
  fromMessageId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteCommentGroupArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteOrganizationLogoArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteOrganizationSecretArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteOrganizationSsoConfigArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteOrganizationSurveyArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteOrganizationWithAnonymizationArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteProcessStepArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteProductVersionArgs = {
  productId: Scalars['ID']['input'];
  rescheduleOrganization?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteQuestionMetricArgs = {
  identifier?: InputMaybe<Metrics>;
  index: Scalars['Int']['input'];
  topicGroupId: Scalars['Int']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteQuestionTriggerArgs = {
  index: Scalars['Int']['input'];
  topicGroupId: Scalars['ID']['input'];
  value: Scalars['Int']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteRespondentArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  respondentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteRespondentWithAnonymizationArgs = {
  respondentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteSurveyAttachmentArgs = {
  attachmentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteSurveyGroupArgs = {
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteTeamArgs = {
  teamId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteTopicArgs = {
  topicId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteTopicGroupArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteUserArgs = {
  email: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDisableFeatureArgs = {
  feature: Features;
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationEnableFeatureArgs = {
  feature: Features;
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationGenerateAccessTokenForTeamioArgs = {
  companyG2Id: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationGenerateOtpArgs = {
  username: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationGenerateReportDefinitionArgs = {
  fromScratch?: InputMaybe<Scalars['Boolean']['input']>;
  topicId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationGrantReportAccessToRecipientsArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationGrantReportAccessesForSurveyGroupArgs = {
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationImportAnswersArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationImportOrganizationArgs = {
  orgId: Scalars['ID']['input'];
  respondents: Array<ImportRespondentInput>;
  teams: Array<TeamInput>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationImportQuestionsArgs = {
  file: Scalars['Upload']['input'];
  topicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationImportReportDefinitionArgs = {
  file: Scalars['Upload']['input'];
  topicId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationImportReportTranslationArgs = {
  file: Scalars['Upload']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationImportTopicArgs = {
  isTesting?: InputMaybe<Scalars['Boolean']['input']>;
  questionOrderManuallyModified?: InputMaybe<Scalars['Boolean']['input']>;
  questionOrderModified?: InputMaybe<Scalars['Boolean']['input']>;
  questions: Array<QuestionDefinitionInput>;
  topic: TopicInput;
  translateViaAi?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationImportTranslationArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  topicId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationJoinSurveyGroupsArgs = {
  sourceSurveyGroupId: Scalars['ID']['input'];
  targetSurveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationLogAiSurveySummaryAbInteractionArgs = {
  input: AiSurveySummaryAbInteractionInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationLogErrorReportArgs = {
  errorReport: ErrorReportInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationLogFeEventArgs = {
  eventType: FeEventType;
  payload: FeEventPayload;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationMarkTranslationAsReviewedArgs = {
  languageCode: Scalars['String']['input'];
  questionDefinitionId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationOpenChannelArgs = {
  channelId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationRegistrationArgs = {
  organizationInput: RegistrationOrganizationInput;
  password: Scalars['String']['input'];
  userInput: UserInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationRemoveRespondentFromSurveyGroupArgs = {
  addedOn: Scalars['Date']['input'];
  respondentId: Scalars['ID']['input'];
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationRemoveRespondentFromSurveyGroupWithDateArgs = {
  accessToken: Scalars['String']['input'];
  dateFrom: Scalars['Date']['input'];
  respondentId: Scalars['ID']['input'];
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationRenameSurveyGroupArgs = {
  name: Scalars['String']['input'];
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationReopenSurveyArgs = {
  input: ReopenSurveyInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationResetPasswordArgs = {
  origin: Origin;
  username: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSaveReportDefinitionNewForSurveyArgs = {
  definition: Scalars['JSON']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSaveReportDefinitionNewForTopicArgs = {
  definition: Scalars['JSON']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendEmailConfirmationArgs = {
  email: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendInvitationAgainArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  respondentId: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
  templateUid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendMagicLinkArgs = {
  redirect?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendNewReportsArgs = {
  respondentId: Scalars['ID']['input'];
  surveyIds: Array<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendPreviewConversationArgs = {
  contactType: ContactType;
  contactValue: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  topicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendPreviewReportArgs = {
  email: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
  topicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendReactionArgs = {
  accessToken: Scalars['String']['input'];
  channelId: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendReportOpenMetricsArgs = {
  channelIds: Array<Scalars['ID']['input']>;
  orgAdmin: Scalars['Boolean']['input'];
  reportAccessKey: Scalars['String']['input'];
  reportView: ReportOpenMetricsView;
  sysAdmin: Scalars['Boolean']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendScaleAnswerArgs = {
  answers: Array<ScaleStatementAnswerInput>;
  channelId: Scalars['ID']['input'];
  previousQuestionId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendSelectAnswerArgs = {
  channelId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  previousQuestionId: Scalars['ID']['input'];
  values: Array<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendSurveyInvitationArgs = {
  messageType?: InputMaybe<MessageTemplateUid>;
  respondentEmail: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendTextAnswerArgs = {
  channelId: Scalars['ID']['input'];
  previousQuestionId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetCategoryCodeArgs = {
  categoryCode: Scalars['String']['input'];
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetChannelAnonymityArgs = {
  channelId: Scalars['ID']['input'];
  level: AnonymityLevel;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetConsentArgs = {
  consent: Scalars['Boolean']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetFeatureAsDefaultArgs = {
  feature: Features;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetLanguageForRespondentArgs = {
  channelId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetManualDeductionArgs = {
  creditsUsed: Scalars['Float']['input'];
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetMessageTemplateArgs = {
  messageTemplate?: InputMaybe<MessageTemplateInput>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetPrimaryReportDefinitionNewForSurveyArgs = {
  id: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetPrimaryReportDefinitionNewForTopicArgs = {
  id: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetProductTopicGroupsArgs = {
  items: Array<ProductTopicGroupInput>;
  topicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetRespondentNewAnswersNotificationsArgs = {
  auth?: InputMaybe<OnePlaceAuthInput>;
  notificationLevel: NotificationLevel;
  respondentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetSurveyArchivedArgs = {
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetSurveyGroupArchivedArgs = {
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetSurveyMetricsSnapshotPublicArgs = {
  public: Scalars['Boolean']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetTopicGroupDefaultsArgs = {
  input: SetTopicGroupDefaultsInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetUserSummaryNotificationsArgs = {
  auth?: InputMaybe<OnePlaceAuthInput>;
  on: Scalars['Boolean']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationTestAiGenerationConfigArgs = {
  input: AiGenerationConfigTestInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUnlockGraphileJobArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUnlockGraphileJobQueueArgs = {
  queueName: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUnlockUserArgs = {
  username: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUnsetFeatureAsDefaultArgs = {
  feature: Features;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateAiGenerationConfigArgs = {
  input: AiGenerationConfigInput;
  useCase: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateAnonymityArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateCommentArgs = {
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateCommentGroupPositionArgs = {
  id: Scalars['ID']['input'];
  positionX: Scalars['Int']['input'];
  positionY: Scalars['Int']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateOrganizationConfigArgs = {
  input: UpdateOrganizationConfigInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateProcessStepArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProcessStepInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateProductVersionArgs = {
  input: UpdateProductVersionInput;
  productId: Scalars['ID']['input'];
  rescheduleOrganization?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateReportAccessMetricsArgs = {
  bottomSeen?: InputMaybe<Scalars['Boolean']['input']>;
  questionsSeen?: InputMaybe<Scalars['Int']['input']>;
  questionsTotal?: InputMaybe<Scalars['Int']['input']>;
  reportAccessKey: Scalars['String']['input'];
  timeSpentInSec?: InputMaybe<Scalars['Int']['input']>;
  topSeen?: InputMaybe<Scalars['Boolean']['input']>;
  topicGroupId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateRespondentArgs = {
  input: UpdateRespondentInput;
  respondentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateRespondentFromReportArgs = {
  accessToken: Scalars['String']['input'];
  input: UpdateRespondentFromReportInput;
  respondentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateSurveyArgs = {
  input: UpdateSurveyInput;
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
  teamId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateTopicArgs = {
  input: UpdateTopicInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
  username: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUploadOrganizationLogoArgs = {
  file: Scalars['Upload']['input'];
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUploadPulserImportArgs = {
  file: Scalars['Upload']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUploadSurveyAttachmentArgs = {
  file: Scalars['Upload']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpsertOrganizationSsoConfigArgs = {
  input: OrganizationSsoConfigInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpsertTopicGroupTranslationArgs = {
  input: UpsertTopicGroupTranslationInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationVerifyPhoneNumbersArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumbers: Array<Scalars['String']['input']>;
};

export type NewReport = {
  __typename?: 'NewReport';
  anonymityEnabled: Scalars['Boolean']['output'];
  anonymityForced: Scalars['Boolean']['output'];
  /** Survey settings regarding anonymity (chosen for this survey; fallback to topic group defaults) */
  anonymitySettings?: Maybe<AnonymitySettings>;
  id: Scalars['ID']['output'];
  metadata: PubMetadata;
  /** Stored AI themes, loaded on demand and restricted to messages available in this report */
  questionLabels: Array<QuestionLabel>;
  questions: Array<PubQuestion>;
  reportDefinition?: Maybe<NewReportDefinition>;
  reportRoots: Array<Scalars['ID']['output']>;
  respondents: Array<PubRespondent>;
  responses: Array<PubResponse>;
  surveyId: Scalars['ID']['output'];
  surveys: Array<Survey>;
  teams: Array<PubTeams>;
  topicGroup: TopicGroup;
  totalRespondents: Scalars['Int']['output'];
};

export type NewReportDefinition = {
  __typename?: 'NewReportDefinition';
  definition: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
};

export type NewRespondentSurveyGroupInput = {
  /** Added on date */
  addedOn: Scalars['Date']['input'];
  /** Recruiter ID from external system */
  recruiterId?: InputMaybe<Scalars['String']['input']>;
  /** Recruiter name from external system */
  recruiterName?: InputMaybe<Scalars['String']['input']>;
  /** Recruitment ID from external system */
  recruitmentId?: InputMaybe<Scalars['String']['input']>;
  /** Recruitment name from external system */
  recruitmentInternalName?: InputMaybe<Scalars['String']['input']>;
  /** Recruitment name from external system */
  recruitmentName?: InputMaybe<Scalars['String']['input']>;
  runOngoingSteps?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Survey group ID */
  surveyGroupId: Scalars['ID']['input'];
};

export enum NotificationLevel {
  AlertsOnly = 'alerts_only',
  All = 'all',
  Never = 'never'
}

/** Notstarted survey reasons */
export enum NotstartedSurveyReason {
  IsInFuture = 'IS_IN_FUTURE',
  IsInPast = 'IS_IN_PAST',
  LicenceExceeded = 'LICENCE_EXCEEDED',
  NotCompletedTranslations = 'NOT_COMPLETED_TRANSLATIONS',
  NoRespondents = 'NO_RESPONDENTS',
  NoRespondentsInSg = 'NO_RESPONDENTS_IN_SG',
  NoTopic = 'NO_TOPIC',
  OrganizationNotActive = 'ORGANIZATION_NOT_ACTIVE',
  TgNotAllowed = 'TG_NOT_ALLOWED'
}

export type OnePlaceAuthInput = {
  channelSlug?: InputMaybe<Scalars['String']['input']>;
  reportAccessToken?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Organization that orders surveys */
export type Organization = {
  __typename?: 'Organization';
  /** toggle notifications for channels with alerting answers */
  activeOnboadings: Array<SurveyGroup>;
  activeProcessSurveys: Array<SurveyGroup>;
  /** All active respondents that belong to organization teams */
  activeRespondents: Array<Respondent>;
  /** Number of respondents applied in current 30-days period */
  activeRespondentsInCurrentPeriodCount?: Maybe<Scalars['Int']['output']>;
  /** All respondents that belong to organization teams */
  allRespondents: Array<Respondent>;
  /** Topics that are allowed for organization. Instead of topicGroup id used latest valid */
  allowedTopics: Array<Topic>;
  /** Indicate if before first survey card was checked */
  beforeFirstSurvey: Scalars['Boolean']['output'];
  /** Business unit of the organization */
  businessUnit: BusinessUnit;
  /** Source channel */
  channel?: Maybe<Scalars['String']['output']>;
  /** CIN (IČO) for integration with other systems */
  companyId?: Maybe<Scalars['String']['output']>;
  /** Organization config */
  config?: Maybe<OrganizationConfig>;
  /** Country */
  country?: Maybe<Scalars['String']['output']>;
  /** Time stamp when organization was created */
  createdAt: Scalars['Date']['output'];
  currentSurveys: Array<Survey>;
  /** Number of enabled respondents in organization */
  enabledRespondentsCount: Scalars['Int']['output'];
  /** External ID for integration with other systems (Teamio etc.) */
  externalUid?: Maybe<Scalars['String']['output']>;
  /** List of features allowed for organization */
  featureNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** E-mail contact to organization garant */
  garantEmail?: Maybe<Scalars['String']['output']>;
  /** ID of organizations group */
  groupOrganizationId?: Maybe<Scalars['ID']['output']>;
  /** Org has survey groups that are not onboardings */
  hasProcessSurveys: Scalars['Boolean']['output'];
  /** ID of organization */
  id: Scalars['ID']['output'];
  /** Industry */
  industry?: Maybe<Scalars['String']['output']>;
  /** Languages of organization */
  languages: Array<Language>;
  /** Date of last failed API update */
  lastFailedApiUpdate?: Maybe<Scalars['Date']['output']>;
  /** Date of last successful API update */
  lastSuccessfulApiUpdate?: Maybe<Scalars['Date']['output']>;
  /** e-mail contact to organization garant */
  limitExceededEmailSent?: Maybe<Scalars['Boolean']['output']>;
  /** Organization logo */
  logo?: Maybe<OrganizationLogo>;
  marketingChannel?: Maybe<MarketingChannel>;
  /** Custom field for analytics */
  microlearningAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** Minimal team size to generate report */
  minimalTeamSizeToGenerateReport?: Maybe<Scalars['Int']['output']>;
  /** Minimal team size to keep anonymity */
  minimalTeamSizeToKeepAnonymity?: Maybe<Scalars['Int']['output']>;
  /** Short identification for humans */
  name: Scalars['String']['output'];
  /** Number of employees */
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  /** List of all ORG admins in organization */
  organizationAdmins: Array<Respondent>;
  /** Version of organisation */
  organizationVersion: Scalars['Int']['output'];
  /** user who created the organization */
  originator?: Maybe<User>;
  /** Primary language of organization */
  primaryLanguageCode: Scalars['String']['output'];
  /** Primary language id of organization */
  primaryLanguageId: Scalars['Int']['output'];
  processNotificationsDefault: NotificationLevel;
  processNotificationsLocked: Scalars['Boolean']['output'];
  /** Active version of product */
  productVersion?: Maybe<ProductVersion>;
  /** Complete history of product */
  productVersionHistory?: Maybe<Array<ProductVersion>>;
  /** Reminder 1 template */
  reminder1Template?: Maybe<Scalars['String']['output']>;
  /** Reminder 2 template */
  reminder2Template?: Maybe<Scalars['String']['output']>;
  /** Reminder 3 template */
  reminder3Template?: Maybe<Scalars['String']['output']>;
  /** Number of respondents in organization */
  respondentsCount: Scalars['Int']['output'];
  /** Organization status */
  status: OrganizationStatus;
  /** ID of organizations group */
  surveyGroups: Array<SurveyGroup>;
  /** All surveys for organization */
  surveys: Array<Survey>;
  /** Count of surveys created for this organization */
  surveysCount?: Maybe<Scalars['Int']['output']>;
  /** Organization system name */
  systemName: Scalars['String']['output'];
  /** Teams that this organization have */
  teams: Array<Team>;
  testOrganization?: Maybe<Scalars['Boolean']['output']>;
  /** all users connected to Organization */
  users?: Maybe<Array<User>>;
  /** Welcome template */
  welcomeTemplate?: Maybe<Scalars['String']['output']>;
};

/** Organization configuration */
export type OrganizationConfig = {
  __typename?: 'OrganizationConfig';
  /** Default country calling code */
  countryCallingCode: Scalars['String']['output'];
  /** Organization country code. ISO 3166-1 alpha-2 */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Organization that belongs organization config */
  organization: Organization;
  /** Maximum of surveys that can be run in trial */
  testSurveys: Scalars['Int']['output'];
  /** Timezone */
  timezone: Scalars['String']['output'];
};

export type OrganizationFilterInput = {
  businessUnit?: InputMaybe<BusinessUnit>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrganizationStatus>;
};

export type OrganizationLevel = {
  __typename?: 'OrganizationLevel';
  level: Scalars['String']['output'];
  respondents?: Maybe<Array<Maybe<ReportRespondent>>>;
};

/** Organization logo */
export type OrganizationLogo = {
  __typename?: 'OrganizationLogo';
  /** Upload timestamp */
  createdAt: Scalars['Date']['output'];
  /** ID of logo record */
  id: Scalars['ID']['output'];
  /** Original file name */
  originalName: Scalars['String']['output'];
  /** S3 object key */
  s3Key: Scalars['String']['output'];
  /** Public URL via CDN */
  url: Scalars['String']['output'];
};

export type OrganizationSecret = {
  __typename?: 'OrganizationSecret';
  clientId: Scalars['ID']['output'];
  clientSecret: Scalars['String']['output'];
};

/** Per-organization OIDC SSO configuration. The client secret is write-only and never exposed. */
export type OrganizationSsoConfig = {
  __typename?: 'OrganizationSsoConfig';
  /** comma-separated email domains that may use this SSO config, e.g. 'acme.com, acme.eu'. */
  allowedEmailDomains: Scalars['String']['output'];
  /** optional override when the provider does not support discovery */
  authorizationEndpoint?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  hasClientSecret: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** OIDC issuer URL used for discovery, e.g. https://login.microsoftonline.com/<tenantId>/v2.0 */
  issuer: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  /** space separated OIDC scopes, e.g. 'openid profile email offline_access' */
  scopes: Scalars['String']['output'];
  /** optional override when the provider does not support discovery */
  tokenEndpoint?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  /** optional override when the provider does not support discovery */
  userinfoEndpoint?: Maybe<Scalars['String']['output']>;
};

export type OrganizationSsoConfigInput = {
  /** comma-separated email domains that may use this SSO config, e.g. 'acme.com, acme.eu'. */
  allowedEmailDomains?: InputMaybe<Scalars['String']['input']>;
  authorizationEndpoint?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  /** omit or pass null to keep the existing secret on update; required when creating */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  issuer: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  scopes?: InputMaybe<Scalars['String']['input']>;
  tokenEndpoint?: InputMaybe<Scalars['String']['input']>;
  userinfoEndpoint?: InputMaybe<Scalars['String']['input']>;
};

export enum OrganizationStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE'
}

export type OrganizationWithLinksToReport = {
  __typename?: 'OrganizationWithLinksToReport';
  linksToReport: Array<LinkToReport>;
  organizations: Array<Organization>;
};

export type OrganizationsData = {
  __typename?: 'OrganizationsData';
  data: Array<Organization>;
  totalCount: Scalars['Int']['output'];
};

export enum Origin {
  Dashboard = 'DASHBOARD',
  SelfCare = 'SELF_CARE',
  Talk = 'TALK'
}

/** Unspecified message, with no special meaning */
export type OtherMessage = Message & {
  __typename?: 'OtherMessage';
  anonymityLevel: AnonymityLevel;
  anonymousInReport?: Maybe<Scalars['Boolean']['output']>;
  /** When message was created */
  createdAt: Scalars['Date']['output'];
  /** Entity that sent this message, bot or respondent */
  createdBy: ChannelUserType;
  /** ID of message */
  id: Scalars['ID']['output'];
  isLast?: Maybe<Scalars['Boolean']['output']>;
  /** Channel to which message was sent */
  sentOn: Channel;
  /** Message text */
  text?: Maybe<Scalars['String']['output']>;
};

export type OverviewUser = {
  __typename?: 'OverviewUser';
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  intercomHash: Scalars['String']['output'];
  summaryNotifications: Scalars['Boolean']['output'];
  surname: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

/** Pagination info as per relay spec */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type PayloadCheck = {
  __typename?: 'PayloadCheck';
  fieldPath: Scalars['String']['output'];
  regex: Scalars['String']['output'];
};

export type PayloadCheckInput = {
  fieldPath: Scalars['String']['input'];
  regex: Scalars['String']['input'];
};

export type PersonMultiselectQuestionDefinition = Answerable & QuestionDefinition & {
  __typename?: 'PersonMultiselectQuestionDefinition';
  /**
   * Answers to this question.
   * Optionaly can return only answers for given channel or survey
   */
  answers: SelectAnswersConnection;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** Choices of possible avatars which question can set */
  organizationRespondents: Array<Respondent>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<RangeRule>;
  /** How many choices user needs to select */
  selectedRange: Scalars['RangeExp']['output'];
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};


export type PersonMultiselectQuestionDefinitionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  countryCallingCode: Scalars['String']['output'];
  nationalNumber: Scalars['String']['output'];
};

export type PreviewConversationUsage = {
  __typename?: 'PreviewConversationUsage';
  contact: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  language: Scalars['String']['output'];
  openedAt?: Maybe<Scalars['Date']['output']>;
  organizationName: Scalars['String']['output'];
  topicGroup: PublicTopicGroup;
};

export type PreviousEventsCheck = {
  __typename?: 'PreviousEventsCheck';
  check: PayloadCheck;
  type: Scalars['String']['output'];
};

export type PreviousEventsCheckInput = {
  check: PayloadCheckInput;
  type: Scalars['String']['input'];
};

export type ProcessReportComparsion = {
  __typename?: 'ProcessReportComparsion';
  id: Scalars['ID']['output'];
  stepStatistics: Array<StepStatistics>;
};

export type ProcessReportInfoSub = {
  __typename?: 'ProcessReportInfoSub';
  addedOnFrom?: Maybe<Scalars['Date']['output']>;
  addedOnTo?: Maybe<Scalars['Date']['output']>;
  filteredRespondents?: Maybe<Scalars['Int']['output']>;
  /** Fourth stage */
  groupedRespondents?: Maybe<SurveyGroupRespondentsResult>;
  hiringInfo?: Maybe<HiringInfo>;
  /** First stage */
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  metadata: PubMetadata;
  reportRoots: Array<Scalars['ID']['output']>;
  /** Third stage */
  rootTeamsStatistics?: Maybe<Array<RootTeamsStatistics>>;
  /** Second stage */
  surveyGroup?: Maybe<SurveyGroup>;
  teams?: Maybe<Array<PubTeams>>;
  totalRespondents?: Maybe<Scalars['Int']['output']>;
  widgets?: Maybe<ProcessWidgets>;
};

export type ProcessReportRespondentDetail = {
  __typename?: 'ProcessReportRespondentDetail';
  groupedRespondents: Array<GroupedRespondents>;
  hiringAdditionalData?: Maybe<Array<HiringAdditionalData>>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  keyPoints?: Maybe<Array<KeyPoint>>;
  metadata: PubMetadata;
  questions: Array<PubQuestion>;
  reportRoots: Array<Scalars['ID']['output']>;
  respondents: Array<PubRespondent>;
  responses: Array<PubResponse>;
  surveyGroup?: Maybe<SurveyGroup>;
  teams: Array<PubTeams>;
  totalRespondents: Scalars['Int']['output'];
};

/** Survey status */
export enum ProcessStatus {
  Anonymized = 'ANONYMIZED',
  Archived = 'ARCHIVED',
  /** Last survey in the sequence step is not active, ends_at date is in past */
  Completed = 'COMPLETED',
  /** All surveys are in state PREPARED or NOTSTARTED */
  Notstarted = 'NOTSTARTED',
  /** Some survey in the sequence step is active, send_at date is in past and ends_at date is in future */
  Ongoing = 'ONGOING',
  /** First survey in the sequence step is not active, send_at date is in future */
  Prepared = 'PREPARED'
}

export type ProcessStep = {
  __typename?: 'ProcessStep';
  candidateLanguage?: Maybe<Language>;
  copyTg?: Maybe<Scalars['Boolean']['output']>;
  customFieldsCheck?: Maybe<Array<CustomFieldsCheck>>;
  endOffsetMins?: Maybe<Scalars['Int']['output']>;
  eventDateField?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  payloadCheck?: Maybe<Array<PayloadCheck>>;
  previousEventsCheck?: Maybe<Array<PreviousEventsCheck>>;
  processTopicGroup: TopicGroup;
  reminders: Array<ProcessStepReminder>;
  startOffsetMins?: Maybe<Scalars['Int']['output']>;
  stepTopicGroup: TopicGroup;
  triggeredOn?: Maybe<Scalars['String']['output']>;
  useEmailFromNote?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessStepReminder = {
  __typename?: 'ProcessStepReminder';
  id: Scalars['ID']['output'];
  processStepId: Scalars['ID']['output'];
  reminderOffsetMins: Scalars['Int']['output'];
};

export type ProcessWidgets = {
  __typename?: 'ProcessWidgets';
  anonymityRate: Widget;
  finishedRate: Widget;
  responseRate: Widget;
  withoutProblems: Widget;
};

export type Product = {
  __typename?: 'Product';
  code: Scalars['String']['output'];
};

export type ProductHistorySurveyType = {
  __typename?: 'ProductHistorySurveyType';
  id: Scalars['ID']['output'];
  numOfEmployees?: Maybe<Scalars['Int']['output']>;
  numOfPositions?: Maybe<Scalars['Int']['output']>;
  numOfSurveys?: Maybe<Scalars['Int']['output']>;
  productHistoryId: Scalars['ID']['output'];
  type: ProductVersionSurveyType;
};

export type ProductHistorySurveyTypeInput = {
  numOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  numOfPositions?: InputMaybe<Scalars['Int']['input']>;
  numOfSurveys?: InputMaybe<Scalars['Int']['input']>;
  type: ProductVersionSurveyType;
};

/** Row of product_topic_group: the topic group is visible to organizations with this product and business unit */
export type ProductTopicGroup = {
  __typename?: 'ProductTopicGroup';
  businessUnit: BusinessUnit;
  /** Hidden from the Admin topic list, already scheduled surveys still start */
  deprecated: Scalars['Boolean']['output'];
  product: Scalars['String']['output'];
};

export type ProductTopicGroupInput = {
  businessUnit: BusinessUnit;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  product: Scalars['String']['input'];
};

export type ProductVersion = {
  __typename?: 'ProductVersion';
  activePeriodEnd?: Maybe<Scalars['Date']['output']>;
  boughtCredits?: Maybe<Scalars['Float']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  licenceCount?: Maybe<Scalars['Int']['output']>;
  organizationId: Scalars['ID']['output'];
  product: Scalars['String']['output'];
  productHistorySurveyTypes: Array<Maybe<ProductHistorySurveyType>>;
  transferredCredits?: Maybe<Scalars['Float']['output']>;
  trial?: Maybe<Scalars['Boolean']['output']>;
  /** Number of used credits */
  usedCredits?: Maybe<Scalars['Float']['output']>;
  validFrom: Scalars['Date']['output'];
  validTo: Scalars['Date']['output'];
};

export enum ProductVersionSurveyType {
  Exit = 'EXIT',
  Fms = 'FMS',
  Hiring = 'HIRING',
  Onboarding = 'ONBOARDING',
  OneTime = 'ONE_TIME',
  Pulser = 'PULSER',
  Seduo = 'SEDUO',
  Sequential = 'SEQUENTIAL'
}

export type PubDisplayFilter = {
  __typename?: 'PubDisplayFilter';
  operator: Scalars['String']['output'];
  questionDefinitionIndex: Scalars['ID']['output'];
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type PubMessage = {
  __typename?: 'PubMessage';
  anonymous: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  hasAlert: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  originalAnonymous: Scalars['Boolean']['output'];
  questionDefinitionIndex: Scalars['ID']['output'];
  relevance: Scalars['Float']['output'];
  statementIndex?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PubMetadata = {
  __typename?: 'PubMetadata';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  adminEmails?: Maybe<Array<Scalars['String']['output']>>;
  language?: Maybe<Language>;
  organization: Organization;
  organizationDepth: Scalars['Int']['output'];
  productVersion?: Maybe<ProductVersion>;
  respondent?: Maybe<Respondent>;
  status: SurveyStatus;
  surveyEnd?: Maybe<Scalars['Date']['output']>;
  surveyStart?: Maybe<Scalars['Date']['output']>;
  topicGroupId?: Maybe<Scalars['ID']['output']>;
  user?: Maybe<User>;
};

export type PubQuestion = {
  __typename?: 'PubQuestion';
  answersLocal?: Maybe<Array<Scalars['String']['output']>>;
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  index: Scalars['ID']['output'];
  isRankingScale?: Maybe<Scalars['Boolean']['output']>;
  metrics: Array<Maybe<Scalars['String']['output']>>;
  reportIndex?: Maybe<Scalars['ID']['output']>;
  reportOrder?: Maybe<Scalars['Int']['output']>;
  selectedRange?: Maybe<Scalars['String']['output']>;
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  statementsLocal?: Maybe<Array<Scalars['String']['output']>>;
  text: Scalars['String']['output'];
  topicGroupId?: Maybe<Scalars['ID']['output']>;
  type: QuestionType;
};

export type PubReport = {
  __typename?: 'PubReport';
  addedOnFrom?: Maybe<Scalars['Date']['output']>;
  addedOnTo?: Maybe<Scalars['Date']['output']>;
  additionalRespondentData?: Maybe<Array<AdditionalRespondentDataFromTeamio>>;
  anonymityEnabled: Scalars['Boolean']['output'];
  anonymityForced: Scalars['Boolean']['output'];
  /** Survey settings regarding anonymity (chosen for this survey; fallback to topic group defaults) */
  anonymitySettings?: Maybe<AnonymitySettings>;
  /** First survey in the report (for single surveys) or first survey in the sequence */
  firstSurvey?: Maybe<Survey>;
  hiringAdditionalData?: Maybe<Array<HiringAdditionalData>>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  keywordsVersion: Scalars['Int']['output'];
  metadata?: Maybe<PubMetadata>;
  questionLabels?: Maybe<Array<QuestionLabel>>;
  questions?: Maybe<Array<PubQuestion>>;
  reportDefinition?: Maybe<PubReportDefinition>;
  reportRoots?: Maybe<Array<Scalars['ID']['output']>>;
  respondents?: Maybe<Array<PubRespondent>>;
  responses?: Maybe<Array<PubResponse>>;
  sequenceFrom?: Maybe<Scalars['Date']['output']>;
  sequenceTo?: Maybe<Scalars['Date']['output']>;
  source?: Maybe<Array<PubSource>>;
  surveyGroup?: Maybe<SurveyGroup>;
  surveyKeywordsGenerated: Scalars['Boolean']['output'];
  teams?: Maybe<Array<PubTeams>>;
  /** Total respondents including disqualified (disabled with disabledReason) */
  totalRespondents?: Maybe<Scalars['Int']['output']>;
};

export type PubReportDefinition = {
  __typename?: 'PubReportDefinition';
  aboutLocal?: Maybe<Scalars['String']['output']>;
  approved: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  intro?: Maybe<Array<PubWidget>>;
  sections?: Maybe<Array<PubSection>>;
  titleLocal?: Maybe<Scalars['String']['output']>;
};

export type PubRespondent = {
  __typename?: 'PubRespondent';
  addedOn?: Maybe<Scalars['Date']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  surname: Scalars['String']['output'];
};

export type PubResponse = {
  __typename?: 'PubResponse';
  additionallyAnonymized: Scalars['Boolean']['output'];
  anonymous: Scalars['Boolean']['output'];
  endsAt?: Maybe<Scalars['Date']['output']>;
  finished: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  messages?: Maybe<Array<PubMessage>>;
  originalAnonymous: Scalars['Boolean']['output'];
  reactions?: Maybe<Array<Reaction>>;
  respondentId: Scalars['ID']['output'];
  seqDate?: Maybe<Scalars['Date']['output']>;
  surveyId: Scalars['ID']['output'];
  topicGroupId: Scalars['ID']['output'];
};

export type PubSection = {
  __typename?: 'PubSection';
  descriptionLocal?: Maybe<Scalars['String']['output']>;
  displayFilters?: Maybe<Array<PubDisplayFilter>>;
  heading: Scalars['String']['output'];
  headingLocal: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  titleFilters?: Maybe<Array<PubDisplayFilter>>;
  type: ReportSectionType;
  widgets?: Maybe<Array<PubWidget>>;
};

export type PubSource = {
  __typename?: 'PubSource';
  respondentId: Scalars['ID']['output'];
  sourceId: Scalars['String']['output'];
};

export type PubTeams = {
  __typename?: 'PubTeams';
  directMembers?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  memberTeams?: Maybe<Array<Scalars['ID']['output']>>;
  teamLeader?: Maybe<Scalars['ID']['output']>;
  teamName: Scalars['String']['output'];
};

export type PubWidget = {
  __typename?: 'PubWidget';
  additionallyAnonymized?: Maybe<Scalars['Boolean']['output']>;
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  denominator?: Maybe<Scalars['Int']['output']>;
  descriptionLocal?: Maybe<Scalars['String']['output']>;
  displayFilters?: Maybe<Array<PubDisplayFilter>>;
  headingLocal: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  numerator?: Maybe<Scalars['Int']['output']>;
  questionDefinitionIndex?: Maybe<Scalars['ID']['output']>;
  titleFilters?: Maybe<Array<PubDisplayFilter>>;
  type: Scalars['String']['output'];
  values?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type PublicChannel = {
  __typename?: 'PublicChannel';
  /** Date of FINISHED event if exists */
  finishedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isFinishedByRespondent: Scalars['Boolean']['output'];
  lastRemindedAt?: Maybe<Scalars['Date']['output']>;
  maxAnonymousHighlightedLevel: Scalars['Int']['output'];
  respondentId: Scalars['ID']['output'];
  withAnswer: Scalars['Boolean']['output'];
};

export type PublicRespondent = {
  __typename?: 'PublicRespondent';
  channels?: Maybe<Array<Channel>>;
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isLeader: Scalars['Boolean']['output'];
  isReportRecipient: Scalars['Boolean']['output'];
  newAnswersNotifications?: Maybe<NotificationLevel>;
  organization: Organization;
  organizationRole: UserOrgRole;
  reports?: Maybe<Array<ReportAccess>>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type PublicTopicGroup = {
  __typename?: 'PublicTopicGroup';
  /** Translation of TopicGroupCategory */
  categoryCode?: Maybe<Scalars['String']['output']>;
  /** Translation of TopicGroupCategory */
  categoryName?: Maybe<Scalars['String']['output']>;
  /** Translation of TopicGroup */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Translation of TopicGroup */
  name: Scalars['String']['output'];
  /** Is topic group of conversation subject a process? */
  process: Scalars['Boolean']['output'];
  steps: Array<PublicTopicGroup>;
};

/** One Pulser JSON upload. The row stays after Graphile removes the finished job. */
export type PulserImport = {
  __typename?: 'PulserImport';
  byteSize: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  error?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  organizationExternalUid?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status: PulserImportStatus;
  summary?: Maybe<Scalars['String']['output']>;
  surveyCount?: Maybe<Scalars['Int']['output']>;
};

export enum PulserImportStatus {
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type Query = {
  __typename?: 'Query';
  /** Paged AI call log listing with truncated previews (SysAdmin only) */
  aiCallLog: AiCallLogData;
  /** Full detail, including full prompt/response text, for one AI call log row (SysAdmin only) */
  aiCallLogDetail?: Maybe<AiCallLogDetail>;
  /** A single AI use-case config by use case key (SysAdmin only) */
  aiGenerationConfig?: Maybe<AiGenerationConfig>;
  /** All AI use-case configs (SysAdmin only) */
  aiGenerationConfigs: Array<AiGenerationConfig>;
  /** Current AI model pricing table (SysAdmin only) */
  aiModelPricing: Array<AiModelPricing>;
  aiSurveySummary: AiSurveySummaryData;
  /** On-demand usage aggregation over the AI call log, bounded by its 7-day retention (SysAdmin only) */
  aiUsage: Array<AiUsageRow>;
  /** Retrieves all surveys */
  allSurveys: Array<Survey>;
  allSurveysCount: Scalars['Int']['output'];
  /** Return all topic groups */
  allowedTopicGroups?: Maybe<Array<TopicGroup>>;
  /** Retrieves specific channel */
  channel?: Maybe<Channel>;
  channelOverview: ChannelOverview;
  /** Check which login modes are available for the given email (no auth required) */
  checkSso: SsoLoginMode;
  /** Get suitable dates for new survey */
  datesForNewSurvey: DatesForNewSurvey;
  defaultFeatureFlags: Array<Features>;
  /** Exports survey answers as 'File' */
  exportSurveyAnswers?: Maybe<TextFile>;
  /** Exports file for translation import for selected topic */
  exportTranslations?: Maybe<TextFile>;
  getAccessToken: Scalars['String']['output'];
  getCategoryCodes: Array<CategoryCode>;
  /** Get slug for survey channel by respondent ID No. in organization */
  getChannelSlugForIdNumber: Scalars['String']['output'];
  /** Get last open channel for respondent surname and validate using pin */
  getChannelSlugForName: Scalars['String']['output'];
  /** Compare statistics for given periods */
  getComparsionDataForProcessReport: ProcessReportComparsion;
  getCompletedSurveys: Array<Survey>;
  getCreditHistory: Array<CreditHistory>;
  /** get paginated workerTasks references */
  getCronJobs?: Maybe<Array<CronJob>>;
  getGraphileJobQueues?: Maybe<Array<JobQueue>>;
  /** get paginated workerTasks references */
  getGraphileJobs?: Maybe<Array<Job>>;
  /** Return simplified report data */
  getNewReport: NewReport;
  getOrganizationsWithExternalUid: OrganizationWithLinksToReport;
  getProcessReport: ProcessReportInfoSub;
  /** Return all details about respondent in report sequence */
  getProcessReportRespondentDetail: ProcessReportRespondentDetail;
  getProcessReportRespondents: SurveyGroupRespondentsResult;
  /** Return all informations for report */
  getReport: PubReport;
  /** List all reports */
  getReports: Array<ReportList>;
  getRespondentsWithOnboardingInfo?: Maybe<Array<RespondentWithLinksToReport>>;
  getResponseRateStatistics: ResponseRateStatistics;
  getSecureRespondentDetail: ProcessReportRespondentDetail;
  getSurveyGroupResponseRateStatistics: Array<ResponseRateSurveyGroupStatistics>;
  getTotalUnprocessedGraphileJobsCount: Scalars['Int']['output'];
  getUserOtp?: Maybe<Scalars['String']['output']>;
  groupedMessageTemplate?: Maybe<Array<Maybe<GroupTemplateValue>>>;
  industries: Array<IndustryCategory>;
  /** Check if access token can be used for authenticated resources */
  isAccessTokenValid: AccessToken;
  /** Return all supported languages in DB */
  languages: Array<Language>;
  lastMessagesForRespondent: Array<MessageStatus>;
  /** List of all marketing channels */
  marketingChannels?: Maybe<Array<Maybe<MarketingChannel>>>;
  messageQueues?: Maybe<Array<Maybe<MessageQueue>>>;
  /** List of langs */
  messageTemplates?: Maybe<Array<Maybe<MessageTemplate>>>;
  /** Retrieves messages of specific channel */
  messages?: Maybe<Array<Message>>;
  /** Retrieves organization structure */
  organization?: Maybe<Organization>;
  organizationAdmins?: Maybe<Array<Maybe<Respondent>>>;
  /** SSO configuration of an organization (SysAdmin only; clientSecret is never returned) */
  organizationSsoConfig?: Maybe<OrganizationSsoConfig>;
  organizationSurveys: Array<Survey>;
  /** All teams in organization */
  organizationTeams: Array<Team>;
  /** List of all organizations */
  organizations?: Maybe<Array<Maybe<Organization>>>;
  paginatedMessages: MessageData;
  paginatedMessagesForRespondent: MessageData;
  /** Return all topic groups */
  paginatedOrganizations: OrganizationsData;
  /** Return all respondents */
  paginatedRespondents: RespondentsData;
  /** Return information about usage of preview conversation */
  previewConversationUsage: Array<PreviewConversationUsage>;
  /** Render a preview of a message template without persisting it. Placeholders are left as-is. */
  previewMessageTemplate: MessageTemplatePreview;
  /** List of all products */
  products?: Maybe<Array<Maybe<Product>>>;
  /** Return all topic groups */
  publicTopicGroups: Array<Maybe<PublicTopicGroup>>;
  /** Pulser JSON imports and their status after the worker finishes (SysAdmin only) */
  pulserImports: Array<PulserImport>;
  /** Retrieves specific question definition */
  questionDefinition?: Maybe<QuestionDefinition>;
  questionTriggers: Array<QuestionTrigger>;
  reportDefinitionNewForSurvey: ReportDefinitionNewVersion;
  reportDefinitionNewForTopic: ReportDefinitionNewVersion;
  reportDefinitionsNewForSurvey: Array<ReportDefinitionNewVersion>;
  reportDefinitionsNewForTopic: Array<ReportDefinitionNewVersion>;
  /** Return recipients of reports for teams in organization */
  reportRecipients: Array<ReportRecipient>;
  /** Return all details about respondent */
  respondent: Respondent;
  /** Retrieves specific survey */
  survey?: Maybe<Survey>;
  /** Short-lived presigned download URL for a survey attachment */
  surveyAttachmentDownloadUrl: Scalars['String']['output'];
  /** Retrieves specific survey group */
  surveyGroup?: Maybe<SurveyGroup>;
  /** Retrieves respondents for specific survey group */
  surveyGroupRespondents: SurveyGroupRespondents;
  /** Retrieves organization survey groups for defined topic group */
  surveyGroups?: Maybe<Array<SurveyGroup>>;
  /** Retrieves public information about specific survey */
  surveyPublicInfo?: Maybe<SurveyPublicInfo>;
  /** Return all system admins */
  systemAdmins: Array<User>;
  /** get detail of topic */
  topicDetail: Topic;
  /** Topic group is collection of topics */
  topicGroup: TopicGroup;
  /** Return all topic groups */
  topicGroups: TopicGroupsData;
  /** List of all topics */
  topics?: Maybe<Array<Maybe<Topic>>>;
  /** Return user that is derived from used accessToken */
  user: User;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAiCallLogArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  onlyErrors?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  useCase?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAiCallLogDetailArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAiGenerationConfigArgs = {
  useCase: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAiSurveySummaryArgs = {
  accessToken: Scalars['String']['input'];
  answers?: InputMaybe<Array<QuestionWithAnswer>>;
  languageCode: Scalars['String']['input'];
  systemMessage?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAiUsageArgs = {
  from: Scalars['Date']['input'];
  groupBy: AiUsageGroupBy;
  model?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  to: Scalars['Date']['input'];
  useCase?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAllSurveysArgs = {
  filter?: InputMaybe<SurveyFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAllSurveysCountArgs = {
  filter?: InputMaybe<SurveyFilterInput>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAllowedTopicGroupsArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryChannelArgs = {
  channelId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryChannelOverviewArgs = {
  channelSlug: Scalars['ID']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryCheckSsoArgs = {
  email: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryDatesForNewSurveyArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryExportSurveyAnswersArgs = {
  surveyId: Scalars['ID']['input'];
  unfinished: Scalars['Boolean']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryExportTranslationsArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
  topicId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetAccessTokenArgs = {
  username: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetChannelSlugForIdNumberArgs = {
  respondentIdNo: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetChannelSlugForNameArgs = {
  organizationId: Scalars['ID']['input'];
  pin: Scalars['Int']['input'];
  surname: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetComparsionDataForProcessReportArgs = {
  accessToken: Scalars['String']['input'];
  periods: Array<DateRangeInput>;
  teamFilters?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetCompletedSurveysArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetCreditHistoryArgs = {
  productId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetCronJobsArgs = {
  direction?: InputMaybe<OrderByDirection>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  showLockedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  taskIdentifierFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetGraphileJobQueuesArgs = {
  queueNameFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  showLockedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetGraphileJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  showLockedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  taskIdentifierFilter?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetNewReportArgs = {
  accessToken: Scalars['String']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetOrganizationsWithExternalUidArgs = {
  companyExternalUid: Scalars['ID']['input'];
  userEmail: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetProcessReportArgs = {
  accessToken: Scalars['String']['input'];
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  managerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  recruiterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  respondentFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
  showOnlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
  teamFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  withoutDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetProcessReportRespondentDetailArgs = {
  accessToken: Scalars['String']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  respondentId: Scalars['ID']['input'];
  seqDate?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetProcessReportRespondentsArgs = {
  accessToken: Scalars['String']['input'];
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  managerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<Pagination>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  recruiterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  showOnlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
  teamFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  withoutDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetReportArgs = {
  accessToken: Scalars['String']['input'];
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  filters?: InputMaybe<Array<Filter>>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  reportDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetRespondentsWithOnboardingInfoArgs = {
  candidateExternalUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  candidates?: InputMaybe<Array<RespondentsWithOnboardingInfoInput>>;
  companyExternalUid: Scalars['ID']['input'];
  userEmail: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetResponseRateStatisticsArgs = {
  contactType?: InputMaybe<ResponseRateStatisticsContactType>;
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  hasSentReport?: InputMaybe<Scalars['Boolean']['input']>;
  prevSurveyDays?: InputMaybe<Scalars['Int']['input']>;
  reminders: ResponseRateStatisticsReminders;
  respondentsCountFrom?: InputMaybe<Scalars['Int']['input']>;
  respondentsCountTo?: InputMaybe<Scalars['Int']['input']>;
  timeFrom?: InputMaybe<Scalars['Date']['input']>;
  timeTo?: InputMaybe<Scalars['Date']['input']>;
  weekDay?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetSecureRespondentDetailArgs = {
  accessToken: Scalars['String']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
  seqDate?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetSurveyGroupResponseRateStatisticsArgs = {
  hasSentReport?: InputMaybe<Scalars['Boolean']['input']>;
  sequenceTopicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetUserOtpArgs = {
  username: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGroupedMessageTemplateArgs = {
  businessUnit?: InputMaybe<BusinessUnit>;
  groupBy: GroupTemplateType;
  type?: InputMaybe<ContactType>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryLanguagesArgs = {
  filter?: InputMaybe<LanguageFilterInput>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryLastMessagesForRespondentArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  respondentIds: Array<Scalars['ID']['input']>;
  surveyIds: Array<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryMessagesArgs = {
  channelId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryOrganizationAdminsArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryOrganizationSsoConfigArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryOrganizationSurveysArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryOrganizationTeamsArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryPaginatedMessagesArgs = {
  filter?: InputMaybe<MessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryPaginatedMessagesForRespondentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  respondentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryPaginatedOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryPaginatedRespondentsArgs = {
  filter?: InputMaybe<RespondentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryPreviewMessageTemplateArgs = {
  messageTemplate: MessageTemplateInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryPublicTopicGroupsArgs = {
  businessUnit?: InputMaybe<BusinessUnit>;
  language: Scalars['String']['input'];
  product?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryPulserImportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryQuestionDefinitionArgs = {
  questionId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryQuestionTriggersArgs = {
  topicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryReportDefinitionNewForSurveyArgs = {
  id: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryReportDefinitionNewForTopicArgs = {
  id: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryReportDefinitionsNewForSurveyArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryReportDefinitionsNewForTopicArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryReportRecipientsArgs = {
  organizationId: Scalars['ID']['input'];
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryRespondentArgs = {
  respondentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QuerySurveyArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QuerySurveyAttachmentDownloadUrlArgs = {
  attachmentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QuerySurveyGroupArgs = {
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QuerySurveyGroupRespondentsArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  surveyGroupId: Scalars['ID']['input'];
  withoutDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QuerySurveyGroupsArgs = {
  organizationId: Scalars['ID']['input'];
  topicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QuerySurveyPublicInfoArgs = {
  langCode?: InputMaybe<Scalars['String']['input']>;
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QuerySystemAdminsArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryTopicDetailArgs = {
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
  topicId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryTopicGroupArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  topicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryTopicGroupsArgs = {
  filter?: InputMaybe<TopicGroupFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryUserArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

/** Inquiry about something, currently sent by bot */
export type Question = Message & {
  __typename?: 'Question';
  anonymityLevel: AnonymityLevel;
  anonymousInReport?: Maybe<Scalars['Boolean']['output']>;
  /** When message was created */
  createdAt: Scalars['Date']['output'];
  /** Entity that sent this message, bot or respondent */
  createdBy: ChannelUserType;
  /** QuestionDefinition bot used to create message */
  definition: QuestionDefinition;
  /** ID of message */
  id: Scalars['ID']['output'];
  isLast?: Maybe<Scalars['Boolean']['output']>;
  /** Channel to which message was sent */
  sentOn: Channel;
  /** Message text */
  text?: Maybe<Scalars['String']['output']>;
};

/**
 * Definition of single question bot sents. This is template, bot uses to create message from.
 * Also based on previous question and answer determines which question definition it sends next
 */
export type QuestionDefinition = {
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<Rule>;
  /** How many choices user needs to select */
  selectedRange?: Maybe<Scalars['RangeExp']['output']>;
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};

export type QuestionDefinitionInput = {
  answersToHighlight?: InputMaybe<Array<Scalars['ID']['input']>>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isFirstInSectionWithNumber?: InputMaybe<Scalars['Int']['input']>;
  /** If scale question should rank statements */
  isRankingScale?: InputMaybe<Scalars['Boolean']['input']>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  /** X position in the topic editor */
  positionX?: InputMaybe<Scalars['Int']['input']>;
  /** Y position in the topic editor */
  positionY?: InputMaybe<Scalars['Int']['input']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder?: InputMaybe<Scalars['Boolean']['input']>;
  reportIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Question order for reporting */
  reportOrder?: InputMaybe<Scalars['Int']['input']>;
  rules: Array<Routing>;
  selectedRange?: InputMaybe<SelectedRange>;
  /** If skip option should be shown */
  showEscapeOption?: InputMaybe<Scalars['Boolean']['input']>;
  translations: Array<QuestionDefinitionTranslationInput>;
  type: QuestionType;
};

/** Question translation */
export type QuestionDefinitionTranslation = {
  __typename?: 'QuestionDefinitionTranslation';
  choices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isDefault: Scalars['Boolean']['output'];
  /** Language of this translation */
  language: Language;
  /** Statements (sub-questions) of scale question */
  statements?: Maybe<Array<Scalars['String']['output']>>;
  /** Text of the translation */
  text: Scalars['String']['output'];
  /** Translation status: same_as_source = the same as source, source_changed = source language was updated after this translation was saved */
  translationStatus?: Maybe<TranslationStatus>;
};

export type QuestionDefinitionTranslationInput = {
  choices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDefault: Scalars['Boolean']['input'];
  languageId: Scalars['ID']['input'];
  /** Statements (sub-questions) of scale question */
  statements?: InputMaybe<Array<Scalars['String']['input']>>;
  text: Scalars['String']['input'];
};

/** An edge in a connection. */
export type QuestionDefinitionsEdge = {
  __typename?: 'QuestionDefinitionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The questionDefinition at the end of the edge. */
  node: QuestionDefinition;
};

export type QuestionLabel = {
  __typename?: 'QuestionLabel';
  questionDefinitionIndex: Scalars['ID']['output'];
  questionLabelComments?: Maybe<Array<QuestionLabelComments>>;
};

export type QuestionLabelComments = {
  __typename?: 'QuestionLabelComments';
  commentIds?: Maybe<Array<Scalars['ID']['output']>>;
  label: Scalars['String']['output'];
};

export type QuestionTrigger = {
  __typename?: 'QuestionTrigger';
  index: Scalars['Int']['output'];
  topicGroupId: Scalars['ID']['output'];
  triggerIdentifier: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type QuestionTriggerInput = {
  index: Scalars['Int']['input'];
  topicGroupId: Scalars['ID']['input'];
  triggerIdentifier: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export enum QuestionType {
  EmailContact = 'EMAIL_CONTACT',
  Ending = 'ENDING',
  Freetext = 'FREETEXT',
  Multiselect = 'MULTISELECT',
  PersonMultiselect = 'PERSON_MULTISELECT',
  Scale = 'SCALE',
  Select = 'SELECT',
  SmsContact = 'SMS_CONTACT',
  Tell = 'TELL'
}

export type QuestionWithAnswer = {
  answers?: InputMaybe<Array<Scalars['String']['input']>>;
  choices?: InputMaybe<Array<ChoiceAnswer>>;
  id: Scalars['ID']['input'];
  question: Scalars['String']['input'];
  type: QuestionType;
};

/** Rule that can match range of integers. */
export type RangeRule = Rule & {
  __typename?: 'RangeRule';
  /** anonymity */
  anonymity?: Maybe<AnonymityLevel>;
  /** id of rule */
  id: Scalars['ID']['output'];
  /** Is from default - rule is created from question default rule */
  isFromDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Next state that FSM will transition to if this rule matches */
  nextQuestion: QuestionDefinition;
  /** rule operator */
  operator?: Maybe<RuleOperator>;
  /** Order of rule */
  order: Scalars['Int']['output'];
  /** Original rule value */
  origValue: Scalars['String']['output'];
  /** Expression for this rule */
  value?: Maybe<Scalars['RangeExp']['output']>;
};

export type Reaction = {
  __typename?: 'Reaction';
  channelId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  messageId?: Maybe<Scalars['ID']['output']>;
  respondentFullName?: Maybe<Scalars['String']['output']>;
  respondentId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

/** Organization input for self-service registration - only what the sign-up form actually collects. */
export type RegistrationOrganizationInput = {
  /** Source channel */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Allowed topics or topic groups for organization */
  conversationSubjects?: InputMaybe<Array<ConversationSubjectInput>>;
  /** Organization country code. ISO 3166-1 alpha-2 */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  /** Organization name */
  systemName: Scalars['String']['input'];
};

export type Reminder = {
  __typename?: 'Reminder';
  /** Time when reminder will be send */
  reminderAt: Scalars['Date']['output'];
};

export type ReopenSurveyInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  endsAt: Scalars['Date']['input'];
  messageTemplateUid?: InputMaybe<Scalars['String']['input']>;
  reminders?: InputMaybe<Array<SurveyReminderInput>>;
  respondentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sendMessage?: InputMaybe<Scalars['Boolean']['input']>;
  surveyId: Scalars['ID']['input'];
};

export type ReportAccept = {
  accepted: Scalars['Boolean']['input'];
  reportAccessId: Scalars['ID']['input'];
};

export type ReportAccess = {
  __typename?: 'ReportAccess';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  accessKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  language?: Maybe<Language>;
  readAt?: Maybe<Scalars['Date']['output']>;
  respondent?: Maybe<Respondent>;
  resultsInfo?: Maybe<SurveyResultsInfo>;
  sent: Scalars['Boolean']['output'];
  survey?: Maybe<Survey>;
  surveyGroup?: Maybe<SurveyGroup>;
  teams?: Maybe<Array<Team>>;
  topicName: Scalars['String']['output'];
  totalCount?: Maybe<Scalars['Int']['output']>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
  unreadMessages?: Maybe<UnreadMessages>;
  visitsInLastYear?: Maybe<Scalars['Int']['output']>;
};

export type ReportBasicStatistics = {
  __typename?: 'ReportBasicStatistics';
  anonymous: Scalars['Int']['output'];
  answered: Scalars['Int']['output'];
  avgMetric: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
  withProblems: Scalars['Int']['output'];
};

/** Admin-only immutable version metadata and optional payload */
export type ReportDefinitionNewVersion = {
  __typename?: 'ReportDefinitionNewVersion';
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  definition?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ReportList = {
  __typename?: 'ReportList';
  approved: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  languagesWithMissingTranslations: Array<Maybe<Scalars['String']['output']>>;
  reportTopic?: Maybe<Topic>;
  reportTopicGroup?: Maybe<TopicGroup>;
  reportTopics: Array<Maybe<Topic>>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum ReportOpenMetricsView {
  ProcessTable = 'PROCESS_TABLE',
  RespondentDetail = 'RESPONDENT_DETAIL',
  RespondentInPhase = 'RESPONDENT_IN_PHASE'
}

export type ReportOrganization = {
  __typename?: 'ReportOrganization';
  language: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  respondents: Array<Maybe<ReportRespondent>>;
};

export type ReportRecipient = {
  __typename?: 'ReportRecipient';
  id: Scalars['ID']['output'];
  language: Language;
  respondent?: Maybe<Respondent>;
  /** whether linked respondent is deleted */
  respondentDeleted: Scalars['Boolean']['output'];
  team?: Maybe<Team>;
  /** whether linked team is deleted */
  teamDeleted: Scalars['Boolean']['output'];
  type: ReportType;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTo?: Maybe<Scalars['Date']['output']>;
};

export type ReportRespondent = {
  __typename?: 'ReportRespondent';
  channel_id?: Maybe<Scalars['ID']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  respondent_email?: Maybe<Scalars['String']['output']>;
  respondent_firstname?: Maybe<Scalars['String']['output']>;
  respondent_supervisor_email?: Maybe<Scalars['String']['output']>;
  respondent_supervisor_id?: Maybe<Scalars['ID']['output']>;
  respondent_surname?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  team_id?: Maybe<Scalars['ID']['output']>;
  team_name?: Maybe<Scalars['String']['output']>;
};

export enum ReportSectionType {
  Charts = 'charts',
  Pulser = 'pulser'
}

export enum ReportType {
  Team = 'TEAM',
  Unit = 'UNIT'
}

export enum ReportWidgetType {
  AnonymityRate = 'ANONYMITY_RATE',
  CommentTable = 'COMMENT_TABLE',
  Filter = 'FILTER',
  FinishedRate = 'FINISHED_RATE',
  Nps = 'NPS',
  ResponseRate = 'RESPONSE_RATE',
  ScaleChart = 'SCALE_CHART',
  StackedChart = 'STACKED_CHART',
  WithoutIssuesRate = 'WITHOUT_ISSUES_RATE'
}

/** User that answers surveys */
export type Respondent = {
  __typename?: 'Respondent';
  /** all channels of respondent */
  channels?: Maybe<Array<Channel>>;
  /** All respondent contacts */
  contacts?: Maybe<Array<Contact>>;
  /** Date of record creation */
  createdAt: Scalars['Date']['output'];
  /** is respondent deleted */
  deleted: Scalars['Boolean']['output'];
  /** is Respondent disabled - all channels will be disabled */
  disabled: Scalars['Boolean']['output'];
  externalUid?: Maybe<Scalars['String']['output']>;
  /** Respondent name */
  firstname?: Maybe<Scalars['String']['output']>;
  /** ID of respondent */
  id: Scalars['ID']['output'];
  intercomHash?: Maybe<Scalars['String']['output']>;
  /** participated survey groups */
  involvedSurveyGroups?: Maybe<Array<SurveyGroupRespondent>>;
  /** Has subordinates? */
  isLeader: Scalars['Boolean']['output'];
  isReportRecipient: Scalars['Boolean']['output'];
  /** Preferred respondent language */
  language?: Maybe<Language>;
  newAnswersNotifications?: Maybe<NotificationLevel>;
  notificationTeamIds: Array<Scalars['ID']['output']>;
  /** Team organization */
  organization: Organization;
  /** Organization role of respondent */
  organizationRole: UserOrgRole;
  originator?: Maybe<RespondentOriginator>;
  /** Pin code for channel access */
  pin: Scalars['Int']['output'];
  /** Preferred type of contact */
  preferredContactType: ContactType;
  /** reportAccess for respondent */
  reports?: Maybe<Array<ReportAccess>>;
  /** Respondent surname */
  surname?: Maybe<Scalars['String']['output']>;
  /** Team to which respondent belong */
  team?: Maybe<Team>;
  /** user entity if exists */
  user?: Maybe<User>;
};

export type RespondentFilterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type RespondentInput = {
  /** All respondent contacts */
  contacts?: InputMaybe<Array<ContactInput>>;
  /** is Respondent disabled - all channels will be disabled */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** respondent email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Id from external system */
  externalUid?: InputMaybe<Scalars['String']['input']>;
  /** First name of user */
  firstname: Scalars['String']['input'];
  /** Preferred respondent language. Code is ISO 639-1 */
  language?: InputMaybe<Scalars['String']['input']>;
  notificationTeamIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** organization for respondent */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Organization role of respondent */
  organizationRole?: InputMaybe<UserOrgRole>;
  /** Originiator */
  originator?: InputMaybe<Scalars['String']['input']>;
  /** Preferred type of contact */
  preferredContactType?: InputMaybe<ContactType>;
  /** Teams for which respondent will receive reports */
  reportTeamIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Last name of user */
  surname: Scalars['String']['input'];
  surveyGroups?: InputMaybe<Array<NewRespondentSurveyGroupInput>>;
  /** Respondent will be added to surveys */
  surveyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Team to which respondent belong */
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export enum RespondentOriginator {
  Administrator = 'ADMINISTRATOR',
  ApiImport = 'API_IMPORT',
  Autogenerated = 'AUTOGENERATED',
  AutomaticImport = 'AUTOMATIC_IMPORT',
  Import = 'IMPORT',
  Pulser = 'PULSER',
  Teamio = 'TEAMIO'
}

export type RespondentWithLinksToReport = {
  __typename?: 'RespondentWithLinksToReport';
  linksToReport: Array<LinkToReport>;
  respondent: Respondent;
};

export type RespondentsData = {
  __typename?: 'RespondentsData';
  data: Array<Respondent>;
  totalCount: Scalars['Int']['output'];
};

export type RespondentsWithOnboardingInfoInput = {
  email: Scalars['String']['input'];
  externalUid: Scalars['ID']['input'];
  firstname: Scalars['String']['input'];
  hireDate: Scalars['Date']['input'];
  surname: Scalars['String']['input'];
};

export type ResponseRateStatistics = {
  __typename?: 'ResponseRateStatistics';
  total: Scalars['Int']['output'];
  withAnswer: Scalars['Int']['output'];
};

export enum ResponseRateStatisticsContactType {
  Email = 'EMAIL',
  EmailSms = 'EMAIL_SMS',
  Sms = 'SMS'
}

export enum ResponseRateStatisticsReminders {
  All = 'ALL',
  MoreReminders = 'MORE_REMINDERS',
  NoReminder = 'NO_REMINDER',
  OneReminder = 'ONE_REMINDER'
}

export type ResponseRateSurveyGroupStatistics = {
  __typename?: 'ResponseRateSurveyGroupStatistics';
  all: ResponseRateStatistics;
  email: ResponseRateStatistics;
  emailSms: ResponseRateStatistics;
  sms: ResponseRateStatistics;
  topicGroupId: Scalars['ID']['output'];
  topicGroupName: Scalars['String']['output'];
};

export type RootTeamsStatistics = {
  __typename?: 'RootTeamsStatistics';
  statistics: ProcessWidgets;
  teamId: Scalars['ID']['output'];
};

export type Routing = {
  /** Secondary rule based on anonymity. If undefined, anonymity does not matters */
  anonymity?: InputMaybe<AnonymityLevel>;
  /** Is from default - rule is created from question default rule */
  isFromDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** next question index relative for import file/query */
  nextQuestionIndex?: InputMaybe<Scalars['ID']['input']>;
  /** rule for routing to next question. If empty, match all answers */
  rule?: InputMaybe<Scalars['String']['input']>;
  /** Rule Operator */
  ruleOperator?: InputMaybe<RuleOperator>;
};

/**
 * Question rule, basicly this is one row in state-transition table of underlying FSM.
 * We don't have value here because graphql doesn't support union of scalars
 */
export type Rule = {
  /** id of rule */
  id: Scalars['ID']['output'];
  /** Is from default - rule is created from question default rule */
  isFromDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Next state that FSM will transition to if this rule matches */
  nextQuestion: QuestionDefinition;
  /** Rule Operator */
  operator?: Maybe<RuleOperator>;
  /** Order of rule */
  order: Scalars['Int']['output'];
  /** Original rule value */
  origValue: Scalars['String']['output'];
};

export enum RuleOperator {
  In = 'IN',
  Inany = 'INANY'
}

export type ScaleAnswer = Message & {
  __typename?: 'ScaleAnswer';
  anonymityLevel: AnonymityLevel;
  anonymousInReport?: Maybe<Scalars['Boolean']['output']>;
  /** Optional comment provided with the statement answer */
  comment?: Maybe<Scalars['String']['output']>;
  /** When message was created */
  createdAt: Scalars['Date']['output'];
  /** Entity that sent this message, bot or respondent */
  createdBy: ChannelUserType;
  /** ID of message */
  id: Scalars['ID']['output'];
  isLast?: Maybe<Scalars['Boolean']['output']>;
  /** Answer is to this question */
  question: Question;
  remainingQuestions: Scalars['Int']['output'];
  /** Response on answer */
  response?: Maybe<Array<Message>>;
  /** Channel to which message was sent */
  sentOn: Channel;
  /** Index of statement within Scale question */
  statementIndex?: Maybe<Scalars['Int']['output']>;
  /** Display value of answer */
  text: Scalars['String']['output'];
  /** Selected value index for the statement */
  value: Array<Scalars['Int']['output']>;
};

/** Question scale - multiple choices (only 1 selectable) and multiple sub-questions */
export type ScaleQuestionDefinition = Answerable & QuestionDefinition & {
  __typename?: 'ScaleQuestionDefinition';
  /**
   * Answers to this question.
   * Optionally can return only answers for given channel or survey
   */
  answers: SelectAnswersConnection;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** Available choices for this question */
  choices: Array<Scalars['String']['output']>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<Rule>;
  /** How many choices user needs to select */
  selectedRange?: Maybe<Scalars['RangeExp']['output']>;
  /** If skip option should be shown */
  showEscapeOption: Scalars['Boolean']['output'];
  /** Statements (sub-questions) of scale question */
  statements: Array<Scalars['String']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};


/** Question scale - multiple choices (only 1 selectable) and multiple sub-questions */
export type ScaleQuestionDefinitionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for one statement answer in a scale question */
export type ScaleStatementAnswerInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  statementIndex: Scalars['Int']['input'];
  value: Scalars['Int']['input'];
};

/** Answer to question with choices */
export type SelectAnswer = Message & {
  __typename?: 'SelectAnswer';
  anonymityLevel: AnonymityLevel;
  anonymousInReport?: Maybe<Scalars['Boolean']['output']>;
  /** Optional comment provided with the statement answer */
  comment?: Maybe<Scalars['String']['output']>;
  /** When message was created */
  createdAt: Scalars['Date']['output'];
  /** Entity that sent this message, bot or respondent */
  createdBy: ChannelUserType;
  /** ID of message */
  id: Scalars['ID']['output'];
  isLast?: Maybe<Scalars['Boolean']['output']>;
  /** Answer is to this question */
  question: Question;
  remainingQuestions: Scalars['Int']['output'];
  /** Response on answer */
  response?: Maybe<Array<Message>>;
  /** Channel to which message was sent */
  sentOn: Channel;
  /** Index of statement within Scale question */
  statementIndex?: Maybe<Scalars['Int']['output']>;
  /** Display value of answer */
  text: Scalars['String']['output'];
  /** Value of answer, it's index to questionDefinition choices */
  value: Array<Scalars['Int']['output']>;
};

/** The connection type for SelectAnswer. */
export type SelectAnswersConnection = AnswersConnection & {
  __typename?: 'SelectAnswersConnection';
  /** Aggregate of answers by value */
  aggregate?: Maybe<Array<AggregateAnswersByValue>>;
  /** A list of edges. */
  edges?: Maybe<Array<SelectAnswersEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SelectAnswersEdge = AnswersEdge & {
  __typename?: 'SelectAnswersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The select answer at the end of the edge. */
  node: SelectAnswer;
};

/** Question with choices. Respondent needs to select one of choices */
export type SelectQuestionDefinition = Answerable & QuestionDefinition & {
  __typename?: 'SelectQuestionDefinition';
  /**
   * Answers to this question.
   * Optionaly can return only answers for given channel or survey
   */
  answers: SelectAnswersConnection;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** Available choices for this question */
  choices: Array<Scalars['String']['output']>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<Rule>;
  /** How many choices user needs to select */
  selectedRange: Scalars['RangeExp']['output'];
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};


/** Question with choices. Respondent needs to select one of choices */
export type SelectQuestionDefinitionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

export type SelectedRange = {
  /** Maximum of selectable options */
  max: Scalars['Int']['input'];
  /** Minimum of selectable options */
  min: Scalars['Int']['input'];
};

export enum Sentiment {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type SmsContactQuestionDefinition = Answerable & QuestionDefinition & {
  __typename?: 'SmsContactQuestionDefinition';
  /**
   * Answers to this question.
   * Optionaly can return only answers for given channel or survey
   */
  answers: SelectAnswersConnection;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** International phone code or respondents phone number */
  phoneNumber: Scalars['String']['output'];
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<RangeRule>;
  /** How many choices user needs to select */
  selectedRange?: Maybe<Scalars['RangeExp']['output']>;
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};


export type SmsContactQuestionDefinitionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Which login modes the login page should offer for an email */
export enum SsoLoginMode {
  /** login is completely blocked - email domain is not authorized for SSO in a strict (sso_forced + sso_exclusive) organization */
  Blocked = 'BLOCKED',
  /** SSO not available - regular password / magic-link login */
  None = 'NONE',
  /** SSO available as an additional option next to password / magic-link login */
  Optional = 'OPTIONAL',
  /** SSO is the only allowed login method */
  Required = 'REQUIRED'
}

export type StepStatistics = {
  __typename?: 'StepStatistics';
  avgMetric: Scalars['Float']['output'];
  periodIndex: Scalars['Int']['output'];
  statistics: ProcessWidgets;
  stepId: Scalars['ID']['output'];
};

/** Root subscription type. */
export type Subscription = {
  __typename?: 'Subscription';
  aiSurveySummary: AiSurveySummaryData;
  aiSurveySummaryAbTest: AiSurveySummaryAbTestData;
  arielAiChat: ArielAiChatData;
  getProcessKeywords: GetProcessKeywordsData;
  getProcessReport: ProcessReportInfoSub;
  /** Return all informations for report */
  getReport: PubReport;
  watchSurveyGroupChanges?: Maybe<SurveyGroupChange>;
};


/** Root subscription type. */
export type SubscriptionAiSurveySummaryArgs = {
  accessToken: Scalars['String']['input'];
  answers?: InputMaybe<Array<QuestionWithAnswer>>;
  languageCode: Scalars['String']['input'];
  systemMessage?: InputMaybe<Scalars['String']['input']>;
};


/** Root subscription type. */
export type SubscriptionAiSurveySummaryAbTestArgs = {
  accessToken: Scalars['String']['input'];
  answers?: InputMaybe<Array<QuestionWithAnswer>>;
  defaultSystemMessage: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
};


/** Root subscription type. */
export type SubscriptionArielAiChatArgs = {
  graph: Array<ArielAiNodeDataInput>;
  languageCode: Scalars['String']['input'];
  messages: Array<ArielAiChatMessageInput>;
  topicId: Scalars['ID']['input'];
};


/** Root subscription type. */
export type SubscriptionGetProcessKeywordsArgs = {
  accessToken: Scalars['String']['input'];
  answersIds: Array<Scalars['String']['input']>;
  generate: Scalars['Boolean']['input'];
  languageCode: Scalars['String']['input'];
  questionIdx: Scalars['String']['input'];
};


/** Root subscription type. */
export type SubscriptionGetProcessReportArgs = {
  accessToken: Scalars['String']['input'];
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  managerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  recruiterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  respondentFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
  showOnlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
  teamFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  withoutDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root subscription type. */
export type SubscriptionGetReportArgs = {
  accessToken: Scalars['String']['input'];
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  filters?: InputMaybe<Array<Filter>>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  reportDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
};


/** Root subscription type. */
export type SubscriptionWatchSurveyGroupChangesArgs = {
  surveyGroupId: Scalars['ID']['input'];
};

export enum SubscriptionDuration {
  Month = 'MONTH',
  Year = 'YEAR'
}

/**
 * Survey binds one topic to respondents that will be surveyed.
 * Will send emails with channel links to recipients on scheduled time.
 */
export type Survey = {
  __typename?: 'Survey';
  /** Access key for public survey */
  accessKey?: Maybe<Scalars['String']['output']>;
  /** Survey settings regarding anonymity */
  anonymitySettings: AnonymitySettings;
  /** Date when was the survey archived, null if not archived */
  archivedAt?: Maybe<Scalars['Date']['output']>;
  /** Documents attached to this survey */
  attachments: Array<SurveyAttachment>;
  availableInLanguages: Array<Language>;
  /** Channels where responders answer surveys. Only when ONGOING || FINISHED */
  channels?: Maybe<Array<Channel>>;
  /** When survey was created */
  createdAt: Scalars['Date']['output'];
  /** When survey will end. When it ends it will finish all channels */
  endsAt?: Maybe<Scalars['Date']['output']>;
  hasReports: Scalars['Boolean']['output'];
  /** ID of survey */
  id: Scalars['ID']['output'];
  /** If this survey is finished, respondents cannot answer questions anymore */
  isFinished: Scalars['Boolean']['output'];
  /** True when the topic requires Internal approval and the survey report is not yet approved */
  isReportPendingApproval: Scalars['Boolean']['output'];
  /** default js report short id for survey topic */
  jsReportShortId?: Maybe<Scalars['String']['output']>;
  keywordsGenerated: Scalars['Boolean']['output'];
  keywordsVersion: Scalars['Int']['output'];
  /** Language of survey */
  languageCode?: Maybe<Scalars['String']['output']>;
  /** Stored company-wide values of identified report metrics, created when the results are released (Internal only) */
  metricsSnapshot?: Maybe<SurveyMetricsSnapshot>;
  notstartedReason?: Maybe<NotstartedSurveyReason>;
  /** Organization that ordered this survey. */
  organization: Organization;
  /** If survey is free to all users */
  public?: Maybe<Scalars['Boolean']['output']>;
  publicChannels: Array<PublicChannel>;
  /** Who this survey is for. Those teams need to be in same org */
  recipients: Array<Team>;
  /** Survey reminders */
  reminders: Array<Reminder>;
  /** Whether Internal has approved the client-facing report */
  reportApproved: Scalars['Boolean']['output'];
  /** Report definition ID */
  reportDefinitionId?: Maybe<Scalars['ID']['output']>;
  /** note for report */
  reportNote?: Maybe<Scalars['String']['output']>;
  /** Params for report genratero */
  reportParams?: Maybe<Scalars['String']['output']>;
  reportRecipients?: Maybe<Array<Maybe<ReportRecipient>>>;
  /** Free-text grouping key for metric calculation */
  reportSeries?: Maybe<Scalars['String']['output']>;
  /** List of reports for this survey */
  reports?: Maybe<Array<ReportAccess>>;
  respondentIds: Array<Scalars['ID']['output']>;
  /** Aggregate results info */
  resultsInfo?: Maybe<SurveyResultsInfo>;
  /** Time when this survey is scheduled to be send */
  sendAt: Scalars['Date']['output'];
  /** Survey invitation and reminders will be send to both contacts - email and sms */
  sendEmailSms?: Maybe<Scalars['Boolean']['output']>;
  /** Survey status */
  status: SurveyStatus;
  /** Survey group where survey belongs to */
  surveyGroup?: Maybe<SurveyGroup>;
  teamIds: Array<Maybe<Scalars['ID']['output']>>;
  /** Results info aggregated by teams */
  teamsResultInfo?: Maybe<Array<Maybe<TeamsSurveyResultsInfo>>>;
  /** Indicates wheter survey runs in test mode or not */
  testing?: Maybe<Scalars['Boolean']['output']>;
  /** Top level report for this survey */
  topLevelReport?: Maybe<ReportAccess>;
  /** Surveyed topic */
  topic?: Maybe<Topic>;
  /** Surveyed topic group */
  topicGroup?: Maybe<TopicGroup>;
  /** When survey was last time updated */
  updatedAt: Scalars['Date']['output'];
  /** User which created survey */
  user: User;
  /** Who this survey is for. Whitelist with respondents. */
  whitelistedRespondents: Array<Respondent>;
  whitelistedRespondentsLength?: Maybe<Scalars['Int']['output']>;
};

/** Descriptor for survey anonymity */
export type SurveyAnonymityInput = {
  allowedLevels?: InputMaybe<Array<InputMaybe<AnonymityLevel>>>;
  /**
   * Default anonymity for channels that are created from this survey.
   * Will default to ORGANIZATION
   */
  default?: InputMaybe<AnonymityLevel>;
};

export type SurveyAttachment = {
  __typename?: 'SurveyAttachment';
  /** Upload timestamp */
  createdAt: Scalars['Date']['output'];
  /** ID of attachment record */
  id: Scalars['ID']['output'];
  /** MIME type as reported on upload */
  mimeType: Scalars['String']['output'];
  /** Original file name */
  originalName: Scalars['String']['output'];
  /** File size in bytes */
  sizeBytes: Scalars['Int']['output'];
};

export type SurveyFilterInput = {
  endsAtTo?: InputMaybe<Scalars['Date']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  sendAtFrom?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<SurveyStatus>>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyGroup = {
  __typename?: 'SurveyGroup';
  from?: Maybe<Scalars['Date']['output']>;
  groupedRespondents: Array<GroupedRespondents>;
  hasOutOfLicenceInterval?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isAnySurveyComplete: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notstartedReason?: Maybe<Array<NotstartedSurveyReason>>;
  organization?: Maybe<Organization>;
  reportRecipients?: Maybe<Array<Maybe<ReportRecipient>>>;
  reports: Array<ReportAccess>;
  statistics?: Maybe<ReportBasicStatistics>;
  status: ProcessStatus;
  steps: Array<SurveyGroupStep>;
  surveyGroupRespondents?: Maybe<Array<SurveyGroupRespondent>>;
  to?: Maybe<Scalars['Date']['output']>;
  /** Top level report for this survey group */
  topLevelReport?: Maybe<ReportAccess>;
  topicGroup: TopicGroup;
  topicGroupId: Scalars['ID']['output'];
};

export type SurveyGroupChange = {
  __typename?: 'SurveyGroupChange';
  surveyGroupId: Scalars['ID']['output'];
};

export type SurveyGroupRespondent = {
  __typename?: 'SurveyGroupRespondent';
  addedOn?: Maybe<Scalars['Date']['output']>;
  deleted: Scalars['Boolean']['output'];
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  numberOfSurveys?: Maybe<Scalars['Int']['output']>;
  respondent: Respondent;
  respondentId: Scalars['ID']['output'];
  respondentStatus?: Maybe<SurveyGroupRespondentStatus>;
  surveyGroup: SurveyGroup;
  surveyGroupId: Scalars['ID']['output'];
};

export type SurveyGroupRespondentImport = {
  id: Scalars['ID']['input'];
  settings: Array<SurveyGroupRespondentSettings>;
};

export type SurveyGroupRespondentImportInput = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<SurveyGroupRespondentImportType>;
};

export enum SurveyGroupRespondentImportType {
  ChangeDate = 'change_date',
  CreateNewRun = 'create_new_run'
}

export type SurveyGroupRespondentSettings = {
  addedOn: Scalars['String']['input'];
  respondentEmails: Array<Scalars['String']['input']>;
};

export enum SurveyGroupRespondentStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Notplanned = 'NOTPLANNED',
  Ongoing = 'ONGOING',
  Prepared = 'PREPARED'
}

export type SurveyGroupRespondentWithDetails = {
  __typename?: 'SurveyGroupRespondentWithDetails';
  addedOn: Scalars['Date']['output'];
  answers: Array<MetricAnswer>;
  channels?: Maybe<Array<Channel>>;
  creditsToReturn?: Maybe<Scalars['Int']['output']>;
  deleted: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  hiringAdditionalData?: Maybe<Array<HiringAdditionalData>>;
  hiringSurveys?: Maybe<Array<Survey>>;
  isCreatingSurveys: Scalars['Boolean']['output'];
  isLastRun: Scalars['Boolean']['output'];
  recruiterName: Scalars['String']['output'];
  recruitmentId?: Maybe<Scalars['String']['output']>;
  respondent: Respondent;
  surveys: Array<Survey>;
  undeliveredInvitations?: Maybe<Array<Maybe<UndeliveredInvitations>>>;
};

export type SurveyGroupRespondents = {
  __typename?: 'SurveyGroupRespondents';
  data: Array<SurveyGroupRespondentWithDetails>;
  totalCount: Scalars['Int']['output'];
};

export type SurveyGroupRespondentsResult = {
  __typename?: 'SurveyGroupRespondentsResult';
  data: Array<GroupedRespondents>;
  totalCount: Scalars['Int']['output'];
};

export type SurveyGroupStep = {
  __typename?: 'SurveyGroupStep';
  avgMetric?: Maybe<Scalars['Float']['output']>;
  channels: Array<Channel>;
  daysFromStart: Scalars['Int']['output'];
  hasMetricQuestion: Scalars['Boolean']['output'];
  hasNotStarted?: Maybe<Scalars['Boolean']['output']>;
  hasOutOfLicenceInterval?: Maybe<Scalars['Boolean']['output']>;
  notstartedReason?: Maybe<Array<NotstartedSurveyReason>>;
  processStep: ProcessStep;
  reportDefinition?: Maybe<PubReportDefinition>;
  statistics?: Maybe<ReportBasicStatistics>;
  status: ProcessStatus;
  surveyGroupId: Scalars['Int']['output'];
  surveys: Array<BasicSurveyInfo>;
};

/**
 * Company-wide values of the identified metrics of a survey's primary report definition, stored once for trends
 * and benchmarks. Organization data is copied as it was when the snapshot was created.
 */
export type SurveyMetricsSnapshot = {
  __typename?: 'SurveyMetricsSnapshot';
  /** Organization number of employees */
  companySize?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Map of metric identifier to { value: Float | null, count: Int } */
  metrics: Scalars['JSON']['output'];
  /** Non-public snapshots are excluded from leaderboard and benchmark inputs */
  public: Scalars['Boolean']['output'];
  /** Report definition version the values were calculated from */
  reportDefinitionId: Scalars['ID']['output'];
  reportSeries: Scalars['String']['output'];
  /** Organization industry code */
  sector?: Maybe<Scalars['String']['output']>;
};

/**
 * Survey binds one topic to respondents that will be surveyed.
 * Will send emails with channel links to recipients on scheduled time.
 */
export type SurveyPublicInfo = {
  __typename?: 'SurveyPublicInfo';
  endsAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  status: SurveyStatus;
  topicGroupName?: Maybe<Scalars['String']['output']>;
};

/** Reminder to be sent at given time */
export type SurveyReminderInput = {
  /** Time when is the reminder supposed to be sent */
  reminderAt: Scalars['Date']['input'];
};

export type SurveyRespondentImport = {
  id: Scalars['ID']['input'];
  respondentEmails: Array<Scalars['String']['input']>;
};

/** Aggregate info about results of survey */
export type SurveyResultsInfo = {
  __typename?: 'SurveyResultsInfo';
  /** Number of anonymous channels */
  anonymous: Scalars['Int']['output'];
  /** Number of channels with answer from user */
  answered: Scalars['Int']['output'];
  /**
   * Average time it takes respondent to finish this survey.
   * TODO: interval scalar
   */
  avgFinishTime?: Maybe<Scalars['Interval']['output']>;
  /** Number of finished channels */
  finished: Scalars['Int']['output'];
  /** Total number of channels */
  total: Scalars['Int']['output'];
  /** Number of channels with problems */
  withProblems: Scalars['Int']['output'];
};

/** Survey status */
export enum SurveyStatus {
  /** Survey is being activated and email are being sent */
  Activating = 'ACTIVATING',
  /** Survey was automatically anonymized after 25 months */
  Anonymized = 'ANONYMIZED',
  /** Survey is not active, ends_at date is in past and archived column is set to true.It does not mean that survey is archived in report_data_storage! */
  Archived = 'ARCHIVED',
  /** Survey is not active, ends_at date is in past */
  Completed = 'COMPLETED',
  /** Survey not started */
  Notstarted = 'NOTSTARTED',
  /** Survey is active, send_at date is in past and ends_at date is in future */
  Ongoing = 'ONGOING',
  /** Survey is not active, send_at date is in future */
  Prepared = 'PREPARED'
}

/**
 * Team groups respondents.
 * Surveys can be send to specific teams in organization
 */
export type Team = {
  __typename?: 'Team';
  /** ID of team */
  id: Scalars['ID']['output'];
  /** Team Leader */
  leader?: Maybe<Respondent>;
  /** Respondents that belong to this team */
  members: Array<Respondent>;
  /** Name of team */
  name?: Maybe<Scalars['String']['output']>;
  /** Parent organization */
  organization: Organization;
  /** Is it rootTeam in tree structure?(leader is CEO) */
  rootTeam: Scalars['Boolean']['output'];
  /** Team unique identificator */
  structureId?: Maybe<Scalars['String']['output']>;
  /** supervisor team in org structure */
  supervisorTeam?: Maybe<Team>;
  teamLeaderId?: Maybe<Scalars['ID']['output']>;
};

export type TeamInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  supervisorTeam?: InputMaybe<Scalars['String']['input']>;
};

/** survey results info for team */
export type TeamsSurveyResultsInfo = {
  __typename?: 'TeamsSurveyResultsInfo';
  resultInfo: SurveyResultsInfo;
  team: Team;
  /** team member ids from channels - is basically the team structure from the moment of survey creation */
  teamMemberIdsFromChannels: Array<Scalars['ID']['output']>;
};

/** Text file to be downloaded */
export type TextFile = {
  __typename?: 'TextFile';
  /** UTF-8 encoded file contents */
  contents: Scalars['String']['output'];
  /** Mimetype of file, like Content-Type header */
  mimetype: Scalars['String']['output'];
  /** Name of file, like filename in Content-Disposition header */
  name: Scalars['String']['output'];
};

/** Rule that can match regular expression. */
export type TextRule = Rule & {
  __typename?: 'TextRule';
  /** anonymity */
  anonymity?: Maybe<AnonymityLevel>;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** id of rule */
  id: Scalars['ID']['output'];
  /** Is from default - rule is created from question default rule */
  isFromDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Next state that FSM will transition to if this rule matches */
  nextQuestion: QuestionDefinition;
  /** Rule Operator */
  operator?: Maybe<RuleOperator>;
  /** Order of rule */
  order: Scalars['Int']['output'];
  /** Original rule value */
  origValue: Scalars['String']['output'];
  /** expression for this rule */
  value?: Maybe<Scalars['RegExp']['output']>;
};

export enum TimePeriod {
  Month = 'MONTH'
}

/**
 * Topic is conversation template, it contains question tree with rules that determine
 * whats next question based on answer.
 */
export type Topic = {
  __typename?: 'Topic';
  /** Flattened question definitions that can be answered */
  allAnswerables: Array<Answerable>;
  /** Flattened questions */
  allQuestions: Array<QuestionDefinition>;
  /** default allowed anonymities for topic */
  allowedAnonymities?: Maybe<Array<Maybe<AnonymityLevel>>>;
  commentGroups?: Maybe<Array<CommentGroup>>;
  /** When topic was created */
  createdAt: Scalars['Date']['output'];
  /** default anonymity for topic */
  defaultAnonymity?: Maybe<AnonymityLevel>;
  /** Description of topic */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of topic */
  id: Scalars['ID']['output'];
  /** Indicate if topic is ready for new surveys */
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  /** Indicate if topic can be edited - planned and ongoing topics are not editable */
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  /** Indicate if topic is used only for testing purposes */
  isTesting?: Maybe<Scalars['Boolean']['output']>;
  /** Indicate if topic is valid */
  isValid?: Maybe<Scalars['Boolean']['output']>;
  /** Language IDs of translations that are on the starting question */
  languageIdsOnStartingQuestion: Array<Scalars['ID']['output']>;
  /** All topic languages. */
  languages: Array<TopicLanguage>;
  /** Newest report definition specified for this topic */
  lastValidReportDefinition?: Maybe<ReportList>;
  /** Short identification for humans */
  name: Scalars['String']['output'];
  numberOfComments?: Maybe<Scalars['Int']['output']>;
  /** specified message template uid for reminder message */
  reminderTemplate?: Maybe<Scalars['String']['output']>;
  /** First question in topic, bot initiates conversation with this */
  startingQuestion: QuestionDefinition;
  /** Topic group to which topic belongs */
  topicGroup: TopicGroup;
  /** When topic was updated */
  updatedAt: Scalars['Date']['output'];
  updatedBy?: Maybe<User>;
  /** specified message template uid for welcome message */
  welcomeTemplate?: Maybe<Scalars['String']['output']>;
};

export type TopicDetail = {
  __typename?: 'TopicDetail';
  approved: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Topic>;
  topicGroup?: Maybe<TopicGroup>;
};

export type TopicGroup = {
  __typename?: 'TopicGroup';
  accessKeys?: Maybe<Array<TopicGroupAccess>>;
  allowedAnonymities: Array<AnonymityLevel>;
  categoryCode?: Maybe<Scalars['String']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  chatSatisfactionScale?: Maybe<Scalars['Int']['output']>;
  containsSteps: Scalars['Boolean']['output'];
  defaultAnonymity: AnonymityLevel;
  deleteRespondents?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hideOnboardingParts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  languages?: Maybe<Array<Language>>;
  lastSurvey?: Maybe<Survey>;
  lastSurveyGroup?: Maybe<SurveyGroup>;
  lastValidTopic?: Maybe<Topic>;
  limitedMode?: Maybe<Scalars['String']['output']>;
  /** Minimum time in seconds a respondent must take to fill the survey; responses below this threshold are auto-deactivated */
  minimumFillingTimeSecs?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** Organization owning this topic group */
  organization?: Maybe<Organization>;
  parentTopicGroup?: Maybe<TopicGroup>;
  /** Products / business units in which this public topic group is available (SysAdmin only) */
  productTopicGroups: Array<ProductTopicGroup>;
  questionOrderManuallyModified?: Maybe<Scalars['Boolean']['output']>;
  questionOrderModified?: Maybe<Scalars['Boolean']['output']>;
  reminder1Template?: Maybe<Scalars['String']['output']>;
  reminder2Template?: Maybe<Scalars['String']['output']>;
  reminder3Template?: Maybe<Scalars['String']['output']>;
  reports: Array<ReportList>;
  /** When true, client reports stay hidden and unsent until Internal approves the survey report */
  requiresReportApproval: Scalars['Boolean']['output'];
  steps?: Maybe<Array<ProcessStep>>;
  topics?: Maybe<Array<Topic>>;
  translations?: Maybe<Array<TopicGroupTranslation>>;
  typeCode?: Maybe<TopicGroupTypeCode>;
  welcomeTemplate?: Maybe<Scalars['String']['output']>;
};

export type TopicGroupAccess = {
  __typename?: 'TopicGroupAccess';
  accessKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['String']['output'];
  topicGroupId: Scalars['ID']['output'];
};

export type TopicGroupFilterInput = {
  /** Only topic groups not owned by any organization */
  onlyPublic?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  topicGroup?: InputMaybe<Scalars['String']['input']>;
};

export type TopicGroupTranslation = {
  __typename?: 'TopicGroupTranslation';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: Language;
  topicGroup?: Maybe<TopicGroup>;
  topicGroupId?: Maybe<Scalars['ID']['output']>;
  value: Scalars['String']['output'];
};

/** type of topic group mainly useto distinguish process topic groups */
export enum TopicGroupTypeCode {
  Exit = 'EXIT',
  Hiring = 'HIRING',
  HiringFms = 'HIRING_FMS',
  Onboarding = 'ONBOARDING',
  Pulse = 'PULSE',
  Pulser = 'PULSER'
}

export type TopicGroupsData = {
  __typename?: 'TopicGroupsData';
  data: Array<TopicGroup>;
  totalCount: Scalars['Int']['output'];
};

export type TopicInput = {
  /** Topic group description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** if topic is approved */
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  /** if topic is used only for testing purposes */
  isTesting?: InputMaybe<Scalars['Boolean']['input']>;
  /** if topic is valid */
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Language - iso of new topic */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Language id of new topic */
  languageId?: InputMaybe<Scalars['ID']['input']>;
  previousTopicId?: InputMaybe<Scalars['ID']['input']>;
  /** Id of topic group */
  topicGroupId: Scalars['ID']['input'];
  /** Id of new topic */
  topicId?: InputMaybe<Scalars['ID']['input']>;
  /** Team Notes */
  topicName: Scalars['String']['input'];
};

export type TopicLanguage = {
  __typename?: 'TopicLanguage';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
};

export type TopicMessageTemplate = {
  __typename?: 'TopicMessageTemplate';
  messageTemplateId: Scalars['ID']['output'];
  messageType: MessageTemplateUid;
  topicId: Scalars['ID']['output'];
};

export enum TranslationStatus {
  SameAsSource = 'same_as_source',
  SourceChanged = 'source_changed'
}

export type TwilioLookUpResponse = {
  __typename?: 'TwilioLookUpResponse';
  countryCode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  specifiedPhoneNumber: Scalars['String']['output'];
  twilioError?: Maybe<TwilioLookUpResponseErr>;
};

export type TwilioLookUpResponseErr = {
  __typename?: 'TwilioLookUpResponseErr';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Enum to determine if typing started or ended */
export enum TypingEventType {
  /** Typing ended */
  End = 'END',
  /** Typing started */
  Start = 'START'
}

export type UndeliveredInvitation = {
  __typename?: 'UndeliveredInvitation';
  contact: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  surveyId: Scalars['ID']['output'];
};

export type UndeliveredInvitations = {
  __typename?: 'UndeliveredInvitations';
  respondentId: Scalars['ID']['output'];
  undeliveredSurveyInvitations?: Maybe<Array<UndeliveredInvitation>>;
};

export type UnreadMessages = {
  __typename?: 'UnreadMessages';
  count?: Maybe<Scalars['Int']['output']>;
  from?: Maybe<Scalars['Date']['output']>;
};

export type UpdateCommentInput = {
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

/** Organization configuration */
export type UpdateOrganizationConfigInput = {
  /** Default country calling code */
  countryCallingCode?: InputMaybe<Scalars['String']['input']>;
  /** send team reports to teamleaders */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Organization id */
  organizationId: Scalars['ID']['input'];
  /** Language code of organization. Code is ISO 639-1 */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
  /** Timezone */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInput = {
  /** Allowed survey languages for organization. Code is ISO 639-1 */
  allowedLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Change organization status to ARCHIVED. To archive organization pass true, to unarchive organization pass false */
  archiveOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Business unit of the organization */
  businessUnit?: InputMaybe<BusinessUnit>;
  /** Source channel */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** CIN (IČO) for integration with other systems */
  companyId?: InputMaybe<Scalars['String']['input']>;
  /** Allowed topics or topic groups for organization */
  conversationSubjects?: InputMaybe<Array<ConversationSubjectInput>>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** Custom organization name */
  customName?: InputMaybe<Scalars['String']['input']>;
  /** ID of the default onboarding SG */
  defaultOnboardingId?: InputMaybe<Scalars['ID']['input']>;
  /** External ID for integration with other systems (Teamio etc.) */
  externalUid?: InputMaybe<Scalars['String']['input']>;
  garantEmail?: InputMaybe<Scalars['String']['input']>;
  /** ID of organizations group */
  groupOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Organization id */
  id: Scalars['ID']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
  /** Organization language code */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Licence count */
  licenceCount?: InputMaybe<Scalars['Int']['input']>;
  /** custom attribute do DB */
  microlearningAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minimal team size to generate report */
  minimalTeamSizeToGenerateReport?: InputMaybe<Scalars['Int']['input']>;
  /** Minimal team size to keep anonymity */
  minimalTeamSizeToKeepAnonymity?: InputMaybe<Scalars['Int']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  /** ID of originator */
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  processNotificationsDefault?: InputMaybe<NotificationLevel>;
  processNotificationsLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of organization purchased product name */
  product?: InputMaybe<Scalars['String']['input']>;
  reminder1Template?: InputMaybe<Scalars['String']['input']>;
  reminder2Template?: InputMaybe<Scalars['String']['input']>;
  reminder3Template?: InputMaybe<Scalars['String']['input']>;
  /** Organiation name */
  systemName?: InputMaybe<Scalars['String']['input']>;
  testOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization valid period */
  validPeriod?: InputMaybe<Scalars['Int']['input']>;
  welcomeTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProcessStepInput = {
  candidateLanguageCode?: InputMaybe<Scalars['String']['input']>;
  copyTg?: InputMaybe<Scalars['Boolean']['input']>;
  customFieldsCheck?: InputMaybe<Array<CustomFieldsCheckInput>>;
  endOffsetMins?: InputMaybe<Scalars['Int']['input']>;
  eventDateField?: InputMaybe<Scalars['String']['input']>;
  payloadCheck?: InputMaybe<Array<PayloadCheckInput>>;
  previousEventsCheck?: InputMaybe<Array<PreviousEventsCheckInput>>;
  remindersOffsetMins?: InputMaybe<Array<Scalars['Int']['input']>>;
  startOffsetMins?: InputMaybe<Scalars['Int']['input']>;
  triggeredOn?: InputMaybe<Scalars['String']['input']>;
  useEmailFromNote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProductVersionInput = {
  boughtCredits?: InputMaybe<Scalars['Float']['input']>;
  licenceCount?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  productHistorySurveyTypes?: InputMaybe<Array<InputMaybe<ProductHistorySurveyTypeInput>>>;
  rescheduleOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  transferredCredits?: InputMaybe<Scalars['Float']['input']>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateRespondentFromReportInput = {
  /** All respondent contacts */
  contacts?: InputMaybe<Array<ContactInput>>;
  /** Preferred type of contact */
  preferredContactType?: InputMaybe<ContactType>;
};

export type UpdateRespondentInput = {
  /** All respondent contacts */
  contacts?: InputMaybe<Array<ContactInput>>;
  /** is Respondent disabled - all channels will be disabled */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** First name of user */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** Preferred respondent language. Code is ISO 639-1 */
  language?: InputMaybe<Scalars['String']['input']>;
  notificationTeamIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** organization for respondent */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Organization role of respondent */
  organizationRole?: InputMaybe<UserOrgRole>;
  /** Preferred type of contact */
  preferredContactType?: InputMaybe<ContactType>;
  /** Teams for which respondent will receive reports */
  reportTeamIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Last name of user */
  surname?: InputMaybe<Scalars['String']['input']>;
  /** Team to which respondent belong */
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

/** Parameters for updateSurvey mutation */
export type UpdateSurveyInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  /** Descriptor for anonymity related behaviour */
  anonymity?: InputMaybe<SurveyAnonymityInput>;
  /** Conversation subject to start */
  conversationSubjectId?: InputMaybe<Scalars['ID']['input']>;
  /** Conversation subject type */
  conversationSubjectType?: InputMaybe<ConversationSubjectType>;
  /** When survey ends. Must be later than sendAt */
  endsAt?: InputMaybe<Scalars['Date']['input']>;
  forceActivation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Language of survey. Topic must have translation for this language */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Only allowed channels for these recipients */
  recipientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Reminders to be sent at specified time. */
  reminders?: InputMaybe<Array<SurveyReminderInput>>;
  /** ID of report definition */
  reportDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  reportNote?: InputMaybe<Scalars['String']['input']>;
  reportParams?: InputMaybe<Scalars['String']['input']>;
  /** Free-text grouping key for metric calculation */
  reportSeries?: InputMaybe<Scalars['String']['input']>;
  respondentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When survey sends out invitation emails and becomes ONGOING */
  sendAt?: InputMaybe<Scalars['Date']['input']>;
  /** Survey invitation and reminders will be send to both contacts - email and sms */
  sendEmailSms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reference date for the survey group respondents */
  seqDate?: InputMaybe<Scalars['Date']['input']>;
  /** Id of survey group for the survey */
  surveyGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates wheter survey runs in test mode or not */
  testing?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeTemplateUid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamInput = {
  supervisorTeamId?: InputMaybe<Scalars['ID']['input']>;
  teamLeaderId?: InputMaybe<Scalars['ID']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  systemRole?: InputMaybe<UserSysRole>;
};

export type User = {
  __typename?: 'User';
  /** list of allowed organizations for user - based on user role */
  allowedMoreOrganizations: Scalars['Boolean']['output'];
  /** list of allowed organizations for user - based on user role */
  allowedOrganizations: Array<Organization>;
  /** flag if user changed password */
  changedPassword: Scalars['Boolean']['output'];
  consent: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** users first name */
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intercomHash?: Maybe<Scalars['String']['output']>;
  marketingConsent: Scalars['Boolean']['output'];
  optValidTo?: Maybe<Scalars['Date']['output']>;
  /** if user is ORG admin */
  organization?: Maybe<Organization>;
  otp?: Maybe<Scalars['String']['output']>;
  /** list of all users respondents */
  respondents?: Maybe<Array<Respondent>>;
  summaryNotifications: Scalars['Boolean']['output'];
  /** users last name */
  surname?: Maybe<Scalars['String']['output']>;
  /** user role org/sys admin */
  systemRole: UserSysRole;
  username: Scalars['String']['output'];
};

export type UserInput = {
  /** user calling code */
  callingCode?: InputMaybe<Scalars['String']['input']>;
  /** users email and login */
  email: Scalars['String']['input'];
  /** First name of user */
  firstname?: InputMaybe<Scalars['String']['input']>;
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization role of user */
  orgRole?: InputMaybe<UserOrgRole>;
  /** organization for users of type ORG_ADMIN and REPORT */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** user phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** UID of message template for registration message */
  registrationTemplateUid?: InputMaybe<Scalars['String']['input']>;
  /** Last name of user */
  surname?: InputMaybe<Scalars['String']['input']>;
  /** System role of user */
  sysRole?: InputMaybe<UserSysRole>;
  /** username  */
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum UserOrgRole {
  /** organization admin */
  OrgAdmin = 'ORG_ADMIN',
  /** respondent in organization - default */
  OrgRespondent = 'ORG_RESPONDENT'
}

export enum UserSysRole {
  /** system admin */
  SysAdmin = 'SYS_ADMIN',
  /** role is dependent on organization - default */
  SysUser = 'SYS_USER'
}

export type Widget = {
  __typename?: 'Widget';
  denominator: Scalars['Int']['output'];
  numerator: Scalars['Int']['output'];
};

export type CreateTopicGroupInput = {
  /** Topic group allowed Anonymities. Default value is [ORGANIZATION,NONE] */
  allowedAnonymities?: InputMaybe<Array<AnonymityLevel>>;
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  /** True if topic group contains a sequence of topic groups */
  containsSteps?: InputMaybe<Scalars['Boolean']['input']>;
  /** Topic group default anonymity. Default value is NONE */
  defaultAnonymity?: InputMaybe<AnonymityLevel>;
  deleteRespondents?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Hide onboarding parts in reports */
  hideOnboardingParts?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  /** Minimum filling time in seconds; must be a positive integer or null to clear */
  minimumFillingTimeSecs?: InputMaybe<Scalars['Int']['input']>;
  /** Topic group name */
  name: Scalars['String']['input'];
  /** Owner of this topic group */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Topic group default reminder template uid */
  reminder1Template?: InputMaybe<Scalars['String']['input']>;
  reminder2Template?: InputMaybe<Scalars['String']['input']>;
  reminder3Template?: InputMaybe<Scalars['String']['input']>;
  /** When true, client reports stay hidden and unsent until Internal approves the survey report */
  requiresReportApproval?: InputMaybe<Scalars['Boolean']['input']>;
  typeCode?: InputMaybe<TopicGroupTypeCode>;
  /** Topic group default welcome template uid */
  welcomeTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type GetProcessKeywordsData = {
  __typename?: 'getProcessKeywordsData';
  done: Scalars['Boolean']['output'];
  keywords?: Maybe<Array<QuestionLabelComments>>;
};

export type SetTopicGroupDefaultsInput = {
  /** Topic group allowed Anonymities */
  allowedAnonymities?: InputMaybe<Array<AnonymityLevel>>;
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  /** Topic group default anonymity. */
  defaultAnonymity?: InputMaybe<AnonymityLevel>;
  deleteRespondents?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hide onboarding parts in reports */
  hideOnboardingParts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id of topicGroup */
  id: Scalars['ID']['input'];
  /** Minimum filling time in seconds; must be a positive integer or null to clear */
  minimumFillingTimeSecs?: InputMaybe<Scalars['Int']['input']>;
  /** Organization ID */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Topic group default reminder template uid */
  reminder1Template?: InputMaybe<Scalars['String']['input']>;
  reminder2Template?: InputMaybe<Scalars['String']['input']>;
  reminder3Template?: InputMaybe<Scalars['String']['input']>;
  /** When true, client reports stay hidden and unsent until Internal approves the survey report */
  requiresReportApproval?: InputMaybe<Scalars['Boolean']['input']>;
  typeCode?: InputMaybe<TopicGroupTypeCode>;
  /** Topic group default welcome template uid */
  welcomeTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTopicInput = {
  /** Topic id */
  id: Scalars['ID']['input'];
  /** Topic is approved. If false topic will not be used for survey */
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Topic name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Topic group id to which topic belongs */
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertTopicGroupTranslationInput = {
  /** Description translation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Language code of translation. Code is ISO 639-1 */
  language: Scalars['String']['input'];
  /** Topic group */
  topicGroupId: Scalars['ID']['input'];
  /** Name translations */
  value?: InputMaybe<Scalars['String']['input']>;
};

type QuestionDefinition_CommentQuestionDefinition_Fragment = { __typename?: 'CommentQuestionDefinition' };

type QuestionDefinition_EmailContactQuestionDefinition_Fragment = { __typename?: 'EmailContactQuestionDefinition', text: string, email: string };

type QuestionDefinition_EndingQuestionDefinition_Fragment = { __typename?: 'EndingQuestionDefinition' };

type QuestionDefinition_FreeTextQuestionDefinition_Fragment = { __typename?: 'FreeTextQuestionDefinition', text: string };

type QuestionDefinition_PersonMultiselectQuestionDefinition_Fragment = { __typename?: 'PersonMultiselectQuestionDefinition', text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> };

type QuestionDefinition_ScaleQuestionDefinition_Fragment = { __typename?: 'ScaleQuestionDefinition', text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string };

type QuestionDefinition_SelectQuestionDefinition_Fragment = { __typename?: 'SelectQuestionDefinition', text: string, choices: Array<string>, selectedRange: any };

type QuestionDefinition_SmsContactQuestionDefinition_Fragment = { __typename?: 'SmsContactQuestionDefinition', text: string, phoneNumber: string };

export type QuestionDefinitionFragment = QuestionDefinition_CommentQuestionDefinition_Fragment | QuestionDefinition_EmailContactQuestionDefinition_Fragment | QuestionDefinition_EndingQuestionDefinition_Fragment | QuestionDefinition_FreeTextQuestionDefinition_Fragment | QuestionDefinition_PersonMultiselectQuestionDefinition_Fragment | QuestionDefinition_ScaleQuestionDefinition_Fragment | QuestionDefinition_SelectQuestionDefinition_Fragment | QuestionDefinition_SmsContactQuestionDefinition_Fragment;

export type ReportFragmentFragment = { __typename?: 'PubReport', id: string, addedOnFrom?: any | null, addedOnTo?: any | null, identifier: string, totalRespondents?: number | null, surveyKeywordsGenerated: boolean, anonymityEnabled: boolean, anonymityForced: boolean, reportRoots?: Array<string> | null, sequenceFrom?: any | null, sequenceTo?: any | null, anonymitySettings?: { __typename?: 'AnonymitySettings', default?: AnonymityLevel | null, allowedLevels?: Array<AnonymityLevel> | null } | null, firstSurvey?: { __typename?: 'Survey', public?: boolean | null } | null, hiringAdditionalData?: Array<{ __typename?: 'HiringAdditionalData', respondentId: string, surveyId?: string | null, position?: string | null, isHired?: boolean | null, isRejected?: boolean | null, recruiterName?: string | null }> | null, responses?: Array<{ __typename?: 'PubResponse', id: string, surveyId: string, respondentId: string, topicGroupId: string, anonymous: boolean, originalAnonymous: boolean, finished: boolean, additionallyAnonymized: boolean, seqDate?: any | null, messages?: Array<{ __typename?: 'PubMessage', id: string, questionDefinitionIndex: string, statementIndex?: number | null, comment?: string | null, text?: string | null, value?: string | null, anonymous: boolean, originalAnonymous: boolean, date: any }> | null, reactions?: Array<{ __typename?: 'Reaction', id: string, channelId: string, messageId?: string | null, respondentId: string, text: string, createdAt: any }> | null }> | null, questions?: Array<{ __typename?: 'PubQuestion', id: string, index: string, text: string, type: QuestionType, selectedRange?: string | null, answersLocal?: Array<string> | null, statementsLocal?: Array<string> | null, showEscapeOption?: boolean | null, isRankingScale?: boolean | null, reportIndex?: string | null, answersToHighlight?: Array<string> | null }> | null, respondents?: Array<{ __typename?: 'PubRespondent', id: string, firstname: string, surname: string, addedOn?: any | null }> | null, metadata?: { __typename?: 'PubMetadata', surveyEnd?: any | null, surveyStart?: any | null, status: SurveyStatus, accepted?: boolean | null, topicGroupId?: string | null, adminEmails?: Array<string> | null, organizationDepth: number, organization: { __typename?: 'Organization', id: string, name: string, featureNames?: Array<string | null> | null, primaryLanguageCode: string, languages: Array<{ __typename?: 'Language', code: string }> }, language?: { __typename?: 'Language', id: string, code: string } | null, respondent?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, intercomHash?: string | null, createdAt: any, organizationRole: UserOrgRole, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string, source?: ContactSource | null }> | null, organization: { __typename?: 'Organization', id: string, name: string, companyId?: string | null, featureNames?: Array<string | null> | null }, user?: { __typename?: 'User', id: string, username: string, firstname?: string | null, surname?: string | null, intercomHash?: string | null, createdAt?: any | null, systemRole: UserSysRole, respondents?: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole }> | null } | null } | null, productVersion?: { __typename?: 'ProductVersion', validFrom: any, validTo: any, product: string } | null } | null, teams?: Array<{ __typename?: 'PubTeams', id: string, teamName: string, directMembers?: Array<string> | null, memberTeams?: Array<string> | null, teamLeader?: string | null }> | null, surveyGroup?: { __typename?: 'SurveyGroup', from?: any | null, to?: any | null, topicGroup: { __typename?: 'TopicGroup', id: string, typeCode?: TopicGroupTypeCode | null, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null }, steps: Array<{ __typename?: 'SurveyGroupStep', daysFromStart: number, processStep: { __typename?: 'ProcessStep', stepTopicGroup: { __typename?: 'TopicGroup', id: string, allowedAnonymities: Array<AnonymityLevel>, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null } } }> } | null, questionLabels?: Array<{ __typename?: 'QuestionLabel', questionDefinitionIndex: string, questionLabelComments?: Array<{ __typename?: 'QuestionLabelComments', label: string, commentIds?: Array<string> | null }> | null }> | null, source?: Array<{ __typename?: 'PubSource', respondentId: string, sourceId: string }> | null, reportDefinition?: { __typename?: 'PubReportDefinition', id: string, titleLocal?: string | null, aboutLocal?: string | null, sections?: Array<{ __typename?: 'PubSection', id: string, heading: string, headingLocal: string, descriptionLocal?: string | null, type: ReportSectionType, displayFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null, titleFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null, widgets?: Array<{ __typename?: 'PubWidget', id: string, questionDefinitionIndex?: string | null, headingLocal: string, type: string, descriptionLocal?: string | null, answersToHighlight?: Array<string> | null, values?: Array<string | null> | null, titleFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null, displayFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null }> | null }> | null, intro?: Array<{ __typename?: 'PubWidget', questionDefinitionIndex?: string | null, headingLocal: string, type: string, descriptionLocal?: string | null, answersToHighlight?: Array<string> | null, values?: Array<string | null> | null, numerator?: number | null, denominator?: number | null, additionallyAnonymized?: boolean | null, displayFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null }> | null } | null, additionalRespondentData?: Array<{ __typename?: 'AdditionalRespondentDataFromTeamio', channelId: string, position?: string | null, recruiter?: string | null, managers?: Array<string> | null, addedOn?: string | null }> | null };

export type ProcessReportRespondentDetailFragment = { __typename?: 'ProcessReportRespondentDetail', id: string, identifier: string, reportRoots: Array<string>, hiringAdditionalData?: Array<{ __typename?: 'HiringAdditionalData', respondentId: string, position?: string | null, isHired?: boolean | null, surveyId?: string | null, isRejected?: boolean | null, recruiterName?: string | null }> | null, groupedRespondents: Array<{ __typename?: 'GroupedRespondents', addedOn: any, deletedRespondents?: Array<string> | null, respondents: Array<{ __typename?: 'Respondent', id: string, preferredContactType: ContactType, firstname?: string | null, surname?: string | null, deleted: boolean, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string, phoneNumber?: { __typename?: 'PhoneNumber', countryCallingCode: string, nationalNumber: string } | null }> | null }>, surveys: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, sendAt: any, endsAt?: any | null, public?: boolean | null, respondentIds: Array<string>, topicGroup?: { __typename?: 'TopicGroup', id: string } | null, publicChannels: Array<{ __typename?: 'PublicChannel', id: string, respondentId: string, lastRemindedAt?: any | null, maxAnonymousHighlightedLevel: number, withAnswer: boolean, finishedAt?: any | null, isFinishedByRespondent: boolean }> }>, hiringSurveys?: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, sendAt: any, endsAt?: any | null, respondentIds: Array<string>, topicGroup?: { __typename?: 'TopicGroup', id: string } | null, publicChannels: Array<{ __typename?: 'PublicChannel', id: string, respondentId: string, lastRemindedAt?: any | null, maxAnonymousHighlightedLevel: number, withAnswer: boolean, finishedAt?: any | null, isFinishedByRespondent: boolean }> }> | null, hiringAdditionalData?: Array<{ __typename?: 'HiringAdditionalData', respondentId: string, position?: string | null, isHired?: boolean | null, isRejected?: boolean | null, recruiterName?: string | null }> | null, undeliveredInvitations?: Array<{ __typename?: 'UndeliveredInvitations', respondentId: string, undeliveredSurveyInvitations?: Array<{ __typename?: 'UndeliveredInvitation', surveyId: string, contact: string, status?: string | null }> | null } | null> | null, metricQuestionsForRespondent: Array<{ __typename?: 'MetricQuestionForRespondent', respondentId: string, answers: Array<{ __typename?: 'MetricAnswer', topicGroupId: string, value?: number | null }> }>, hasUnreadMessages?: Array<{ __typename?: 'HasUnreadMessages', respondentId: string, unreadMessages?: Array<string> | null }> | null }>, questions: Array<{ __typename?: 'PubQuestion', id: string, index: string, text: string, type: QuestionType, selectedRange?: string | null, answersLocal?: Array<string> | null, statementsLocal?: Array<string> | null, showEscapeOption?: boolean | null, isRankingScale?: boolean | null, reportIndex?: string | null, answersToHighlight?: Array<string> | null, metrics: Array<string | null>, topicGroupId?: string | null }>, responses: Array<{ __typename?: 'PubResponse', id: string, surveyId: string, respondentId: string, topicGroupId: string, anonymous: boolean, originalAnonymous: boolean, finished: boolean, additionallyAnonymized: boolean, seqDate?: any | null, reactions?: Array<{ __typename?: 'Reaction', id: string, channelId: string, messageId?: string | null, respondentId: string, respondentFullName?: string | null, text: string, createdAt: any }> | null, messages?: Array<{ __typename?: 'PubMessage', id: string, questionDefinitionIndex: string, text?: string | null, value?: string | null, anonymous: boolean, originalAnonymous: boolean, statementIndex?: number | null, comment?: string | null, date: any, hasAlert: boolean }> | null }>, respondents: Array<{ __typename?: 'PubRespondent', id: string, firstname: string, surname: string, addedOn?: any | null }>, keyPoints?: Array<{ __typename?: 'KeyPoint', answerIds: Array<string>, point: string, sentiment: Sentiment }> | null, surveyGroup?: { __typename?: 'SurveyGroup', id: string, from?: any | null, to?: any | null, topicGroup: { __typename?: 'TopicGroup', id: string, typeCode?: TopicGroupTypeCode | null, hideOnboardingParts?: boolean | null, allowedAnonymities: Array<AnonymityLevel>, defaultAnonymity: AnonymityLevel, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null }, steps: Array<{ __typename?: 'SurveyGroupStep', daysFromStart: number, hasMetricQuestion: boolean, status: ProcessStatus, hasNotStarted?: boolean | null, notstartedReason?: Array<NotstartedSurveyReason> | null, surveys: Array<{ __typename?: 'BasicSurveyInfo', id: string, sendAt: any, endsAt?: any | null, seqDate?: any | null, status: SurveyStatus, public?: boolean | null }>, processStep: { __typename?: 'ProcessStep', id: string, startOffsetMins?: number | null, endOffsetMins?: number | null, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }>, stepTopicGroup: { __typename?: 'TopicGroup', allowedAnonymities: Array<AnonymityLevel>, defaultAnonymity: AnonymityLevel, id: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null } } }> } | null, metadata: { __typename?: 'PubMetadata', surveyEnd?: any | null, surveyStart?: any | null, status: SurveyStatus, accepted?: boolean | null, adminEmails?: Array<string> | null, organization: { __typename?: 'Organization', id: string, name: string, featureNames?: Array<string | null> | null, config?: { __typename?: 'OrganizationConfig', countryCallingCode: string } | null }, language?: { __typename?: 'Language', id: string, code: string } | null, respondent?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, createdAt: any, intercomHash?: string | null, organizationRole: UserOrgRole, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string, source?: ContactSource | null }> | null, organization: { __typename?: 'Organization', id: string, name: string, companyId?: string | null, featureNames?: Array<string | null> | null }, user?: { __typename?: 'User', id: string, username: string, firstname?: string | null, surname?: string | null, intercomHash?: string | null, createdAt?: any | null, systemRole: UserSysRole, respondents?: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole }> | null } | null } | null, productVersion?: { __typename?: 'ProductVersion', validFrom: any, validTo: any, product: string } | null }, teams: Array<{ __typename?: 'PubTeams', id: string, teamName: string, directMembers?: Array<string> | null, memberTeams?: Array<string> | null, teamLeader?: string | null }> };

export type AiSurveySummaryFragmentFragment = { __typename?: 'AiSurveySummaryData', text: string, done: boolean, hash?: string | null };

export type ProcessReportFragmentFragment = { __typename?: 'ProcessReportInfoSub', id: string, identifier: string, totalRespondents?: number | null, filteredRespondents?: number | null, addedOnFrom?: any | null, addedOnTo?: any | null, reportRoots: Array<string>, hiringInfo?: { __typename?: 'HiringInfo', positions: Array<{ __typename?: 'HiringInfoItem', id: string, label: string, candidateIds: Array<string> }>, recruiters: Array<{ __typename?: 'HiringInfoItem', id: string, label: string, candidateIds: Array<string> }>, managers: Array<{ __typename?: 'HiringInfoItem', id: string, label: string, candidateIds: Array<string> }> } | null, groupedRespondents?: { __typename?: 'SurveyGroupRespondentsResult', totalCount: number, data: Array<{ __typename?: 'GroupedRespondents', addedOn: any, deletedRespondents?: Array<string> | null, metricQuestionsForRespondent: Array<{ __typename?: 'MetricQuestionForRespondent', respondentId: string, answers: Array<{ __typename?: 'MetricAnswer', topicGroupId: string, value?: number | null }> }>, respondents: Array<{ __typename?: 'Respondent', id: string, preferredContactType: ContactType, firstname?: string | null, surname?: string | null, deleted: boolean, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string, phoneNumber?: { __typename?: 'PhoneNumber', countryCallingCode: string, nationalNumber: string } | null }> | null }>, surveys: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, sendAt: any, endsAt?: any | null, public?: boolean | null, respondentIds: Array<string>, topicGroup?: { __typename?: 'TopicGroup', id: string } | null, publicChannels: Array<{ __typename?: 'PublicChannel', id: string, respondentId: string, lastRemindedAt?: any | null, maxAnonymousHighlightedLevel: number, withAnswer: boolean, isFinishedByRespondent: boolean, finishedAt?: any | null }> }>, hiringSurveys?: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, sendAt: any, endsAt?: any | null, respondentIds: Array<string>, topicGroup?: { __typename?: 'TopicGroup', id: string } | null, publicChannels: Array<{ __typename?: 'PublicChannel', id: string, respondentId: string, lastRemindedAt?: any | null, maxAnonymousHighlightedLevel: number, withAnswer: boolean, isFinishedByRespondent: boolean, finishedAt?: any | null }> }> | null, hiringAdditionalData?: Array<{ __typename?: 'HiringAdditionalData', respondentId: string, position?: string | null, isHired?: boolean | null, isRejected?: boolean | null, recruiterName?: string | null }> | null, undeliveredInvitations?: Array<{ __typename?: 'UndeliveredInvitations', respondentId: string, undeliveredSurveyInvitations?: Array<{ __typename?: 'UndeliveredInvitation', surveyId: string, contact: string, status?: string | null }> | null } | null> | null, hasUnreadMessages?: Array<{ __typename?: 'HasUnreadMessages', respondentId: string, unreadMessages?: Array<string> | null }> | null }> } | null, metadata: { __typename?: 'PubMetadata', surveyEnd?: any | null, surveyStart?: any | null, status: SurveyStatus, accepted?: boolean | null, adminEmails?: Array<string> | null, organization: { __typename?: 'Organization', id: string, name: string, featureNames?: Array<string | null> | null, config?: { __typename?: 'OrganizationConfig', countryCallingCode: string } | null }, language?: { __typename?: 'Language', id: string, code: string } | null, respondent?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole, createdAt: any, intercomHash?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string, source?: ContactSource | null }> | null, organization: { __typename?: 'Organization', id: string, name: string, companyId?: string | null, featureNames?: Array<string | null> | null }, user?: { __typename?: 'User', id: string, username: string, firstname?: string | null, surname?: string | null, intercomHash?: string | null, createdAt?: any | null, systemRole: UserSysRole, respondents?: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole }> | null } | null } | null, productVersion?: { __typename?: 'ProductVersion', validFrom: any, validTo: any, product: string } | null }, widgets?: { __typename?: 'ProcessWidgets', withoutProblems: { __typename?: 'Widget', numerator: number, denominator: number }, responseRate: { __typename?: 'Widget', numerator: number, denominator: number }, anonymityRate: { __typename?: 'Widget', numerator: number, denominator: number } } | null, rootTeamsStatistics?: Array<{ __typename?: 'RootTeamsStatistics', teamId: string, statistics: { __typename?: 'ProcessWidgets', finishedRate: { __typename?: 'Widget', numerator: number, denominator: number }, responseRate: { __typename?: 'Widget', numerator: number, denominator: number }, anonymityRate: { __typename?: 'Widget', numerator: number, denominator: number } } }> | null, teams?: Array<{ __typename?: 'PubTeams', id: string, teamName: string, directMembers?: Array<string> | null, memberTeams?: Array<string> | null, teamLeader?: string | null }> | null, surveyGroup?: { __typename?: 'SurveyGroup', from?: any | null, to?: any | null, id: string, statistics?: { __typename?: 'ReportBasicStatistics', total: number, answered: number, withProblems: number } | null, topicGroup: { __typename?: 'TopicGroup', id: string, hideOnboardingParts?: boolean | null, typeCode?: TopicGroupTypeCode | null, allowedAnonymities: Array<AnonymityLevel>, defaultAnonymity: AnonymityLevel, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null }, steps: Array<{ __typename?: 'SurveyGroupStep', daysFromStart: number, hasMetricQuestion: boolean, status: ProcessStatus, hasNotStarted?: boolean | null, notstartedReason?: Array<NotstartedSurveyReason> | null, statistics?: { __typename?: 'ReportBasicStatistics', answered: number, total: number, withProblems: number, anonymous: number, avgMetric: number } | null, surveys: Array<{ __typename?: 'BasicSurveyInfo', id: string, sendAt: any, endsAt?: any | null, seqDate?: any | null, status: SurveyStatus, public?: boolean | null }>, processStep: { __typename?: 'ProcessStep', id: string, startOffsetMins?: number | null, endOffsetMins?: number | null, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }>, stepTopicGroup: { __typename?: 'TopicGroup', allowedAnonymities: Array<AnonymityLevel>, defaultAnonymity: AnonymityLevel, id: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null } } }> } | null };

export type SaveReportDefinitionNewForSurveyMutationVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  definition: Scalars['JSON']['input'];
}>;


export type SaveReportDefinitionNewForSurveyMutation = { __typename?: 'Mutation', saveReportDefinitionNewForSurvey: { __typename?: 'ReportDefinitionNewVersion', id: string, name?: string | null, createdAt: any, createdBy?: string | null, isPrimary: boolean, definition?: unknown | null } };

export type SetPrimaryReportDefinitionNewForSurveyMutationVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type SetPrimaryReportDefinitionNewForSurveyMutation = { __typename?: 'Mutation', setPrimaryReportDefinitionNewForSurvey: { __typename?: 'ReportDefinitionNewVersion', id: string, name?: string | null, createdAt: any, createdBy?: string | null, isPrimary: boolean, definition?: unknown | null } };

export type SetPrimaryReportDefinitionNewForTopicMutationVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type SetPrimaryReportDefinitionNewForTopicMutation = { __typename?: 'Mutation', setPrimaryReportDefinitionNewForTopic: { __typename?: 'ReportDefinitionNewVersion', id: string, name?: string | null, createdAt: any, createdBy?: string | null, isPrimary: boolean, definition?: unknown | null } };

export type SaveReportDefinitionNewForTopicMutationVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  definition: Scalars['JSON']['input'];
  primary?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaveReportDefinitionNewForTopicMutation = { __typename?: 'Mutation', saveReportDefinitionNewForTopic: { __typename?: 'ReportDefinitionNewVersion', id: string, name?: string | null, createdAt: any, createdBy?: string | null, isPrimary: boolean, definition?: unknown | null } };

export type SendTextAnswerMutationVariables = Exact<{
  channelId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  previousQuestionId: Scalars['ID']['input'];
}>;


export type SendTextAnswerMutation = { __typename?: 'Mutation', sendTextAnswer: { __typename: 'FreeTextAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, remainingQuestions: number, question: { __typename?: 'Question', definition: { __typename?: 'CommentQuestionDefinition' } | { __typename?: 'EmailContactQuestionDefinition', text: string, email: string } | { __typename?: 'EndingQuestionDefinition' } | { __typename?: 'FreeTextQuestionDefinition', text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', text: string, phoneNumber: string } }, response?: Array<{ __typename: 'EndingMessage', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'FreeTextAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'OtherMessage', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'Question', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, definition: { __typename?: 'CommentQuestionDefinition', optional?: boolean | null } | { __typename?: 'EmailContactQuestionDefinition', optional?: boolean | null, text: string, email: string } | { __typename?: 'EndingQuestionDefinition', optional?: boolean | null } | { __typename?: 'FreeTextQuestionDefinition', optional?: boolean | null, text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', optional?: boolean | null, text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', optional?: boolean | null, text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', optional?: boolean | null, text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', optional?: boolean | null, text: string, phoneNumber: string }, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'ScaleAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'SelectAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } }> | null } };

export type SendSelectAnswerMutationVariables = Exact<{
  channelId: Scalars['ID']['input'];
  values: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  message: Scalars['String']['input'];
  previousQuestionId: Scalars['ID']['input'];
}>;


export type SendSelectAnswerMutation = { __typename?: 'Mutation', sendSelectAnswer: { __typename: 'SelectAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, remainingQuestions: number, value: Array<number>, response?: Array<{ __typename: 'EndingMessage', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'FreeTextAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'OtherMessage', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'Question', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, definition: { __typename?: 'CommentQuestionDefinition', optional?: boolean | null } | { __typename?: 'EmailContactQuestionDefinition', optional?: boolean | null, text: string, email: string } | { __typename?: 'EndingQuestionDefinition', optional?: boolean | null } | { __typename?: 'FreeTextQuestionDefinition', optional?: boolean | null, text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', optional?: boolean | null, text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', optional?: boolean | null, text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', optional?: boolean | null, text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', optional?: boolean | null, text: string, phoneNumber: string }, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'ScaleAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'SelectAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } }> | null, question: { __typename?: 'Question', definition: { __typename?: 'CommentQuestionDefinition' } | { __typename?: 'EmailContactQuestionDefinition', text: string, email: string } | { __typename?: 'EndingQuestionDefinition' } | { __typename?: 'FreeTextQuestionDefinition', text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', text: string, phoneNumber: string } } } };

export type SendScaleAnswerMutationVariables = Exact<{
  channelId: Scalars['ID']['input'];
  answers: Array<ScaleStatementAnswerInput> | ScaleStatementAnswerInput;
  previousQuestionId: Scalars['ID']['input'];
}>;


export type SendScaleAnswerMutation = { __typename?: 'Mutation', sendScaleAnswer: Array<{ __typename: 'ScaleAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, remainingQuestions: number, statementIndex?: number | null, comment?: string | null, value: Array<number>, response?: Array<{ __typename: 'EndingMessage', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'FreeTextAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'OtherMessage', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'Question', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, definition: { __typename?: 'CommentQuestionDefinition', optional?: boolean | null } | { __typename?: 'EmailContactQuestionDefinition', optional?: boolean | null, text: string, email: string } | { __typename?: 'EndingQuestionDefinition', optional?: boolean | null } | { __typename?: 'FreeTextQuestionDefinition', optional?: boolean | null, text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', optional?: boolean | null, text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', optional?: boolean | null, text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', optional?: boolean | null, text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', optional?: boolean | null, text: string, phoneNumber: string }, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'ScaleAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'SelectAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } }> | null, question: { __typename?: 'Question', definition: { __typename?: 'CommentQuestionDefinition' } | { __typename?: 'EmailContactQuestionDefinition', text: string, email: string } | { __typename?: 'EndingQuestionDefinition' } | { __typename?: 'FreeTextQuestionDefinition', text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', text: string, phoneNumber: string } } }> };

export type OpenChannelMutationVariables = Exact<{
  channelId: Scalars['ID']['input'];
}>;


export type OpenChannelMutation = { __typename?: 'Mutation', openChannel?: { __typename?: 'ChannelWithStartingMessages', displayLinkToOneplace?: boolean | null, someUnfilledChannel?: boolean | null, someReport?: boolean | null, channel: { __typename?: 'Channel', id: string, isFinished: boolean, isOpen: boolean, createdAt: any, endsAt?: any | null, sendAt: any, topicName: string, surveyFinished: boolean, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, allowedAnonymities: Array<AnonymityLevel>, testing?: boolean | null, public: boolean, remainingQuestions: number, totalQuestions: number, allowedLanguages: Array<{ __typename?: 'Language', id: string, code: string }>, language: { __typename?: 'Language', id: string, code: string }, reactions?: Array<{ __typename?: 'Reaction', id: string, channelId: string, messageId?: string | null, respondentId: string, respondentFullName?: string | null, text: string, createdAt: any }> | null, respondent?: { __typename?: 'Respondent', firstname?: string | null, surname?: string | null, language?: { __typename?: 'Language', id: string, code: string } | null, user?: { __typename?: 'User', id: string, username: string } | null, organization: { __typename?: 'Organization', id: string, name: string }, contacts?: Array<{ __typename?: 'Contact', value: string, type: ContactType, source?: ContactSource | null }> | null } | null }, startingMessages?: Array<{ __typename: 'EndingMessage', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'FreeTextAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'OtherMessage', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'Question', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, definition: { __typename?: 'CommentQuestionDefinition', optional?: boolean | null } | { __typename?: 'EmailContactQuestionDefinition', optional?: boolean | null, text: string, email: string } | { __typename?: 'EndingQuestionDefinition', optional?: boolean | null } | { __typename?: 'FreeTextQuestionDefinition', optional?: boolean | null, text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', optional?: boolean | null, text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', optional?: boolean | null, text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', optional?: boolean | null, text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', optional?: boolean | null, text: string, phoneNumber: string }, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'ScaleAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'SelectAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } }> | null, messages?: Array<{ __typename?: 'EndingMessage', id: string, text?: string | null, createdAt: any, isLast?: boolean | null, createdBy: ChannelUserType, anonymityLevel: AnonymityLevel } | { __typename?: 'FreeTextAnswer', id: string, text: string, createdAt: any, isLast?: boolean | null, createdBy: ChannelUserType, anonymityLevel: AnonymityLevel, question: { __typename?: 'Question', definition: { __typename?: 'CommentQuestionDefinition' } | { __typename?: 'EmailContactQuestionDefinition', text: string, email: string } | { __typename?: 'EndingQuestionDefinition' } | { __typename?: 'FreeTextQuestionDefinition', text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', text: string, phoneNumber: string } } } | { __typename?: 'OtherMessage', id: string, text?: string | null, createdAt: any, isLast?: boolean | null, createdBy: ChannelUserType, anonymityLevel: AnonymityLevel } | { __typename?: 'Question', id: string, text?: string | null, createdAt: any, isLast?: boolean | null, createdBy: ChannelUserType, anonymityLevel: AnonymityLevel, definition: { __typename?: 'CommentQuestionDefinition', optional?: boolean | null } | { __typename?: 'EmailContactQuestionDefinition', optional?: boolean | null, text: string, email: string } | { __typename?: 'EndingQuestionDefinition', optional?: boolean | null } | { __typename?: 'FreeTextQuestionDefinition', optional?: boolean | null, text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', optional?: boolean | null, text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', optional?: boolean | null, text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', optional?: boolean | null, text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', optional?: boolean | null, text: string, phoneNumber: string } } | { __typename?: 'ScaleAnswer', value: Array<number>, statementIndex?: number | null, comment?: string | null, id: string, text: string, createdAt: any, isLast?: boolean | null, createdBy: ChannelUserType, anonymityLevel: AnonymityLevel, question: { __typename?: 'Question', definition: { __typename?: 'CommentQuestionDefinition' } | { __typename?: 'EmailContactQuestionDefinition', text: string, email: string } | { __typename?: 'EndingQuestionDefinition' } | { __typename?: 'FreeTextQuestionDefinition', text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', text: string, phoneNumber: string } } } | { __typename?: 'SelectAnswer', value: Array<number>, id: string, text: string, createdAt: any, isLast?: boolean | null, createdBy: ChannelUserType, anonymityLevel: AnonymityLevel, question: { __typename?: 'Question', definition: { __typename?: 'CommentQuestionDefinition' } | { __typename?: 'EmailContactQuestionDefinition', text: string, email: string } | { __typename?: 'EndingQuestionDefinition' } | { __typename?: 'FreeTextQuestionDefinition', text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', text: string, phoneNumber: string } } }> | null } | null };

export type LogAiSurveySummaryAbInteractionMutationVariables = Exact<{
  input: AiSurveySummaryAbInteractionInput;
}>;


export type LogAiSurveySummaryAbInteractionMutation = { __typename?: 'Mutation', logAiSurveySummaryAbInteraction: boolean };

export type ClearAiSurveySummaryCacheMutationVariables = Exact<{
  accessToken: Scalars['String']['input'];
  hash: Scalars['String']['input'];
}>;


export type ClearAiSurveySummaryCacheMutation = { __typename?: 'Mutation', clearAiSurveySummaryCache: { __typename?: 'AiSurveySummaryCacheClearResult', cacheCleared: boolean, limitReached: boolean } };

export type CreateChannelMutationVariables = Exact<{
  accessKey: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateChannelMutation = { __typename?: 'Mutation', createChannel?: { __typename?: 'ChannelWithStartingMessages', channel: { __typename?: 'Channel', id: string, isFinished: boolean, anonymityLevel: AnonymityLevel, allowedAnonymities: Array<AnonymityLevel>, anonymityLocked: boolean, public: boolean, remainingQuestions: number, totalQuestions: number, allowedLanguages: Array<{ __typename?: 'Language', id: string, code: string }>, language: { __typename?: 'Language', id: string, code: string }, reactions?: Array<{ __typename?: 'Reaction', id: string, channelId: string, messageId?: string | null, respondentId: string, respondentFullName?: string | null, text: string, createdAt: any }> | null }, startingMessages?: Array<{ __typename: 'EndingMessage', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'FreeTextAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'OtherMessage', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'Question', id: string, text?: string | null, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, definition: { __typename?: 'CommentQuestionDefinition', optional?: boolean | null } | { __typename?: 'EmailContactQuestionDefinition', optional?: boolean | null, text: string, email: string } | { __typename?: 'EndingQuestionDefinition', optional?: boolean | null } | { __typename?: 'FreeTextQuestionDefinition', optional?: boolean | null, text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', optional?: boolean | null, text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', optional?: boolean | null, text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', optional?: boolean | null, text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', optional?: boolean | null, text: string, phoneNumber: string }, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'ScaleAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } } | { __typename: 'SelectAnswer', id: string, text: string, createdAt: any, createdBy: ChannelUserType, isLast?: boolean | null, anonymityLevel: AnonymityLevel, sentOn: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean } }> | null } | null };

export type VerifyPhoneNumbersMutationVariables = Exact<{
  phoneNumbers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type VerifyPhoneNumbersMutation = { __typename?: 'Mutation', verifyPhoneNumbers: Array<{ __typename?: 'TwilioLookUpResponse', specifiedPhoneNumber: string, phoneNumber?: string | null, twilioError?: { __typename?: 'TwilioLookUpResponseErr', code: string } | null }> };

export type LogFeEventMutationVariables = Exact<{
  eventType: FeEventType;
  payload: FeEventPayload;
}>;


export type LogFeEventMutation = { __typename?: 'Mutation', logFEEvent: boolean };

export type SetLanguageForRespondentMutationVariables = Exact<{
  channelId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
}>;


export type SetLanguageForRespondentMutation = { __typename?: 'Mutation', setLanguageForRespondent?: { __typename?: 'Respondent', id: string, language?: { __typename?: 'Language', id: string, code: string } | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  username: Scalars['String']['input'];
  origin: Origin;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type ChangePasswordMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
  deviceToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'BaseUser', username: string } };

export type UpdateReportAccessMetricsMutationVariables = Exact<{
  reportAccessKey: Scalars['String']['input'];
  topicGroupId?: InputMaybe<Scalars['Int']['input']>;
  topSeen?: InputMaybe<Scalars['Boolean']['input']>;
  bottomSeen?: InputMaybe<Scalars['Boolean']['input']>;
  questionsSeen?: InputMaybe<Scalars['Int']['input']>;
  questionsTotal?: InputMaybe<Scalars['Int']['input']>;
  timeSpentInSec?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateReportAccessMetricsMutation = { __typename?: 'Mutation', updateReportAccessMetrics?: boolean | null };

export type GenerateOtpMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type GenerateOtpMutation = { __typename?: 'Mutation', generateOtp: boolean };

export type RemoveRespondentFromSurveyGroupWithDateMutationVariables = Exact<{
  surveyGroupId: Scalars['ID']['input'];
  respondentId: Scalars['ID']['input'];
  dateFrom: Scalars['Date']['input'];
  accessToken: Scalars['String']['input'];
}>;


export type RemoveRespondentFromSurveyGroupWithDateMutation = { __typename?: 'Mutation', removeRespondentFromSurveyGroupWithDate: boolean };

export type DeleteRespondentMutationVariables = Exact<{
  respondentId: Scalars['ID']['input'];
  accessToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteRespondentMutation = { __typename?: 'Mutation', deleteRespondent: boolean };

export type ReopenSurveyMutationVariables = Exact<{
  input: ReopenSurveyInput;
}>;


export type ReopenSurveyMutation = { __typename?: 'Mutation', reopenSurvey: { __typename?: 'Survey', id: string } };

export type CreateSurveyMutationVariables = Exact<{
  input: CreateSurveyInput;
}>;


export type CreateSurveyMutation = { __typename?: 'Mutation', createSurvey: { __typename?: 'Survey', id: string } };

export type SendInvitationAgainMutationVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  respondentId: Scalars['ID']['input'];
  templateUid?: InputMaybe<Scalars['String']['input']>;
  accessToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendInvitationAgainMutation = { __typename?: 'Mutation', sendInvitationAgain: boolean };

export type UpdateSurveyMutationVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  input: UpdateSurveyInput;
}>;


export type UpdateSurveyMutation = { __typename?: 'Mutation', updateSurvey: { __typename?: 'Survey', id: string } };

export type SendReportOpenMetricsMutationVariables = Exact<{
  reportAccessKey: Scalars['String']['input'];
  channelIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  reportView: ReportOpenMetricsView;
  sysAdmin: Scalars['Boolean']['input'];
  orgAdmin: Scalars['Boolean']['input'];
}>;


export type SendReportOpenMetricsMutation = { __typename?: 'Mutation', sendReportOpenMetrics: boolean };

export type UpdateRespondentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateRespondentFromReportInput;
  accessToken: Scalars['String']['input'];
}>;


export type UpdateRespondentMutation = { __typename?: 'Mutation', updateRespondentFromReport: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null } };

export type SetUserSummaryNotificationsMutationVariables = Exact<{
  auth?: InputMaybe<OnePlaceAuthInput>;
  on: Scalars['Boolean']['input'];
}>;


export type SetUserSummaryNotificationsMutation = { __typename?: 'Mutation', setUserSummaryNotifications: boolean };

export type SetRespondentNewAnswersNotificationsMutationVariables = Exact<{
  auth?: InputMaybe<OnePlaceAuthInput>;
  respondentId: Scalars['ID']['input'];
  notificationLevel: NotificationLevel;
}>;


export type SetRespondentNewAnswersNotificationsMutation = { __typename?: 'Mutation', setRespondentNewAnswersNotifications: boolean };

export type SendReactionMutationVariables = Exact<{
  accessToken: Scalars['String']['input'];
  channelId: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
}>;


export type SendReactionMutation = { __typename?: 'Mutation', sendReaction: { __typename?: 'Reaction', id: string, channelId: string, messageId?: string | null, respondentId: string, text: string, createdAt: any } };

export type GetMessagesQueryVariables = Exact<{
  channelId: Scalars['ID']['input'];
}>;


export type GetMessagesQuery = { __typename?: 'Query', messages?: Array<{ __typename?: 'EndingMessage', id: string, text?: string | null, createdAt: any, isLast?: boolean | null, createdBy: ChannelUserType, anonymityLevel: AnonymityLevel } | { __typename?: 'FreeTextAnswer', id: string, text: string, createdAt: any, isLast?: boolean | null, createdBy: ChannelUserType, anonymityLevel: AnonymityLevel, question: { __typename?: 'Question', definition: { __typename?: 'CommentQuestionDefinition' } | { __typename?: 'EmailContactQuestionDefinition', text: string, email: string } | { __typename?: 'EndingQuestionDefinition' } | { __typename?: 'FreeTextQuestionDefinition', text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', text: string, phoneNumber: string } } } | { __typename?: 'OtherMessage', id: string, text?: string | null, createdAt: any, isLast?: boolean | null, createdBy: ChannelUserType, anonymityLevel: AnonymityLevel } | { __typename?: 'Question', id: string, text?: string | null, createdAt: any, isLast?: boolean | null, createdBy: ChannelUserType, anonymityLevel: AnonymityLevel, definition: { __typename?: 'CommentQuestionDefinition', optional?: boolean | null } | { __typename?: 'EmailContactQuestionDefinition', optional?: boolean | null, text: string, email: string } | { __typename?: 'EndingQuestionDefinition', optional?: boolean | null } | { __typename?: 'FreeTextQuestionDefinition', optional?: boolean | null, text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', optional?: boolean | null, text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', optional?: boolean | null, text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', optional?: boolean | null, text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', optional?: boolean | null, text: string, phoneNumber: string } } | { __typename?: 'ScaleAnswer', value: Array<number>, statementIndex?: number | null, comment?: string | null, id: string, text: string, createdAt: any, isLast?: boolean | null, createdBy: ChannelUserType, anonymityLevel: AnonymityLevel, question: { __typename?: 'Question', definition: { __typename?: 'CommentQuestionDefinition' } | { __typename?: 'EmailContactQuestionDefinition', text: string, email: string } | { __typename?: 'EndingQuestionDefinition' } | { __typename?: 'FreeTextQuestionDefinition', text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', text: string, phoneNumber: string } } } | { __typename?: 'SelectAnswer', value: Array<number>, id: string, text: string, createdAt: any, isLast?: boolean | null, createdBy: ChannelUserType, anonymityLevel: AnonymityLevel, question: { __typename?: 'Question', definition: { __typename?: 'CommentQuestionDefinition' } | { __typename?: 'EmailContactQuestionDefinition', text: string, email: string } | { __typename?: 'EndingQuestionDefinition' } | { __typename?: 'FreeTextQuestionDefinition', text: string } | { __typename?: 'PersonMultiselectQuestionDefinition', text: string, selectedRange: any, organizationRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null }> } | { __typename?: 'ScaleQuestionDefinition', text: string, choices: Array<string>, statements: Array<string>, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, id: string } | { __typename?: 'SelectQuestionDefinition', text: string, choices: Array<string>, selectedRange: any } | { __typename?: 'SmsContactQuestionDefinition', text: string, phoneNumber: string } } }> | null };

export type GetChannelQueryVariables = Exact<{
  channelId: Scalars['ID']['input'];
}>;


export type GetChannelQuery = { __typename?: 'Query', channel?: { __typename?: 'Channel', id: string, anonymityLevel: AnonymityLevel, anonymityLocked: boolean, isFinished: boolean, isOpen: boolean, createdAt: any, endsAt?: any | null, topicName: string, allowedAnonymities: Array<AnonymityLevel>, allowedLanguages: Array<{ __typename?: 'Language', id: string, code: string }>, reactions?: Array<{ __typename?: 'Reaction', id: string, channelId: string, messageId?: string | null, respondentId: string, respondentFullName?: string | null, text: string, createdAt: any }> | null, respondent?: { __typename?: 'Respondent', firstname?: string | null, surname?: string | null, user?: { __typename?: 'User', username: string, id: string } | null, contacts?: Array<{ __typename?: 'Contact', value: string, type: ContactType, source?: ContactSource | null }> | null, organization: { __typename?: 'Organization', id: string, name: string } } | null } | null };

export type GetChannelSlugForIdNumberQueryVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  respondentIdNo: Scalars['String']['input'];
}>;


export type GetChannelSlugForIdNumberQuery = { __typename?: 'Query', getChannelSlugForIdNumber: string };

export type IsAccessTokenValidQueryVariables = Exact<{ [key: string]: never; }>;


export type IsAccessTokenValidQuery = { __typename?: 'Query', isAccessTokenValid: { __typename?: 'AccessToken', expireAt?: any | null, status?: AccessTokenStatus | null, consent?: boolean | null, user?: { __typename?: 'User', id: string, marketingConsent: boolean, username: string, firstname?: string | null, systemRole: UserSysRole, surname?: string | null, summaryNotifications: boolean, organization?: { __typename?: 'Organization', id: string, name: string, systemName: string, primaryLanguageCode: string } | null, respondents?: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole, isLeader: boolean, isReportRecipient: boolean, newAnswersNotifications?: NotificationLevel | null, language?: { __typename?: 'Language', id: string, code: string } | null, contacts?: Array<{ __typename?: 'Contact', value: string, type: ContactType, source?: ContactSource | null }> | null, channels?: Array<{ __typename?: 'Channel', id: string, isOpen: boolean, isFinished: boolean, createdAt: any, sendAt: any, endsAt?: any | null, topicName: string, surveyFinished: boolean, disabled: boolean, isFinishedByRespondent: boolean, containsOriginalAnonymity: boolean, reactions?: Array<{ __typename?: 'Reaction', id: string }> | null }> | null, reports?: Array<{ __typename?: 'ReportAccess', accessKey: string, topicName: string, survey?: { __typename?: 'Survey', sendAt: any, endsAt?: any | null } | null, surveyGroup?: { __typename?: 'SurveyGroup', from?: any | null, to?: any | null } | null, unreadMessages?: { __typename?: 'UnreadMessages', count?: number | null, from?: any | null } | null }> | null, organization: { __typename?: 'Organization', id: string, name: string, systemName: string, companyId?: string | null, primaryLanguageCode: string, processNotificationsDefault: NotificationLevel, processNotificationsLocked: boolean, featureNames?: Array<string | null> | null, productVersionHistory?: Array<{ __typename?: 'ProductVersion', product: string, licenceCount?: number | null, validFrom: any, validTo: any }> | null, languages: Array<{ __typename?: 'Language', code: string }> } }> | null } | null } };

export type ChannelOverviewQueryVariables = Exact<{
  channelSlug: Scalars['ID']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChannelOverviewQuery = { __typename?: 'Query', channelOverview: { __typename?: 'ChannelOverview', respondents?: Array<{ __typename?: 'PublicRespondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole, isLeader: boolean, isReportRecipient: boolean, newAnswersNotifications?: NotificationLevel | null, channels?: Array<{ __typename?: 'Channel', id: string, isOpen: boolean, isFinished: boolean, createdAt: any, sendAt: any, endsAt?: any | null, topicName: string, surveyFinished: boolean, disabled: boolean, isFinishedByRespondent: boolean, containsOriginalAnonymity: boolean, reactions?: Array<{ __typename?: 'Reaction', id: string }> | null }> | null, reports?: Array<{ __typename?: 'ReportAccess', accessKey: string, topicName: string, survey?: { __typename?: 'Survey', sendAt: any, endsAt?: any | null } | null, surveyGroup?: { __typename?: 'SurveyGroup', from?: any | null, to?: any | null } | null, unreadMessages?: { __typename?: 'UnreadMessages', count?: number | null, from?: any | null } | null }> | null, organization: { __typename?: 'Organization', id: string, name: string, processNotificationsDefault: NotificationLevel, processNotificationsLocked: boolean, featureNames?: Array<string | null> | null } }> | null, user?: { __typename?: 'OverviewUser', id: string, username: string, firstname: string, surname: string, intercomHash: string, summaryNotifications: boolean } | null } };

export type ReportSequenceRespondentDetailQueryQueryVariables = Exact<{
  languageCode?: InputMaybe<Scalars['String']['input']>;
  accessToken: Scalars['String']['input'];
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  respondentId: Scalars['ID']['input'];
  seqDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportSequenceRespondentDetailQueryQuery = { __typename?: 'Query', getProcessReportRespondentDetail: { __typename?: 'ProcessReportRespondentDetail', id: string, identifier: string, reportRoots: Array<string>, hiringAdditionalData?: Array<{ __typename?: 'HiringAdditionalData', respondentId: string, position?: string | null, isHired?: boolean | null, surveyId?: string | null, isRejected?: boolean | null, recruiterName?: string | null }> | null, groupedRespondents: Array<{ __typename?: 'GroupedRespondents', addedOn: any, deletedRespondents?: Array<string> | null, respondents: Array<{ __typename?: 'Respondent', id: string, preferredContactType: ContactType, firstname?: string | null, surname?: string | null, deleted: boolean, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string, phoneNumber?: { __typename?: 'PhoneNumber', countryCallingCode: string, nationalNumber: string } | null }> | null }>, surveys: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, sendAt: any, endsAt?: any | null, public?: boolean | null, respondentIds: Array<string>, topicGroup?: { __typename?: 'TopicGroup', id: string } | null, publicChannels: Array<{ __typename?: 'PublicChannel', id: string, respondentId: string, lastRemindedAt?: any | null, maxAnonymousHighlightedLevel: number, withAnswer: boolean, finishedAt?: any | null, isFinishedByRespondent: boolean }> }>, hiringSurveys?: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, sendAt: any, endsAt?: any | null, respondentIds: Array<string>, topicGroup?: { __typename?: 'TopicGroup', id: string } | null, publicChannels: Array<{ __typename?: 'PublicChannel', id: string, respondentId: string, lastRemindedAt?: any | null, maxAnonymousHighlightedLevel: number, withAnswer: boolean, finishedAt?: any | null, isFinishedByRespondent: boolean }> }> | null, hiringAdditionalData?: Array<{ __typename?: 'HiringAdditionalData', respondentId: string, position?: string | null, isHired?: boolean | null, isRejected?: boolean | null, recruiterName?: string | null }> | null, undeliveredInvitations?: Array<{ __typename?: 'UndeliveredInvitations', respondentId: string, undeliveredSurveyInvitations?: Array<{ __typename?: 'UndeliveredInvitation', surveyId: string, contact: string, status?: string | null }> | null } | null> | null, metricQuestionsForRespondent: Array<{ __typename?: 'MetricQuestionForRespondent', respondentId: string, answers: Array<{ __typename?: 'MetricAnswer', topicGroupId: string, value?: number | null }> }>, hasUnreadMessages?: Array<{ __typename?: 'HasUnreadMessages', respondentId: string, unreadMessages?: Array<string> | null }> | null }>, questions: Array<{ __typename?: 'PubQuestion', id: string, index: string, text: string, type: QuestionType, selectedRange?: string | null, answersLocal?: Array<string> | null, statementsLocal?: Array<string> | null, showEscapeOption?: boolean | null, isRankingScale?: boolean | null, reportIndex?: string | null, answersToHighlight?: Array<string> | null, metrics: Array<string | null>, topicGroupId?: string | null }>, responses: Array<{ __typename?: 'PubResponse', id: string, surveyId: string, respondentId: string, topicGroupId: string, anonymous: boolean, originalAnonymous: boolean, finished: boolean, additionallyAnonymized: boolean, seqDate?: any | null, reactions?: Array<{ __typename?: 'Reaction', id: string, channelId: string, messageId?: string | null, respondentId: string, respondentFullName?: string | null, text: string, createdAt: any }> | null, messages?: Array<{ __typename?: 'PubMessage', id: string, questionDefinitionIndex: string, text?: string | null, value?: string | null, anonymous: boolean, originalAnonymous: boolean, statementIndex?: number | null, comment?: string | null, date: any, hasAlert: boolean }> | null }>, respondents: Array<{ __typename?: 'PubRespondent', id: string, firstname: string, surname: string, addedOn?: any | null }>, keyPoints?: Array<{ __typename?: 'KeyPoint', answerIds: Array<string>, point: string, sentiment: Sentiment }> | null, surveyGroup?: { __typename?: 'SurveyGroup', id: string, from?: any | null, to?: any | null, topicGroup: { __typename?: 'TopicGroup', id: string, typeCode?: TopicGroupTypeCode | null, hideOnboardingParts?: boolean | null, allowedAnonymities: Array<AnonymityLevel>, defaultAnonymity: AnonymityLevel, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null }, steps: Array<{ __typename?: 'SurveyGroupStep', daysFromStart: number, hasMetricQuestion: boolean, status: ProcessStatus, hasNotStarted?: boolean | null, notstartedReason?: Array<NotstartedSurveyReason> | null, surveys: Array<{ __typename?: 'BasicSurveyInfo', id: string, sendAt: any, endsAt?: any | null, seqDate?: any | null, status: SurveyStatus, public?: boolean | null }>, processStep: { __typename?: 'ProcessStep', id: string, startOffsetMins?: number | null, endOffsetMins?: number | null, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }>, stepTopicGroup: { __typename?: 'TopicGroup', allowedAnonymities: Array<AnonymityLevel>, defaultAnonymity: AnonymityLevel, id: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null } } }> } | null, metadata: { __typename?: 'PubMetadata', surveyEnd?: any | null, surveyStart?: any | null, status: SurveyStatus, accepted?: boolean | null, adminEmails?: Array<string> | null, organization: { __typename?: 'Organization', id: string, name: string, featureNames?: Array<string | null> | null, config?: { __typename?: 'OrganizationConfig', countryCallingCode: string } | null }, language?: { __typename?: 'Language', id: string, code: string } | null, respondent?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, createdAt: any, intercomHash?: string | null, organizationRole: UserOrgRole, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string, source?: ContactSource | null }> | null, organization: { __typename?: 'Organization', id: string, name: string, companyId?: string | null, featureNames?: Array<string | null> | null }, user?: { __typename?: 'User', id: string, username: string, firstname?: string | null, surname?: string | null, intercomHash?: string | null, createdAt?: any | null, systemRole: UserSysRole, respondents?: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole }> | null } | null } | null, productVersion?: { __typename?: 'ProductVersion', validFrom: any, validTo: any, product: string } | null }, teams: Array<{ __typename?: 'PubTeams', id: string, teamName: string, directMembers?: Array<string> | null, memberTeams?: Array<string> | null, teamLeader?: string | null }> } };

export type SecureRespondentDetailQueryVariables = Exact<{
  languageCode?: InputMaybe<Scalars['String']['input']>;
  accessToken: Scalars['String']['input'];
  seqDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type SecureRespondentDetailQuery = { __typename?: 'Query', getSecureRespondentDetail: { __typename?: 'ProcessReportRespondentDetail', id: string, identifier: string, reportRoots: Array<string>, hiringAdditionalData?: Array<{ __typename?: 'HiringAdditionalData', respondentId: string, position?: string | null, isHired?: boolean | null, surveyId?: string | null, isRejected?: boolean | null, recruiterName?: string | null }> | null, groupedRespondents: Array<{ __typename?: 'GroupedRespondents', addedOn: any, deletedRespondents?: Array<string> | null, respondents: Array<{ __typename?: 'Respondent', id: string, preferredContactType: ContactType, firstname?: string | null, surname?: string | null, deleted: boolean, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string, phoneNumber?: { __typename?: 'PhoneNumber', countryCallingCode: string, nationalNumber: string } | null }> | null }>, surveys: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, sendAt: any, endsAt?: any | null, public?: boolean | null, respondentIds: Array<string>, topicGroup?: { __typename?: 'TopicGroup', id: string } | null, publicChannels: Array<{ __typename?: 'PublicChannel', id: string, respondentId: string, lastRemindedAt?: any | null, maxAnonymousHighlightedLevel: number, withAnswer: boolean, finishedAt?: any | null, isFinishedByRespondent: boolean }> }>, hiringSurveys?: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, sendAt: any, endsAt?: any | null, respondentIds: Array<string>, topicGroup?: { __typename?: 'TopicGroup', id: string } | null, publicChannels: Array<{ __typename?: 'PublicChannel', id: string, respondentId: string, lastRemindedAt?: any | null, maxAnonymousHighlightedLevel: number, withAnswer: boolean, finishedAt?: any | null, isFinishedByRespondent: boolean }> }> | null, hiringAdditionalData?: Array<{ __typename?: 'HiringAdditionalData', respondentId: string, position?: string | null, isHired?: boolean | null, isRejected?: boolean | null, recruiterName?: string | null }> | null, undeliveredInvitations?: Array<{ __typename?: 'UndeliveredInvitations', respondentId: string, undeliveredSurveyInvitations?: Array<{ __typename?: 'UndeliveredInvitation', surveyId: string, contact: string, status?: string | null }> | null } | null> | null, metricQuestionsForRespondent: Array<{ __typename?: 'MetricQuestionForRespondent', respondentId: string, answers: Array<{ __typename?: 'MetricAnswer', topicGroupId: string, value?: number | null }> }>, hasUnreadMessages?: Array<{ __typename?: 'HasUnreadMessages', respondentId: string, unreadMessages?: Array<string> | null }> | null }>, questions: Array<{ __typename?: 'PubQuestion', id: string, index: string, text: string, type: QuestionType, selectedRange?: string | null, answersLocal?: Array<string> | null, statementsLocal?: Array<string> | null, showEscapeOption?: boolean | null, isRankingScale?: boolean | null, reportIndex?: string | null, answersToHighlight?: Array<string> | null, metrics: Array<string | null>, topicGroupId?: string | null }>, responses: Array<{ __typename?: 'PubResponse', id: string, surveyId: string, respondentId: string, topicGroupId: string, anonymous: boolean, originalAnonymous: boolean, finished: boolean, additionallyAnonymized: boolean, seqDate?: any | null, reactions?: Array<{ __typename?: 'Reaction', id: string, channelId: string, messageId?: string | null, respondentId: string, respondentFullName?: string | null, text: string, createdAt: any }> | null, messages?: Array<{ __typename?: 'PubMessage', id: string, questionDefinitionIndex: string, text?: string | null, value?: string | null, anonymous: boolean, originalAnonymous: boolean, statementIndex?: number | null, comment?: string | null, date: any, hasAlert: boolean }> | null }>, respondents: Array<{ __typename?: 'PubRespondent', id: string, firstname: string, surname: string, addedOn?: any | null }>, keyPoints?: Array<{ __typename?: 'KeyPoint', answerIds: Array<string>, point: string, sentiment: Sentiment }> | null, surveyGroup?: { __typename?: 'SurveyGroup', id: string, from?: any | null, to?: any | null, topicGroup: { __typename?: 'TopicGroup', id: string, typeCode?: TopicGroupTypeCode | null, hideOnboardingParts?: boolean | null, allowedAnonymities: Array<AnonymityLevel>, defaultAnonymity: AnonymityLevel, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null }, steps: Array<{ __typename?: 'SurveyGroupStep', daysFromStart: number, hasMetricQuestion: boolean, status: ProcessStatus, hasNotStarted?: boolean | null, notstartedReason?: Array<NotstartedSurveyReason> | null, surveys: Array<{ __typename?: 'BasicSurveyInfo', id: string, sendAt: any, endsAt?: any | null, seqDate?: any | null, status: SurveyStatus, public?: boolean | null }>, processStep: { __typename?: 'ProcessStep', id: string, startOffsetMins?: number | null, endOffsetMins?: number | null, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }>, stepTopicGroup: { __typename?: 'TopicGroup', allowedAnonymities: Array<AnonymityLevel>, defaultAnonymity: AnonymityLevel, id: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null } } }> } | null, metadata: { __typename?: 'PubMetadata', surveyEnd?: any | null, surveyStart?: any | null, status: SurveyStatus, accepted?: boolean | null, adminEmails?: Array<string> | null, organization: { __typename?: 'Organization', id: string, name: string, featureNames?: Array<string | null> | null, config?: { __typename?: 'OrganizationConfig', countryCallingCode: string } | null }, language?: { __typename?: 'Language', id: string, code: string } | null, respondent?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, createdAt: any, intercomHash?: string | null, organizationRole: UserOrgRole, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string, source?: ContactSource | null }> | null, organization: { __typename?: 'Organization', id: string, name: string, companyId?: string | null, featureNames?: Array<string | null> | null }, user?: { __typename?: 'User', id: string, username: string, firstname?: string | null, surname?: string | null, intercomHash?: string | null, createdAt?: any | null, systemRole: UserSysRole, respondents?: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole }> | null } | null } | null, productVersion?: { __typename?: 'ProductVersion', validFrom: any, validTo: any, product: string } | null }, teams: Array<{ __typename?: 'PubTeams', id: string, teamName: string, directMembers?: Array<string> | null, memberTeams?: Array<string> | null, teamLeader?: string | null }> } };

export type SurveyPublicInfoQueryVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  langCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SurveyPublicInfoQuery = { __typename?: 'Query', surveyPublicInfo?: { __typename?: 'SurveyPublicInfo', id: string, topicGroupName?: string | null, organizationName: string, endsAt?: any | null, status: SurveyStatus } | null };

export type GetComparsionDataForProcessReportQueryVariables = Exact<{
  accessToken: Scalars['String']['input'];
  periods: Array<DateRangeInput> | DateRangeInput;
  teamsFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetComparsionDataForProcessReportQuery = { __typename?: 'Query', getComparsionDataForProcessReport: { __typename?: 'ProcessReportComparsion', id: string, stepStatistics: Array<{ __typename?: 'StepStatistics', periodIndex: number, stepId: string, avgMetric: number, statistics: { __typename?: 'ProcessWidgets', withoutProblems: { __typename?: 'Widget', denominator: number, numerator: number }, responseRate: { __typename?: 'Widget', numerator: number, denominator: number }, anonymityRate: { __typename?: 'Widget', numerator: number, denominator: number }, finishedRate: { __typename?: 'Widget', numerator: number, denominator: number } } }> } };

export type GetProcessReportRespondentsQueryVariables = Exact<{
  accessToken: Scalars['String']['input'];
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  teamsFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  recruiterIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  managerIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  withoutDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  showOnlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProcessReportRespondentsQuery = { __typename?: 'Query', getProcessReportRespondents: { __typename?: 'SurveyGroupRespondentsResult', totalCount: number, data: Array<{ __typename?: 'GroupedRespondents', addedOn: any, deletedRespondents?: Array<string> | null, metricQuestionsForRespondent: Array<{ __typename?: 'MetricQuestionForRespondent', respondentId: string, answers: Array<{ __typename?: 'MetricAnswer', topicGroupId: string, value?: number | null }> }>, creditsToReturn?: Array<{ __typename?: 'CreditsToReturn', respondentId: string, creditsToReturn?: number | null }> | null, respondents: Array<{ __typename?: 'Respondent', id: string, preferredContactType: ContactType, firstname?: string | null, surname?: string | null, deleted: boolean, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string, phoneNumber?: { __typename?: 'PhoneNumber', countryCallingCode: string, nationalNumber: string } | null }> | null }>, surveys: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, sendAt: any, endsAt?: any | null, respondentIds: Array<string>, topicGroup?: { __typename?: 'TopicGroup', id: string } | null, publicChannels: Array<{ __typename?: 'PublicChannel', id: string, respondentId: string, lastRemindedAt?: any | null, maxAnonymousHighlightedLevel: number, withAnswer: boolean, isFinishedByRespondent: boolean, finishedAt?: any | null }> }>, hiringSurveys?: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, sendAt: any, endsAt?: any | null, respondentIds: Array<string>, topicGroup?: { __typename?: 'TopicGroup', id: string } | null, publicChannels: Array<{ __typename?: 'PublicChannel', id: string, respondentId: string, lastRemindedAt?: any | null, maxAnonymousHighlightedLevel: number, withAnswer: boolean, isFinishedByRespondent: boolean, finishedAt?: any | null }> }> | null, hiringAdditionalData?: Array<{ __typename?: 'HiringAdditionalData', respondentId: string, position?: string | null, isHired?: boolean | null, isRejected?: boolean | null, recruiterName?: string | null }> | null, undeliveredInvitations?: Array<{ __typename?: 'UndeliveredInvitations', respondentId: string, undeliveredSurveyInvitations?: Array<{ __typename?: 'UndeliveredInvitation', surveyId: string, contact: string, status?: string | null }> | null } | null> | null, hasUnreadMessages?: Array<{ __typename?: 'HasUnreadMessages', respondentId: string, unreadMessages?: Array<string> | null }> | null }> } };

export type LastMessagesForRespondentQueryVariables = Exact<{
  surveyIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  respondentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  accessToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type LastMessagesForRespondentQuery = { __typename?: 'Query', lastMessagesForRespondent: Array<{ __typename?: 'MessageStatus', id: string, messageStatus?: string | null, processed: boolean, createdAt: any, error?: string | null, surveyId: string, respondentId: string }> };

export type GetReportQueryVariables = Exact<{
  languageCode?: InputMaybe<Scalars['String']['input']>;
  accessToken: Scalars['String']['input'];
  reportDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetReportQuery = { __typename?: 'Query', getReport: { __typename?: 'PubReport', id: string, addedOnFrom?: any | null, addedOnTo?: any | null, identifier: string, totalRespondents?: number | null, surveyKeywordsGenerated: boolean, anonymityEnabled: boolean, anonymityForced: boolean, reportRoots?: Array<string> | null, sequenceFrom?: any | null, sequenceTo?: any | null, anonymitySettings?: { __typename?: 'AnonymitySettings', default?: AnonymityLevel | null, allowedLevels?: Array<AnonymityLevel> | null } | null, firstSurvey?: { __typename?: 'Survey', public?: boolean | null } | null, hiringAdditionalData?: Array<{ __typename?: 'HiringAdditionalData', respondentId: string, surveyId?: string | null, position?: string | null, isHired?: boolean | null, isRejected?: boolean | null, recruiterName?: string | null }> | null, responses?: Array<{ __typename?: 'PubResponse', id: string, surveyId: string, respondentId: string, topicGroupId: string, anonymous: boolean, originalAnonymous: boolean, finished: boolean, additionallyAnonymized: boolean, seqDate?: any | null, messages?: Array<{ __typename?: 'PubMessage', id: string, questionDefinitionIndex: string, statementIndex?: number | null, comment?: string | null, text?: string | null, value?: string | null, anonymous: boolean, originalAnonymous: boolean, date: any }> | null, reactions?: Array<{ __typename?: 'Reaction', id: string, channelId: string, messageId?: string | null, respondentId: string, text: string, createdAt: any }> | null }> | null, questions?: Array<{ __typename?: 'PubQuestion', id: string, index: string, text: string, type: QuestionType, selectedRange?: string | null, answersLocal?: Array<string> | null, statementsLocal?: Array<string> | null, showEscapeOption?: boolean | null, isRankingScale?: boolean | null, reportIndex?: string | null, answersToHighlight?: Array<string> | null }> | null, respondents?: Array<{ __typename?: 'PubRespondent', id: string, firstname: string, surname: string, addedOn?: any | null }> | null, metadata?: { __typename?: 'PubMetadata', surveyEnd?: any | null, surveyStart?: any | null, status: SurveyStatus, accepted?: boolean | null, topicGroupId?: string | null, adminEmails?: Array<string> | null, organizationDepth: number, organization: { __typename?: 'Organization', id: string, name: string, featureNames?: Array<string | null> | null, primaryLanguageCode: string, languages: Array<{ __typename?: 'Language', code: string }> }, language?: { __typename?: 'Language', id: string, code: string } | null, respondent?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, intercomHash?: string | null, createdAt: any, organizationRole: UserOrgRole, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string, source?: ContactSource | null }> | null, organization: { __typename?: 'Organization', id: string, name: string, companyId?: string | null, featureNames?: Array<string | null> | null }, user?: { __typename?: 'User', id: string, username: string, firstname?: string | null, surname?: string | null, intercomHash?: string | null, createdAt?: any | null, systemRole: UserSysRole, respondents?: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole }> | null } | null } | null, productVersion?: { __typename?: 'ProductVersion', validFrom: any, validTo: any, product: string } | null } | null, teams?: Array<{ __typename?: 'PubTeams', id: string, teamName: string, directMembers?: Array<string> | null, memberTeams?: Array<string> | null, teamLeader?: string | null }> | null, surveyGroup?: { __typename?: 'SurveyGroup', from?: any | null, to?: any | null, topicGroup: { __typename?: 'TopicGroup', id: string, typeCode?: TopicGroupTypeCode | null, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null }, steps: Array<{ __typename?: 'SurveyGroupStep', daysFromStart: number, processStep: { __typename?: 'ProcessStep', stepTopicGroup: { __typename?: 'TopicGroup', id: string, allowedAnonymities: Array<AnonymityLevel>, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null } } }> } | null, questionLabels?: Array<{ __typename?: 'QuestionLabel', questionDefinitionIndex: string, questionLabelComments?: Array<{ __typename?: 'QuestionLabelComments', label: string, commentIds?: Array<string> | null }> | null }> | null, source?: Array<{ __typename?: 'PubSource', respondentId: string, sourceId: string }> | null, reportDefinition?: { __typename?: 'PubReportDefinition', id: string, titleLocal?: string | null, aboutLocal?: string | null, sections?: Array<{ __typename?: 'PubSection', id: string, heading: string, headingLocal: string, descriptionLocal?: string | null, type: ReportSectionType, displayFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null, titleFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null, widgets?: Array<{ __typename?: 'PubWidget', id: string, questionDefinitionIndex?: string | null, headingLocal: string, type: string, descriptionLocal?: string | null, answersToHighlight?: Array<string> | null, values?: Array<string | null> | null, titleFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null, displayFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null }> | null }> | null, intro?: Array<{ __typename?: 'PubWidget', questionDefinitionIndex?: string | null, headingLocal: string, type: string, descriptionLocal?: string | null, answersToHighlight?: Array<string> | null, values?: Array<string | null> | null, numerator?: number | null, denominator?: number | null, additionallyAnonymized?: boolean | null, displayFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null }> | null } | null, additionalRespondentData?: Array<{ __typename?: 'AdditionalRespondentDataFromTeamio', channelId: string, position?: string | null, recruiter?: string | null, managers?: Array<string> | null, addedOn?: string | null }> | null } };

export type GetProcessReportQueryVariables = Exact<{
  languageCode?: InputMaybe<Scalars['String']['input']>;
  accessToken: Scalars['String']['input'];
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  teamsFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  recruiterIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  managerIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  withoutDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  showOnlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProcessReportQuery = { __typename?: 'Query', getProcessReport: { __typename?: 'ProcessReportInfoSub', id: string, identifier: string, totalRespondents?: number | null, filteredRespondents?: number | null, addedOnFrom?: any | null, addedOnTo?: any | null, reportRoots: Array<string>, hiringInfo?: { __typename?: 'HiringInfo', positions: Array<{ __typename?: 'HiringInfoItem', id: string, label: string, candidateIds: Array<string> }>, recruiters: Array<{ __typename?: 'HiringInfoItem', id: string, label: string, candidateIds: Array<string> }>, managers: Array<{ __typename?: 'HiringInfoItem', id: string, label: string, candidateIds: Array<string> }> } | null, groupedRespondents?: { __typename?: 'SurveyGroupRespondentsResult', totalCount: number, data: Array<{ __typename?: 'GroupedRespondents', addedOn: any, deletedRespondents?: Array<string> | null, metricQuestionsForRespondent: Array<{ __typename?: 'MetricQuestionForRespondent', respondentId: string, answers: Array<{ __typename?: 'MetricAnswer', topicGroupId: string, value?: number | null }> }>, respondents: Array<{ __typename?: 'Respondent', id: string, preferredContactType: ContactType, firstname?: string | null, surname?: string | null, deleted: boolean, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string, phoneNumber?: { __typename?: 'PhoneNumber', countryCallingCode: string, nationalNumber: string } | null }> | null }>, surveys: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, sendAt: any, endsAt?: any | null, public?: boolean | null, respondentIds: Array<string>, topicGroup?: { __typename?: 'TopicGroup', id: string } | null, publicChannels: Array<{ __typename?: 'PublicChannel', id: string, respondentId: string, lastRemindedAt?: any | null, maxAnonymousHighlightedLevel: number, withAnswer: boolean, isFinishedByRespondent: boolean, finishedAt?: any | null }> }>, hiringSurveys?: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, sendAt: any, endsAt?: any | null, respondentIds: Array<string>, topicGroup?: { __typename?: 'TopicGroup', id: string } | null, publicChannels: Array<{ __typename?: 'PublicChannel', id: string, respondentId: string, lastRemindedAt?: any | null, maxAnonymousHighlightedLevel: number, withAnswer: boolean, isFinishedByRespondent: boolean, finishedAt?: any | null }> }> | null, hiringAdditionalData?: Array<{ __typename?: 'HiringAdditionalData', respondentId: string, position?: string | null, isHired?: boolean | null, isRejected?: boolean | null, recruiterName?: string | null }> | null, undeliveredInvitations?: Array<{ __typename?: 'UndeliveredInvitations', respondentId: string, undeliveredSurveyInvitations?: Array<{ __typename?: 'UndeliveredInvitation', surveyId: string, contact: string, status?: string | null }> | null } | null> | null, hasUnreadMessages?: Array<{ __typename?: 'HasUnreadMessages', respondentId: string, unreadMessages?: Array<string> | null }> | null }> } | null, metadata: { __typename?: 'PubMetadata', surveyEnd?: any | null, surveyStart?: any | null, status: SurveyStatus, accepted?: boolean | null, adminEmails?: Array<string> | null, organization: { __typename?: 'Organization', id: string, name: string, featureNames?: Array<string | null> | null, config?: { __typename?: 'OrganizationConfig', countryCallingCode: string } | null }, language?: { __typename?: 'Language', id: string, code: string } | null, respondent?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole, createdAt: any, intercomHash?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string, source?: ContactSource | null }> | null, organization: { __typename?: 'Organization', id: string, name: string, companyId?: string | null, featureNames?: Array<string | null> | null }, user?: { __typename?: 'User', id: string, username: string, firstname?: string | null, surname?: string | null, intercomHash?: string | null, createdAt?: any | null, systemRole: UserSysRole, respondents?: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole }> | null } | null } | null, productVersion?: { __typename?: 'ProductVersion', validFrom: any, validTo: any, product: string } | null }, widgets?: { __typename?: 'ProcessWidgets', withoutProblems: { __typename?: 'Widget', numerator: number, denominator: number }, responseRate: { __typename?: 'Widget', numerator: number, denominator: number }, anonymityRate: { __typename?: 'Widget', numerator: number, denominator: number } } | null, rootTeamsStatistics?: Array<{ __typename?: 'RootTeamsStatistics', teamId: string, statistics: { __typename?: 'ProcessWidgets', finishedRate: { __typename?: 'Widget', numerator: number, denominator: number }, responseRate: { __typename?: 'Widget', numerator: number, denominator: number }, anonymityRate: { __typename?: 'Widget', numerator: number, denominator: number } } }> | null, teams?: Array<{ __typename?: 'PubTeams', id: string, teamName: string, directMembers?: Array<string> | null, memberTeams?: Array<string> | null, teamLeader?: string | null }> | null, surveyGroup?: { __typename?: 'SurveyGroup', from?: any | null, to?: any | null, id: string, statistics?: { __typename?: 'ReportBasicStatistics', total: number, answered: number, withProblems: number } | null, topicGroup: { __typename?: 'TopicGroup', id: string, hideOnboardingParts?: boolean | null, typeCode?: TopicGroupTypeCode | null, allowedAnonymities: Array<AnonymityLevel>, defaultAnonymity: AnonymityLevel, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null }, steps: Array<{ __typename?: 'SurveyGroupStep', daysFromStart: number, hasMetricQuestion: boolean, status: ProcessStatus, hasNotStarted?: boolean | null, notstartedReason?: Array<NotstartedSurveyReason> | null, statistics?: { __typename?: 'ReportBasicStatistics', answered: number, total: number, withProblems: number, anonymous: number, avgMetric: number } | null, surveys: Array<{ __typename?: 'BasicSurveyInfo', id: string, sendAt: any, endsAt?: any | null, seqDate?: any | null, status: SurveyStatus, public?: boolean | null }>, processStep: { __typename?: 'ProcessStep', id: string, startOffsetMins?: number | null, endOffsetMins?: number | null, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }>, stepTopicGroup: { __typename?: 'TopicGroup', allowedAnonymities: Array<AnonymityLevel>, defaultAnonymity: AnonymityLevel, id: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null } } }> } | null } };

export type AiSurveySummaryQueryQueryVariables = Exact<{
  languageCode: Scalars['String']['input'];
  accessToken: Scalars['String']['input'];
  systemMessage?: InputMaybe<Scalars['String']['input']>;
  answers?: InputMaybe<Array<QuestionWithAnswer> | QuestionWithAnswer>;
}>;


export type AiSurveySummaryQueryQuery = { __typename?: 'Query', aiSurveySummary: { __typename?: 'AiSurveySummaryData', text: string, done: boolean, hash?: string | null } };

export type ReportDefinitionsNewForSurveyQueryVariables = Exact<{
  surveyId: Scalars['ID']['input'];
}>;


export type ReportDefinitionsNewForSurveyQuery = { __typename?: 'Query', reportDefinitionsNewForSurvey: Array<{ __typename?: 'ReportDefinitionNewVersion', id: string, name?: string | null, createdAt: any, createdBy?: string | null, isPrimary: boolean }> };

export type ReportDefinitionsNewForTopicQueryVariables = Exact<{
  surveyId: Scalars['ID']['input'];
}>;


export type ReportDefinitionsNewForTopicQuery = { __typename?: 'Query', reportDefinitionsNewForTopic: Array<{ __typename?: 'ReportDefinitionNewVersion', id: string, name?: string | null, createdAt: any, createdBy?: string | null, isPrimary: boolean }> };

export type ReportDefinitionNewForTopicQueryVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type ReportDefinitionNewForTopicQuery = { __typename?: 'Query', reportDefinitionNewForTopic: { __typename?: 'ReportDefinitionNewVersion', id: string, name?: string | null, createdAt: any, createdBy?: string | null, isPrimary: boolean, definition?: unknown | null } };

export type ReportDefinitionNewForSurveyQueryVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type ReportDefinitionNewForSurveyQuery = { __typename?: 'Query', reportDefinitionNewForSurvey: { __typename?: 'ReportDefinitionNewVersion', id: string, name?: string | null, createdAt: any, createdBy?: string | null, isPrimary: boolean, definition?: unknown | null } };

export type GetNewReportQueryVariables = Exact<{
  accessToken: Scalars['String']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetNewReportQuery = { __typename?: 'Query', getNewReport: { __typename?: 'NewReport', id: string, reportRoots: Array<string>, totalRespondents: number, anonymityEnabled: boolean, anonymityForced: boolean, surveyId: string, teams: Array<{ __typename?: 'PubTeams', id: string, teamName: string, directMembers?: Array<string> | null, memberTeams?: Array<string> | null, teamLeader?: string | null }>, anonymitySettings?: { __typename?: 'AnonymitySettings', default?: AnonymityLevel | null, allowedLevels?: Array<AnonymityLevel> | null } | null, surveys: Array<{ __typename?: 'Survey', public?: boolean | null, status: SurveyStatus }>, questions: Array<{ __typename?: 'PubQuestion', id: string, index: string, reportIndex?: string | null, text: string, type: QuestionType, selectedRange?: string | null, answersLocal?: Array<string> | null, statementsLocal?: Array<string> | null, showEscapeOption?: boolean | null, isRankingScale?: boolean | null, metrics: Array<string | null>, reportOrder?: number | null, answersToHighlight?: Array<string> | null }>, responses: Array<{ __typename?: 'PubResponse', id: string, respondentId: string, surveyId: string, topicGroupId: string, anonymous: boolean, finished: boolean, additionallyAnonymized: boolean, originalAnonymous: boolean, messages?: Array<{ __typename?: 'PubMessage', id: string, questionDefinitionIndex: string, statementIndex?: number | null, text?: string | null, value?: string | null, comment?: string | null, relevance: number, anonymous: boolean, originalAnonymous: boolean, date: any }> | null }>, respondents: Array<{ __typename?: 'PubRespondent', id: string, firstname: string, surname: string, addedOn?: any | null }>, metadata: { __typename?: 'PubMetadata', surveyStart?: any | null, surveyEnd?: any | null, status: SurveyStatus, organizationDepth: number, adminEmails?: Array<string> | null, topicGroupId?: string | null, language?: { __typename?: 'Language', id: string, code: string } | null, organization: { __typename?: 'Organization', id: string, name: string, systemName: string, featureNames?: Array<string | null> | null, languages: Array<{ __typename?: 'Language', code: string }> } }, topicGroup: { __typename?: 'TopicGroup', translations?: Array<{ __typename?: 'TopicGroupTranslation', value: string, description?: string | null, language: { __typename?: 'Language', code: string } }> | null }, questionLabels: Array<{ __typename?: 'QuestionLabel', questionDefinitionIndex: string, questionLabelComments?: Array<{ __typename?: 'QuestionLabelComments', label: string, commentIds?: Array<string> | null }> | null }>, reportDefinition?: { __typename?: 'NewReportDefinition', id: string, definition: unknown } | null } };

export type ReportSubscriptionSubscriptionVariables = Exact<{
  languageCode?: InputMaybe<Scalars['String']['input']>;
  accessToken: Scalars['String']['input'];
  reportDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ReportSubscriptionSubscription = { __typename?: 'Subscription', getReport: { __typename?: 'PubReport', id: string, addedOnFrom?: any | null, addedOnTo?: any | null, identifier: string, totalRespondents?: number | null, surveyKeywordsGenerated: boolean, anonymityEnabled: boolean, anonymityForced: boolean, reportRoots?: Array<string> | null, sequenceFrom?: any | null, sequenceTo?: any | null, anonymitySettings?: { __typename?: 'AnonymitySettings', default?: AnonymityLevel | null, allowedLevels?: Array<AnonymityLevel> | null } | null, firstSurvey?: { __typename?: 'Survey', public?: boolean | null } | null, hiringAdditionalData?: Array<{ __typename?: 'HiringAdditionalData', respondentId: string, surveyId?: string | null, position?: string | null, isHired?: boolean | null, isRejected?: boolean | null, recruiterName?: string | null }> | null, responses?: Array<{ __typename?: 'PubResponse', id: string, surveyId: string, respondentId: string, topicGroupId: string, anonymous: boolean, originalAnonymous: boolean, finished: boolean, additionallyAnonymized: boolean, seqDate?: any | null, messages?: Array<{ __typename?: 'PubMessage', id: string, questionDefinitionIndex: string, statementIndex?: number | null, comment?: string | null, text?: string | null, value?: string | null, anonymous: boolean, originalAnonymous: boolean, date: any }> | null, reactions?: Array<{ __typename?: 'Reaction', id: string, channelId: string, messageId?: string | null, respondentId: string, text: string, createdAt: any }> | null }> | null, questions?: Array<{ __typename?: 'PubQuestion', id: string, index: string, text: string, type: QuestionType, selectedRange?: string | null, answersLocal?: Array<string> | null, statementsLocal?: Array<string> | null, showEscapeOption?: boolean | null, isRankingScale?: boolean | null, reportIndex?: string | null, answersToHighlight?: Array<string> | null }> | null, respondents?: Array<{ __typename?: 'PubRespondent', id: string, firstname: string, surname: string, addedOn?: any | null }> | null, metadata?: { __typename?: 'PubMetadata', surveyEnd?: any | null, surveyStart?: any | null, status: SurveyStatus, accepted?: boolean | null, topicGroupId?: string | null, adminEmails?: Array<string> | null, organizationDepth: number, organization: { __typename?: 'Organization', id: string, name: string, featureNames?: Array<string | null> | null, primaryLanguageCode: string, languages: Array<{ __typename?: 'Language', code: string }> }, language?: { __typename?: 'Language', id: string, code: string } | null, respondent?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, intercomHash?: string | null, createdAt: any, organizationRole: UserOrgRole, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string, source?: ContactSource | null }> | null, organization: { __typename?: 'Organization', id: string, name: string, companyId?: string | null, featureNames?: Array<string | null> | null }, user?: { __typename?: 'User', id: string, username: string, firstname?: string | null, surname?: string | null, intercomHash?: string | null, createdAt?: any | null, systemRole: UserSysRole, respondents?: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole }> | null } | null } | null, productVersion?: { __typename?: 'ProductVersion', validFrom: any, validTo: any, product: string } | null } | null, teams?: Array<{ __typename?: 'PubTeams', id: string, teamName: string, directMembers?: Array<string> | null, memberTeams?: Array<string> | null, teamLeader?: string | null }> | null, surveyGroup?: { __typename?: 'SurveyGroup', from?: any | null, to?: any | null, topicGroup: { __typename?: 'TopicGroup', id: string, typeCode?: TopicGroupTypeCode | null, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null }, steps: Array<{ __typename?: 'SurveyGroupStep', daysFromStart: number, processStep: { __typename?: 'ProcessStep', stepTopicGroup: { __typename?: 'TopicGroup', id: string, allowedAnonymities: Array<AnonymityLevel>, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null } } }> } | null, questionLabels?: Array<{ __typename?: 'QuestionLabel', questionDefinitionIndex: string, questionLabelComments?: Array<{ __typename?: 'QuestionLabelComments', label: string, commentIds?: Array<string> | null }> | null }> | null, source?: Array<{ __typename?: 'PubSource', respondentId: string, sourceId: string }> | null, reportDefinition?: { __typename?: 'PubReportDefinition', id: string, titleLocal?: string | null, aboutLocal?: string | null, sections?: Array<{ __typename?: 'PubSection', id: string, heading: string, headingLocal: string, descriptionLocal?: string | null, type: ReportSectionType, displayFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null, titleFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null, widgets?: Array<{ __typename?: 'PubWidget', id: string, questionDefinitionIndex?: string | null, headingLocal: string, type: string, descriptionLocal?: string | null, answersToHighlight?: Array<string> | null, values?: Array<string | null> | null, titleFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null, displayFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null }> | null }> | null, intro?: Array<{ __typename?: 'PubWidget', questionDefinitionIndex?: string | null, headingLocal: string, type: string, descriptionLocal?: string | null, answersToHighlight?: Array<string> | null, values?: Array<string | null> | null, numerator?: number | null, denominator?: number | null, additionallyAnonymized?: boolean | null, displayFilters?: Array<{ __typename?: 'PubDisplayFilter', operator: string, questionDefinitionIndex: string, values?: Array<string> | null }> | null }> | null } | null, additionalRespondentData?: Array<{ __typename?: 'AdditionalRespondentDataFromTeamio', channelId: string, position?: string | null, recruiter?: string | null, managers?: Array<string> | null, addedOn?: string | null }> | null } };

export type ReportSequenceSubscriptionSubscriptionVariables = Exact<{
  languageCode?: InputMaybe<Scalars['String']['input']>;
  accessToken: Scalars['String']['input'];
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  teamsFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  recruiterIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  managerIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  withoutDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  showOnlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ReportSequenceSubscriptionSubscription = { __typename?: 'Subscription', getProcessReport: { __typename?: 'ProcessReportInfoSub', id: string, identifier: string, totalRespondents?: number | null, filteredRespondents?: number | null, addedOnFrom?: any | null, addedOnTo?: any | null, reportRoots: Array<string>, hiringInfo?: { __typename?: 'HiringInfo', positions: Array<{ __typename?: 'HiringInfoItem', id: string, label: string, candidateIds: Array<string> }>, recruiters: Array<{ __typename?: 'HiringInfoItem', id: string, label: string, candidateIds: Array<string> }>, managers: Array<{ __typename?: 'HiringInfoItem', id: string, label: string, candidateIds: Array<string> }> } | null, groupedRespondents?: { __typename?: 'SurveyGroupRespondentsResult', totalCount: number, data: Array<{ __typename?: 'GroupedRespondents', addedOn: any, deletedRespondents?: Array<string> | null, metricQuestionsForRespondent: Array<{ __typename?: 'MetricQuestionForRespondent', respondentId: string, answers: Array<{ __typename?: 'MetricAnswer', topicGroupId: string, value?: number | null }> }>, respondents: Array<{ __typename?: 'Respondent', id: string, preferredContactType: ContactType, firstname?: string | null, surname?: string | null, deleted: boolean, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string, phoneNumber?: { __typename?: 'PhoneNumber', countryCallingCode: string, nationalNumber: string } | null }> | null }>, surveys: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, sendAt: any, endsAt?: any | null, public?: boolean | null, respondentIds: Array<string>, topicGroup?: { __typename?: 'TopicGroup', id: string } | null, publicChannels: Array<{ __typename?: 'PublicChannel', id: string, respondentId: string, lastRemindedAt?: any | null, maxAnonymousHighlightedLevel: number, withAnswer: boolean, isFinishedByRespondent: boolean, finishedAt?: any | null }> }>, hiringSurveys?: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, sendAt: any, endsAt?: any | null, respondentIds: Array<string>, topicGroup?: { __typename?: 'TopicGroup', id: string } | null, publicChannels: Array<{ __typename?: 'PublicChannel', id: string, respondentId: string, lastRemindedAt?: any | null, maxAnonymousHighlightedLevel: number, withAnswer: boolean, isFinishedByRespondent: boolean, finishedAt?: any | null }> }> | null, hiringAdditionalData?: Array<{ __typename?: 'HiringAdditionalData', respondentId: string, position?: string | null, isHired?: boolean | null, isRejected?: boolean | null, recruiterName?: string | null }> | null, undeliveredInvitations?: Array<{ __typename?: 'UndeliveredInvitations', respondentId: string, undeliveredSurveyInvitations?: Array<{ __typename?: 'UndeliveredInvitation', surveyId: string, contact: string, status?: string | null }> | null } | null> | null, hasUnreadMessages?: Array<{ __typename?: 'HasUnreadMessages', respondentId: string, unreadMessages?: Array<string> | null }> | null }> } | null, metadata: { __typename?: 'PubMetadata', surveyEnd?: any | null, surveyStart?: any | null, status: SurveyStatus, accepted?: boolean | null, adminEmails?: Array<string> | null, organization: { __typename?: 'Organization', id: string, name: string, featureNames?: Array<string | null> | null, config?: { __typename?: 'OrganizationConfig', countryCallingCode: string } | null }, language?: { __typename?: 'Language', id: string, code: string } | null, respondent?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole, createdAt: any, intercomHash?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string, source?: ContactSource | null }> | null, organization: { __typename?: 'Organization', id: string, name: string, companyId?: string | null, featureNames?: Array<string | null> | null }, user?: { __typename?: 'User', id: string, username: string, firstname?: string | null, surname?: string | null, intercomHash?: string | null, createdAt?: any | null, systemRole: UserSysRole, respondents?: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole }> | null } | null } | null, productVersion?: { __typename?: 'ProductVersion', validFrom: any, validTo: any, product: string } | null }, widgets?: { __typename?: 'ProcessWidgets', withoutProblems: { __typename?: 'Widget', numerator: number, denominator: number }, responseRate: { __typename?: 'Widget', numerator: number, denominator: number }, anonymityRate: { __typename?: 'Widget', numerator: number, denominator: number } } | null, rootTeamsStatistics?: Array<{ __typename?: 'RootTeamsStatistics', teamId: string, statistics: { __typename?: 'ProcessWidgets', finishedRate: { __typename?: 'Widget', numerator: number, denominator: number }, responseRate: { __typename?: 'Widget', numerator: number, denominator: number }, anonymityRate: { __typename?: 'Widget', numerator: number, denominator: number } } }> | null, teams?: Array<{ __typename?: 'PubTeams', id: string, teamName: string, directMembers?: Array<string> | null, memberTeams?: Array<string> | null, teamLeader?: string | null }> | null, surveyGroup?: { __typename?: 'SurveyGroup', from?: any | null, to?: any | null, id: string, statistics?: { __typename?: 'ReportBasicStatistics', total: number, answered: number, withProblems: number } | null, topicGroup: { __typename?: 'TopicGroup', id: string, hideOnboardingParts?: boolean | null, typeCode?: TopicGroupTypeCode | null, allowedAnonymities: Array<AnonymityLevel>, defaultAnonymity: AnonymityLevel, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null }, steps: Array<{ __typename?: 'SurveyGroupStep', daysFromStart: number, hasMetricQuestion: boolean, status: ProcessStatus, hasNotStarted?: boolean | null, notstartedReason?: Array<NotstartedSurveyReason> | null, statistics?: { __typename?: 'ReportBasicStatistics', answered: number, total: number, withProblems: number, anonymous: number, avgMetric: number } | null, surveys: Array<{ __typename?: 'BasicSurveyInfo', id: string, sendAt: any, endsAt?: any | null, seqDate?: any | null, status: SurveyStatus, public?: boolean | null }>, processStep: { __typename?: 'ProcessStep', id: string, startOffsetMins?: number | null, endOffsetMins?: number | null, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }>, stepTopicGroup: { __typename?: 'TopicGroup', allowedAnonymities: Array<AnonymityLevel>, defaultAnonymity: AnonymityLevel, id: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string, id: string } }> | null } } }> } | null } };

export type AiSurveySummarySubscriptionSubscriptionVariables = Exact<{
  languageCode: Scalars['String']['input'];
  accessToken: Scalars['String']['input'];
  systemMessage?: InputMaybe<Scalars['String']['input']>;
  answers?: InputMaybe<Array<QuestionWithAnswer> | QuestionWithAnswer>;
}>;


export type AiSurveySummarySubscriptionSubscription = { __typename?: 'Subscription', aiSurveySummary: { __typename?: 'AiSurveySummaryData', text: string, done: boolean, hash?: string | null } };

export type AiSurveySummaryAbTestSubscriptionSubscriptionVariables = Exact<{
  languageCode: Scalars['String']['input'];
  accessToken: Scalars['String']['input'];
  defaultSystemMessage: Scalars['String']['input'];
  answers?: InputMaybe<Array<QuestionWithAnswer> | QuestionWithAnswer>;
}>;


export type AiSurveySummaryAbTestSubscriptionSubscription = { __typename?: 'Subscription', aiSurveySummaryAbTest: { __typename?: 'AiSurveySummaryAbTestData', mode: AiSurveySummaryAbTestMode, experimentId?: string | null, layout?: AiSurveySummaryAbTestLayout | null, left?: { __typename?: 'AiSurveySummaryAbTestVariantStream', text: string, done: boolean, variantKey: AiSurveySummaryAbVariantKey, hash?: string | null } | null, right?: { __typename?: 'AiSurveySummaryAbTestVariantStream', text: string, done: boolean, variantKey: AiSurveySummaryAbVariantKey, hash?: string | null } | null, single?: { __typename?: 'AiSurveySummaryData', text: string, done: boolean, hash?: string | null } | null } };

export type GetProcessKeywordsSubscriptionSubscriptionVariables = Exact<{
  languageCode: Scalars['String']['input'];
  accessToken: Scalars['String']['input'];
  questionIdx: Scalars['String']['input'];
  answersIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  generate: Scalars['Boolean']['input'];
}>;


export type GetProcessKeywordsSubscriptionSubscription = { __typename?: 'Subscription', getProcessKeywords: { __typename?: 'getProcessKeywordsData', done: boolean, keywords?: Array<{ __typename?: 'QuestionLabelComments', label: string, commentIds?: Array<string> | null }> | null } };

export const QuestionDefinitionFragmentDoc = gql`
    fragment QuestionDefinition on QuestionDefinition {
  ... on SelectQuestionDefinition {
    text
    choices
    selectedRange
  }
  ... on FreeTextQuestionDefinition {
    text
  }
  ... on PersonMultiselectQuestionDefinition {
    text
    organizationRespondents {
      id
      firstname
      surname
      contacts {
        type
        source
        value
      }
    }
    selectedRange
  }
  ... on SmsContactQuestionDefinition {
    text
    phoneNumber
  }
  ... on EmailContactQuestionDefinition {
    text
    email
  }
  ... on ScaleQuestionDefinition {
    text
    choices
    statements
    randomizeOrder
    isRankingScale
    showEscapeOption
    id
  }
}
    `;
export const ReportFragmentFragmentDoc = gql`
    fragment ReportFragment on PubReport {
  id
  addedOnFrom
  addedOnTo
  identifier
  totalRespondents
  surveyKeywordsGenerated
  anonymityEnabled
  anonymityForced
  anonymitySettings {
    default
    allowedLevels
  }
  firstSurvey {
    public
  }
  hiringAdditionalData {
    respondentId
    surveyId
    position
    isHired
    isRejected
    recruiterName
  }
  responses {
    id
    surveyId
    respondentId
    topicGroupId
    anonymous
    originalAnonymous
    finished
    additionallyAnonymized
    seqDate
    messages {
      id
      questionDefinitionIndex
      statementIndex
      comment
      text
      value
      anonymous
      originalAnonymous
      date
    }
    reactions {
      id
      channelId
      messageId
      respondentId
      text
      createdAt
    }
  }
  questions {
    id
    index
    text
    type
    selectedRange
    answersLocal
    statementsLocal
    showEscapeOption
    isRankingScale
    reportIndex
    answersToHighlight
  }
  respondents {
    id
    firstname
    surname
    addedOn
  }
  reportRoots
  metadata {
    surveyEnd
    surveyStart
    status
    accepted
    topicGroupId
    organization {
      id
      name
      featureNames
      primaryLanguageCode
      languages {
        code
      }
    }
    language {
      id
      code
    }
    respondent {
      id
      firstname
      surname
      intercomHash
      createdAt
      contacts {
        type
        value
        source
      }
      organizationRole
      organization {
        id
        name
        companyId
        featureNames
      }
      user {
        id
        username
        firstname
        surname
        intercomHash
        createdAt
        systemRole
        respondents {
          id
          firstname
          surname
          organizationRole
        }
      }
    }
    adminEmails
    organizationDepth
    productVersion {
      validFrom
      validTo
      product
    }
  }
  teams {
    id
    teamName
    directMembers
    memberTeams
    teamLeader
  }
  surveyGroup {
    from
    to
    topicGroup {
      id
      typeCode
      translations {
        id
        language {
          code
          id
        }
        value
        description
      }
    }
    steps {
      daysFromStart
      processStep {
        stepTopicGroup {
          id
          allowedAnonymities
          translations {
            id
            language {
              code
              id
            }
            value
            description
          }
        }
      }
    }
  }
  questionLabels {
    questionDefinitionIndex
    questionLabelComments {
      label
      commentIds
    }
  }
  source {
    respondentId
    sourceId
  }
  reportDefinition {
    id
    titleLocal
    aboutLocal
    sections {
      id
      heading
      headingLocal
      descriptionLocal
      type
      displayFilters {
        operator
        questionDefinitionIndex
        values
      }
      titleFilters {
        operator
        questionDefinitionIndex
        values
      }
      widgets {
        id
        questionDefinitionIndex
        headingLocal
        type
        descriptionLocal
        titleFilters {
          operator
          questionDefinitionIndex
          values
        }
        displayFilters {
          operator
          questionDefinitionIndex
          values
        }
        answersToHighlight
        values
      }
    }
    intro {
      questionDefinitionIndex
      headingLocal
      type
      descriptionLocal
      displayFilters {
        operator
        questionDefinitionIndex
        values
      }
      answersToHighlight
      values
      numerator
      denominator
      additionallyAnonymized
    }
  }
  additionalRespondentData {
    channelId
    position
    recruiter
    managers
    addedOn
  }
  sequenceFrom
  sequenceTo
}
    `;
export const ProcessReportRespondentDetailFragmentDoc = gql`
    fragment ProcessReportRespondentDetail on ProcessReportRespondentDetail {
  id
  identifier
  hiringAdditionalData {
    respondentId
    position
    isHired
    surveyId
    isRejected
    recruiterName
  }
  groupedRespondents {
    respondents {
      id
      preferredContactType
      firstname
      surname
      deleted
      contacts {
        type
        source
        value
        phoneNumber {
          countryCallingCode
          nationalNumber
        }
      }
    }
    addedOn
    surveys {
      id
      status
      sendAt
      endsAt
      public
      topicGroup {
        id
      }
      publicChannels {
        id
        respondentId
        lastRemindedAt
        maxAnonymousHighlightedLevel
        withAnswer
        finishedAt
        isFinishedByRespondent
      }
      respondentIds
    }
    hiringSurveys {
      id
      status
      sendAt
      endsAt
      topicGroup {
        id
      }
      publicChannels {
        id
        respondentId
        lastRemindedAt
        maxAnonymousHighlightedLevel
        withAnswer
        finishedAt
        isFinishedByRespondent
      }
      respondentIds
    }
    hiringAdditionalData {
      respondentId
      position
      isHired
      isRejected
      recruiterName
    }
    undeliveredInvitations {
      respondentId
      undeliveredSurveyInvitations {
        surveyId
        contact
        status
      }
    }
    metricQuestionsForRespondent {
      respondentId
      answers {
        topicGroupId
        value
      }
    }
    deletedRespondents
    hasUnreadMessages {
      respondentId
      unreadMessages
    }
  }
  questions {
    id
    index
    text
    type
    selectedRange
    answersLocal
    statementsLocal
    showEscapeOption
    isRankingScale
    reportIndex
    answersToHighlight
    metrics
    topicGroupId
  }
  responses {
    id
    surveyId
    respondentId
    topicGroupId
    anonymous
    originalAnonymous
    finished
    additionallyAnonymized
    seqDate
    reactions {
      id
      channelId
      messageId
      respondentId
      respondentFullName
      text
      createdAt
    }
    messages {
      id
      questionDefinitionIndex
      text
      value
      anonymous
      originalAnonymous
      statementIndex
      comment
      date
      hasAlert
    }
  }
  respondents {
    id
    firstname
    surname
    addedOn
  }
  reportRoots
  keyPoints {
    answerIds
    point
    sentiment
  }
  surveyGroup {
    id
    from
    to
    topicGroup {
      id
      typeCode
      hideOnboardingParts
      allowedAnonymities
      defaultAnonymity
      translations {
        id
        language {
          code
          id
        }
        value
        description
      }
    }
    steps {
      daysFromStart
      hasMetricQuestion
      status
      hasNotStarted
      notstartedReason
      surveys {
        id
        sendAt
        endsAt
        seqDate
        status
        public
      }
      processStep {
        id
        startOffsetMins
        reminders {
          reminderOffsetMins
        }
        endOffsetMins
        stepTopicGroup {
          allowedAnonymities
          defaultAnonymity
          id
          translations {
            id
            language {
              code
              id
            }
            value
            description
          }
        }
      }
    }
  }
  metadata {
    surveyEnd
    surveyStart
    status
    accepted
    organization {
      id
      name
      featureNames
      config {
        countryCallingCode
      }
    }
    language {
      id
      code
    }
    respondent {
      id
      firstname
      surname
      createdAt
      contacts {
        type
        value
        source
      }
      intercomHash
      organizationRole
      organization {
        id
        name
        companyId
        featureNames
      }
      user {
        id
        username
        firstname
        surname
        intercomHash
        createdAt
        systemRole
        respondents {
          id
          firstname
          surname
          organizationRole
        }
      }
    }
    adminEmails
    productVersion {
      validFrom
      validTo
      product
    }
  }
  teams {
    id
    teamName
    directMembers
    memberTeams
    teamLeader
  }
}
    `;
export const AiSurveySummaryFragmentFragmentDoc = gql`
    fragment AiSurveySummaryFragment on AiSurveySummaryData {
  text
  done
  hash
}
    `;
export const ProcessReportFragmentFragmentDoc = gql`
    fragment ProcessReportFragment on ProcessReportInfoSub {
  id
  identifier
  totalRespondents
  filteredRespondents
  addedOnFrom
  addedOnTo
  reportRoots
  hiringInfo {
    positions {
      id
      label
      candidateIds
    }
    recruiters {
      id
      label
      candidateIds
    }
    managers {
      id
      label
      candidateIds
    }
  }
  groupedRespondents {
    data {
      metricQuestionsForRespondent {
        respondentId
        answers {
          topicGroupId
          value
        }
      }
      respondents {
        id
        preferredContactType
        firstname
        surname
        deleted
        contacts {
          type
          source
          value
          phoneNumber {
            countryCallingCode
            nationalNumber
          }
        }
      }
      addedOn
      surveys {
        id
        status
        sendAt
        endsAt
        public
        topicGroup {
          id
        }
        respondentIds
        publicChannels {
          id
          respondentId
          lastRemindedAt
          maxAnonymousHighlightedLevel
          withAnswer
          isFinishedByRespondent
          finishedAt
        }
      }
      hiringSurveys {
        id
        status
        sendAt
        endsAt
        topicGroup {
          id
        }
        respondentIds
        publicChannels {
          id
          respondentId
          lastRemindedAt
          maxAnonymousHighlightedLevel
          withAnswer
          isFinishedByRespondent
          finishedAt
        }
      }
      hiringAdditionalData {
        respondentId
        position
        isHired
        isRejected
        recruiterName
      }
      deletedRespondents
      undeliveredInvitations {
        respondentId
        undeliveredSurveyInvitations {
          surveyId
          contact
          status
        }
      }
      hasUnreadMessages {
        respondentId
        unreadMessages
      }
    }
    totalCount
  }
  metadata {
    surveyEnd
    surveyStart
    status
    accepted
    organization {
      id
      name
      featureNames
      config {
        countryCallingCode
      }
    }
    language {
      id
      code
    }
    respondent {
      id
      firstname
      surname
      organizationRole
      createdAt
      intercomHash
      contacts {
        type
        value
        source
      }
      organization {
        id
        name
        companyId
        featureNames
      }
      user {
        id
        username
        firstname
        surname
        intercomHash
        createdAt
        systemRole
        respondents {
          id
          firstname
          surname
          organizationRole
        }
      }
    }
    adminEmails
    productVersion {
      validFrom
      validTo
      product
    }
  }
  widgets {
    withoutProblems {
      numerator
      denominator
    }
    responseRate {
      numerator
      denominator
    }
    anonymityRate {
      numerator
      denominator
    }
  }
  rootTeamsStatistics {
    teamId
    statistics {
      finishedRate {
        numerator
        denominator
      }
      responseRate {
        numerator
        denominator
      }
      anonymityRate {
        numerator
        denominator
      }
    }
  }
  teams {
    id
    teamName
    directMembers
    memberTeams
    teamLeader
  }
  surveyGroup {
    from
    to
    id
    statistics {
      total
      answered
      withProblems
    }
    topicGroup {
      id
      hideOnboardingParts
      typeCode
      allowedAnonymities
      defaultAnonymity
      translations {
        id
        language {
          code
          id
        }
        value
        description
      }
    }
    steps {
      daysFromStart
      hasMetricQuestion
      status
      hasNotStarted
      notstartedReason
      statistics {
        answered
        total
        withProblems
        anonymous
        avgMetric
      }
      surveys {
        id
        sendAt
        endsAt
        seqDate
        status
        public
      }
      processStep {
        id
        startOffsetMins
        reminders {
          reminderOffsetMins
        }
        endOffsetMins
        stepTopicGroup {
          allowedAnonymities
          defaultAnonymity
          id
          translations {
            id
            language {
              code
              id
            }
            value
            description
          }
        }
      }
    }
  }
}
    `;
export const SaveReportDefinitionNewForSurveyDocument = gql`
    mutation SaveReportDefinitionNewForSurvey($surveyId: ID!, $name: String, $definition: JSON!) {
  saveReportDefinitionNewForSurvey(
    surveyId: $surveyId
    name: $name
    definition: $definition
  ) {
    id
    name
    createdAt
    createdBy
    isPrimary
    definition
  }
}
    `;
export type SaveReportDefinitionNewForSurveyMutationFn = Apollo.MutationFunction<SaveReportDefinitionNewForSurveyMutation, SaveReportDefinitionNewForSurveyMutationVariables>;

/**
 * __useSaveReportDefinitionNewForSurveyMutation__
 *
 * To run a mutation, you first call `useSaveReportDefinitionNewForSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveReportDefinitionNewForSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveReportDefinitionNewForSurveyMutation, { data, loading, error }] = useSaveReportDefinitionNewForSurveyMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      name: // value for 'name'
 *      definition: // value for 'definition'
 *   },
 * });
 */
export function useSaveReportDefinitionNewForSurveyMutation(baseOptions?: Apollo.MutationHookOptions<SaveReportDefinitionNewForSurveyMutation, SaveReportDefinitionNewForSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveReportDefinitionNewForSurveyMutation, SaveReportDefinitionNewForSurveyMutationVariables>(SaveReportDefinitionNewForSurveyDocument, options);
      }
export type SaveReportDefinitionNewForSurveyMutationHookResult = ReturnType<typeof useSaveReportDefinitionNewForSurveyMutation>;
export type SaveReportDefinitionNewForSurveyMutationResult = Apollo.MutationResult<SaveReportDefinitionNewForSurveyMutation>;
export type SaveReportDefinitionNewForSurveyMutationOptions = Apollo.BaseMutationOptions<SaveReportDefinitionNewForSurveyMutation, SaveReportDefinitionNewForSurveyMutationVariables>;
export const SetPrimaryReportDefinitionNewForSurveyDocument = gql`
    mutation SetPrimaryReportDefinitionNewForSurvey($surveyId: ID!, $id: ID!) {
  setPrimaryReportDefinitionNewForSurvey(surveyId: $surveyId, id: $id) {
    id
    name
    createdAt
    createdBy
    isPrimary
    definition
  }
}
    `;
export type SetPrimaryReportDefinitionNewForSurveyMutationFn = Apollo.MutationFunction<SetPrimaryReportDefinitionNewForSurveyMutation, SetPrimaryReportDefinitionNewForSurveyMutationVariables>;

/**
 * __useSetPrimaryReportDefinitionNewForSurveyMutation__
 *
 * To run a mutation, you first call `useSetPrimaryReportDefinitionNewForSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryReportDefinitionNewForSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimaryReportDefinitionNewForSurveyMutation, { data, loading, error }] = useSetPrimaryReportDefinitionNewForSurveyMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetPrimaryReportDefinitionNewForSurveyMutation(baseOptions?: Apollo.MutationHookOptions<SetPrimaryReportDefinitionNewForSurveyMutation, SetPrimaryReportDefinitionNewForSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPrimaryReportDefinitionNewForSurveyMutation, SetPrimaryReportDefinitionNewForSurveyMutationVariables>(SetPrimaryReportDefinitionNewForSurveyDocument, options);
      }
export type SetPrimaryReportDefinitionNewForSurveyMutationHookResult = ReturnType<typeof useSetPrimaryReportDefinitionNewForSurveyMutation>;
export type SetPrimaryReportDefinitionNewForSurveyMutationResult = Apollo.MutationResult<SetPrimaryReportDefinitionNewForSurveyMutation>;
export type SetPrimaryReportDefinitionNewForSurveyMutationOptions = Apollo.BaseMutationOptions<SetPrimaryReportDefinitionNewForSurveyMutation, SetPrimaryReportDefinitionNewForSurveyMutationVariables>;
export const SetPrimaryReportDefinitionNewForTopicDocument = gql`
    mutation SetPrimaryReportDefinitionNewForTopic($surveyId: ID!, $id: ID!) {
  setPrimaryReportDefinitionNewForTopic(surveyId: $surveyId, id: $id) {
    id
    name
    createdAt
    createdBy
    isPrimary
    definition
  }
}
    `;
export type SetPrimaryReportDefinitionNewForTopicMutationFn = Apollo.MutationFunction<SetPrimaryReportDefinitionNewForTopicMutation, SetPrimaryReportDefinitionNewForTopicMutationVariables>;

/**
 * __useSetPrimaryReportDefinitionNewForTopicMutation__
 *
 * To run a mutation, you first call `useSetPrimaryReportDefinitionNewForTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryReportDefinitionNewForTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimaryReportDefinitionNewForTopicMutation, { data, loading, error }] = useSetPrimaryReportDefinitionNewForTopicMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetPrimaryReportDefinitionNewForTopicMutation(baseOptions?: Apollo.MutationHookOptions<SetPrimaryReportDefinitionNewForTopicMutation, SetPrimaryReportDefinitionNewForTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPrimaryReportDefinitionNewForTopicMutation, SetPrimaryReportDefinitionNewForTopicMutationVariables>(SetPrimaryReportDefinitionNewForTopicDocument, options);
      }
export type SetPrimaryReportDefinitionNewForTopicMutationHookResult = ReturnType<typeof useSetPrimaryReportDefinitionNewForTopicMutation>;
export type SetPrimaryReportDefinitionNewForTopicMutationResult = Apollo.MutationResult<SetPrimaryReportDefinitionNewForTopicMutation>;
export type SetPrimaryReportDefinitionNewForTopicMutationOptions = Apollo.BaseMutationOptions<SetPrimaryReportDefinitionNewForTopicMutation, SetPrimaryReportDefinitionNewForTopicMutationVariables>;
export const SaveReportDefinitionNewForTopicDocument = gql`
    mutation SaveReportDefinitionNewForTopic($surveyId: ID!, $name: String, $definition: JSON!, $primary: Boolean) {
  saveReportDefinitionNewForTopic(
    surveyId: $surveyId
    name: $name
    definition: $definition
    primary: $primary
  ) {
    id
    name
    createdAt
    createdBy
    isPrimary
    definition
  }
}
    `;
export type SaveReportDefinitionNewForTopicMutationFn = Apollo.MutationFunction<SaveReportDefinitionNewForTopicMutation, SaveReportDefinitionNewForTopicMutationVariables>;

/**
 * __useSaveReportDefinitionNewForTopicMutation__
 *
 * To run a mutation, you first call `useSaveReportDefinitionNewForTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveReportDefinitionNewForTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveReportDefinitionNewForTopicMutation, { data, loading, error }] = useSaveReportDefinitionNewForTopicMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      name: // value for 'name'
 *      definition: // value for 'definition'
 *      primary: // value for 'primary'
 *   },
 * });
 */
export function useSaveReportDefinitionNewForTopicMutation(baseOptions?: Apollo.MutationHookOptions<SaveReportDefinitionNewForTopicMutation, SaveReportDefinitionNewForTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveReportDefinitionNewForTopicMutation, SaveReportDefinitionNewForTopicMutationVariables>(SaveReportDefinitionNewForTopicDocument, options);
      }
export type SaveReportDefinitionNewForTopicMutationHookResult = ReturnType<typeof useSaveReportDefinitionNewForTopicMutation>;
export type SaveReportDefinitionNewForTopicMutationResult = Apollo.MutationResult<SaveReportDefinitionNewForTopicMutation>;
export type SaveReportDefinitionNewForTopicMutationOptions = Apollo.BaseMutationOptions<SaveReportDefinitionNewForTopicMutation, SaveReportDefinitionNewForTopicMutationVariables>;
export const SendTextAnswerDocument = gql`
    mutation sendTextAnswer($channelId: ID!, $text: String!, $previousQuestionId: ID!) {
  sendTextAnswer(
    channelId: $channelId
    text: $text
    previousQuestionId: $previousQuestionId
  ) {
    id
    text
    createdAt
    createdBy
    isLast
    anonymityLevel
    remainingQuestions
    __typename
    question {
      definition {
        ...QuestionDefinition
      }
    }
    response {
      id
      __typename
      text
      createdAt
      createdBy
      isLast
      anonymityLevel
      sentOn {
        id
        anonymityLevel
        anonymityLocked
        isFinished
      }
      ... on Question {
        definition {
          optional
          ...QuestionDefinition
        }
      }
    }
  }
}
    ${QuestionDefinitionFragmentDoc}`;
export type SendTextAnswerMutationFn = Apollo.MutationFunction<SendTextAnswerMutation, SendTextAnswerMutationVariables>;

/**
 * __useSendTextAnswerMutation__
 *
 * To run a mutation, you first call `useSendTextAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTextAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTextAnswerMutation, { data, loading, error }] = useSendTextAnswerMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      text: // value for 'text'
 *      previousQuestionId: // value for 'previousQuestionId'
 *   },
 * });
 */
export function useSendTextAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SendTextAnswerMutation, SendTextAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTextAnswerMutation, SendTextAnswerMutationVariables>(SendTextAnswerDocument, options);
      }
export type SendTextAnswerMutationHookResult = ReturnType<typeof useSendTextAnswerMutation>;
export type SendTextAnswerMutationResult = Apollo.MutationResult<SendTextAnswerMutation>;
export type SendTextAnswerMutationOptions = Apollo.BaseMutationOptions<SendTextAnswerMutation, SendTextAnswerMutationVariables>;
export const SendSelectAnswerDocument = gql`
    mutation sendSelectAnswer($channelId: ID!, $values: [Int!]!, $message: String!, $previousQuestionId: ID!) {
  sendSelectAnswer(
    channelId: $channelId
    values: $values
    message: $message
    previousQuestionId: $previousQuestionId
  ) {
    id
    text
    createdAt
    createdBy
    isLast
    anonymityLevel
    remainingQuestions
    __typename
    response {
      id
      __typename
      text
      createdAt
      createdBy
      isLast
      anonymityLevel
      sentOn {
        id
        anonymityLevel
        anonymityLocked
        isFinished
      }
      ... on Question {
        definition {
          optional
          ...QuestionDefinition
        }
      }
    }
    value
    question {
      definition {
        ...QuestionDefinition
      }
    }
  }
}
    ${QuestionDefinitionFragmentDoc}`;
export type SendSelectAnswerMutationFn = Apollo.MutationFunction<SendSelectAnswerMutation, SendSelectAnswerMutationVariables>;

/**
 * __useSendSelectAnswerMutation__
 *
 * To run a mutation, you first call `useSendSelectAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSelectAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSelectAnswerMutation, { data, loading, error }] = useSendSelectAnswerMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      values: // value for 'values'
 *      message: // value for 'message'
 *      previousQuestionId: // value for 'previousQuestionId'
 *   },
 * });
 */
export function useSendSelectAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SendSelectAnswerMutation, SendSelectAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSelectAnswerMutation, SendSelectAnswerMutationVariables>(SendSelectAnswerDocument, options);
      }
export type SendSelectAnswerMutationHookResult = ReturnType<typeof useSendSelectAnswerMutation>;
export type SendSelectAnswerMutationResult = Apollo.MutationResult<SendSelectAnswerMutation>;
export type SendSelectAnswerMutationOptions = Apollo.BaseMutationOptions<SendSelectAnswerMutation, SendSelectAnswerMutationVariables>;
export const SendScaleAnswerDocument = gql`
    mutation sendScaleAnswer($channelId: ID!, $answers: [ScaleStatementAnswerInput!]!, $previousQuestionId: ID!) {
  sendScaleAnswer(
    channelId: $channelId
    answers: $answers
    previousQuestionId: $previousQuestionId
  ) {
    id
    text
    createdAt
    createdBy
    isLast
    anonymityLevel
    remainingQuestions
    __typename
    statementIndex
    comment
    response {
      id
      __typename
      text
      createdAt
      createdBy
      isLast
      anonymityLevel
      sentOn {
        id
        anonymityLevel
        anonymityLocked
        isFinished
      }
      ... on Question {
        definition {
          optional
          ...QuestionDefinition
        }
      }
    }
    value
    question {
      definition {
        ...QuestionDefinition
      }
    }
  }
}
    ${QuestionDefinitionFragmentDoc}`;
export type SendScaleAnswerMutationFn = Apollo.MutationFunction<SendScaleAnswerMutation, SendScaleAnswerMutationVariables>;

/**
 * __useSendScaleAnswerMutation__
 *
 * To run a mutation, you first call `useSendScaleAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendScaleAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendScaleAnswerMutation, { data, loading, error }] = useSendScaleAnswerMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      answers: // value for 'answers'
 *      previousQuestionId: // value for 'previousQuestionId'
 *   },
 * });
 */
export function useSendScaleAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SendScaleAnswerMutation, SendScaleAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendScaleAnswerMutation, SendScaleAnswerMutationVariables>(SendScaleAnswerDocument, options);
      }
export type SendScaleAnswerMutationHookResult = ReturnType<typeof useSendScaleAnswerMutation>;
export type SendScaleAnswerMutationResult = Apollo.MutationResult<SendScaleAnswerMutation>;
export type SendScaleAnswerMutationOptions = Apollo.BaseMutationOptions<SendScaleAnswerMutation, SendScaleAnswerMutationVariables>;
export const OpenChannelDocument = gql`
    mutation openChannel($channelId: ID!) {
  openChannel(channelId: $channelId) {
    channel {
      id
      isFinished
      isOpen
      createdAt
      endsAt
      sendAt
      topicName
      surveyFinished
      anonymityLevel
      anonymityLocked
      allowedAnonymities
      testing
      public
      allowedLanguages {
        id
        code
      }
      language {
        id
        code
      }
      remainingQuestions
      totalQuestions
      reactions {
        id
        channelId
        messageId
        respondentId
        respondentFullName
        text
        createdAt
      }
      respondent {
        firstname
        surname
        language {
          id
          code
        }
        user {
          id
          username
        }
        organization {
          id
          name
        }
        contacts {
          value
          type
          source
        }
      }
    }
    startingMessages {
      id
      __typename
      text
      createdAt
      createdBy
      isLast
      anonymityLevel
      sentOn {
        id
        anonymityLevel
        anonymityLocked
        isFinished
      }
      ... on Question {
        definition {
          optional
          ...QuestionDefinition
        }
      }
    }
    messages {
      id
      text
      createdAt
      isLast
      createdBy
      anonymityLevel
      ... on FreeTextAnswer {
        question {
          definition {
            ...QuestionDefinition
          }
        }
      }
      ... on SelectAnswer {
        value
        question {
          definition {
            ...QuestionDefinition
          }
        }
      }
      ... on ScaleAnswer {
        value
        statementIndex
        comment
        question {
          definition {
            ...QuestionDefinition
          }
        }
      }
      ... on Question {
        definition {
          ...QuestionDefinition
          optional
        }
      }
    }
    displayLinkToOneplace
    someUnfilledChannel
    someReport
  }
}
    ${QuestionDefinitionFragmentDoc}`;
export type OpenChannelMutationFn = Apollo.MutationFunction<OpenChannelMutation, OpenChannelMutationVariables>;

/**
 * __useOpenChannelMutation__
 *
 * To run a mutation, you first call `useOpenChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openChannelMutation, { data, loading, error }] = useOpenChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useOpenChannelMutation(baseOptions?: Apollo.MutationHookOptions<OpenChannelMutation, OpenChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenChannelMutation, OpenChannelMutationVariables>(OpenChannelDocument, options);
      }
export type OpenChannelMutationHookResult = ReturnType<typeof useOpenChannelMutation>;
export type OpenChannelMutationResult = Apollo.MutationResult<OpenChannelMutation>;
export type OpenChannelMutationOptions = Apollo.BaseMutationOptions<OpenChannelMutation, OpenChannelMutationVariables>;
export const LogAiSurveySummaryAbInteractionDocument = gql`
    mutation logAiSurveySummaryAbInteraction($input: AiSurveySummaryAbInteractionInput!) {
  logAiSurveySummaryAbInteraction(input: $input)
}
    `;
export type LogAiSurveySummaryAbInteractionMutationFn = Apollo.MutationFunction<LogAiSurveySummaryAbInteractionMutation, LogAiSurveySummaryAbInteractionMutationVariables>;

/**
 * __useLogAiSurveySummaryAbInteractionMutation__
 *
 * To run a mutation, you first call `useLogAiSurveySummaryAbInteractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogAiSurveySummaryAbInteractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logAiSurveySummaryAbInteractionMutation, { data, loading, error }] = useLogAiSurveySummaryAbInteractionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogAiSurveySummaryAbInteractionMutation(baseOptions?: Apollo.MutationHookOptions<LogAiSurveySummaryAbInteractionMutation, LogAiSurveySummaryAbInteractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogAiSurveySummaryAbInteractionMutation, LogAiSurveySummaryAbInteractionMutationVariables>(LogAiSurveySummaryAbInteractionDocument, options);
      }
export type LogAiSurveySummaryAbInteractionMutationHookResult = ReturnType<typeof useLogAiSurveySummaryAbInteractionMutation>;
export type LogAiSurveySummaryAbInteractionMutationResult = Apollo.MutationResult<LogAiSurveySummaryAbInteractionMutation>;
export type LogAiSurveySummaryAbInteractionMutationOptions = Apollo.BaseMutationOptions<LogAiSurveySummaryAbInteractionMutation, LogAiSurveySummaryAbInteractionMutationVariables>;
export const ClearAiSurveySummaryCacheDocument = gql`
    mutation clearAiSurveySummaryCache($accessToken: String!, $hash: String!) {
  clearAiSurveySummaryCache(accessToken: $accessToken, hash: $hash) {
    cacheCleared
    limitReached
  }
}
    `;
export type ClearAiSurveySummaryCacheMutationFn = Apollo.MutationFunction<ClearAiSurveySummaryCacheMutation, ClearAiSurveySummaryCacheMutationVariables>;

/**
 * __useClearAiSurveySummaryCacheMutation__
 *
 * To run a mutation, you first call `useClearAiSurveySummaryCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAiSurveySummaryCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAiSurveySummaryCacheMutation, { data, loading, error }] = useClearAiSurveySummaryCacheMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useClearAiSurveySummaryCacheMutation(baseOptions?: Apollo.MutationHookOptions<ClearAiSurveySummaryCacheMutation, ClearAiSurveySummaryCacheMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearAiSurveySummaryCacheMutation, ClearAiSurveySummaryCacheMutationVariables>(ClearAiSurveySummaryCacheDocument, options);
      }
export type ClearAiSurveySummaryCacheMutationHookResult = ReturnType<typeof useClearAiSurveySummaryCacheMutation>;
export type ClearAiSurveySummaryCacheMutationResult = Apollo.MutationResult<ClearAiSurveySummaryCacheMutation>;
export type ClearAiSurveySummaryCacheMutationOptions = Apollo.BaseMutationOptions<ClearAiSurveySummaryCacheMutation, ClearAiSurveySummaryCacheMutationVariables>;
export const CreateChannelDocument = gql`
    mutation createChannel($accessKey: String!, $sourceId: String) {
  createChannel(accessKey: $accessKey, sourceId: $sourceId) {
    channel {
      id
      isFinished
      anonymityLevel
      allowedAnonymities
      allowedLanguages {
        id
        code
      }
      anonymityLocked
      public
      language {
        id
        code
      }
      remainingQuestions
      totalQuestions
      reactions {
        id
        channelId
        messageId
        respondentId
        respondentFullName
        text
        createdAt
      }
    }
    startingMessages {
      id
      __typename
      text
      createdAt
      createdBy
      isLast
      anonymityLevel
      sentOn {
        id
        anonymityLevel
        anonymityLocked
        isFinished
      }
      ... on Question {
        definition {
          optional
          ...QuestionDefinition
        }
      }
    }
  }
}
    ${QuestionDefinitionFragmentDoc}`;
export type CreateChannelMutationFn = Apollo.MutationFunction<CreateChannelMutation, CreateChannelMutationVariables>;

/**
 * __useCreateChannelMutation__
 *
 * To run a mutation, you first call `useCreateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelMutation, { data, loading, error }] = useCreateChannelMutation({
 *   variables: {
 *      accessKey: // value for 'accessKey'
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useCreateChannelMutation(baseOptions?: Apollo.MutationHookOptions<CreateChannelMutation, CreateChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChannelMutation, CreateChannelMutationVariables>(CreateChannelDocument, options);
      }
export type CreateChannelMutationHookResult = ReturnType<typeof useCreateChannelMutation>;
export type CreateChannelMutationResult = Apollo.MutationResult<CreateChannelMutation>;
export type CreateChannelMutationOptions = Apollo.BaseMutationOptions<CreateChannelMutation, CreateChannelMutationVariables>;
export const VerifyPhoneNumbersDocument = gql`
    mutation verifyPhoneNumbers($phoneNumbers: [String!]!, $organizationId: ID) {
  verifyPhoneNumbers(phoneNumbers: $phoneNumbers, organizationId: $organizationId) {
    specifiedPhoneNumber
    phoneNumber
    twilioError {
      code
    }
  }
}
    `;
export type VerifyPhoneNumbersMutationFn = Apollo.MutationFunction<VerifyPhoneNumbersMutation, VerifyPhoneNumbersMutationVariables>;

/**
 * __useVerifyPhoneNumbersMutation__
 *
 * To run a mutation, you first call `useVerifyPhoneNumbersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPhoneNumbersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPhoneNumbersMutation, { data, loading, error }] = useVerifyPhoneNumbersMutation({
 *   variables: {
 *      phoneNumbers: // value for 'phoneNumbers'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useVerifyPhoneNumbersMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPhoneNumbersMutation, VerifyPhoneNumbersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyPhoneNumbersMutation, VerifyPhoneNumbersMutationVariables>(VerifyPhoneNumbersDocument, options);
      }
export type VerifyPhoneNumbersMutationHookResult = ReturnType<typeof useVerifyPhoneNumbersMutation>;
export type VerifyPhoneNumbersMutationResult = Apollo.MutationResult<VerifyPhoneNumbersMutation>;
export type VerifyPhoneNumbersMutationOptions = Apollo.BaseMutationOptions<VerifyPhoneNumbersMutation, VerifyPhoneNumbersMutationVariables>;
export const LogFeEventDocument = gql`
    mutation logFEEvent($eventType: FEEventType!, $payload: FEEventPayload!) {
  logFEEvent(eventType: $eventType, payload: $payload)
}
    `;
export type LogFeEventMutationFn = Apollo.MutationFunction<LogFeEventMutation, LogFeEventMutationVariables>;

/**
 * __useLogFeEventMutation__
 *
 * To run a mutation, you first call `useLogFeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogFeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logFeEventMutation, { data, loading, error }] = useLogFeEventMutation({
 *   variables: {
 *      eventType: // value for 'eventType'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useLogFeEventMutation(baseOptions?: Apollo.MutationHookOptions<LogFeEventMutation, LogFeEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogFeEventMutation, LogFeEventMutationVariables>(LogFeEventDocument, options);
      }
export type LogFeEventMutationHookResult = ReturnType<typeof useLogFeEventMutation>;
export type LogFeEventMutationResult = Apollo.MutationResult<LogFeEventMutation>;
export type LogFeEventMutationOptions = Apollo.BaseMutationOptions<LogFeEventMutation, LogFeEventMutationVariables>;
export const SetLanguageForRespondentDocument = gql`
    mutation setLanguageForRespondent($channelId: ID!, $language: String!) {
  setLanguageForRespondent(channelId: $channelId, language: $language) {
    id
    language {
      id
      code
    }
  }
}
    `;
export type SetLanguageForRespondentMutationFn = Apollo.MutationFunction<SetLanguageForRespondentMutation, SetLanguageForRespondentMutationVariables>;

/**
 * __useSetLanguageForRespondentMutation__
 *
 * To run a mutation, you first call `useSetLanguageForRespondentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLanguageForRespondentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLanguageForRespondentMutation, { data, loading, error }] = useSetLanguageForRespondentMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSetLanguageForRespondentMutation(baseOptions?: Apollo.MutationHookOptions<SetLanguageForRespondentMutation, SetLanguageForRespondentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLanguageForRespondentMutation, SetLanguageForRespondentMutationVariables>(SetLanguageForRespondentDocument, options);
      }
export type SetLanguageForRespondentMutationHookResult = ReturnType<typeof useSetLanguageForRespondentMutation>;
export type SetLanguageForRespondentMutationResult = Apollo.MutationResult<SetLanguageForRespondentMutation>;
export type SetLanguageForRespondentMutationOptions = Apollo.BaseMutationOptions<SetLanguageForRespondentMutation, SetLanguageForRespondentMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($username: String!, $origin: Origin!) {
  resetPassword(username: $username, origin: $origin)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      username: // value for 'username'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($newPassword: String!, $deviceToken: String) {
  changePassword(newPassword: $newPassword, deviceToken: $deviceToken) {
    username
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      deviceToken: // value for 'deviceToken'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const UpdateReportAccessMetricsDocument = gql`
    mutation updateReportAccessMetrics($reportAccessKey: String!, $topicGroupId: Int, $topSeen: Boolean, $bottomSeen: Boolean, $questionsSeen: Int, $questionsTotal: Int, $timeSpentInSec: Int) {
  updateReportAccessMetrics(
    reportAccessKey: $reportAccessKey
    topicGroupId: $topicGroupId
    topSeen: $topSeen
    bottomSeen: $bottomSeen
    questionsSeen: $questionsSeen
    questionsTotal: $questionsTotal
    timeSpentInSec: $timeSpentInSec
  )
}
    `;
export type UpdateReportAccessMetricsMutationFn = Apollo.MutationFunction<UpdateReportAccessMetricsMutation, UpdateReportAccessMetricsMutationVariables>;

/**
 * __useUpdateReportAccessMetricsMutation__
 *
 * To run a mutation, you first call `useUpdateReportAccessMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportAccessMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportAccessMetricsMutation, { data, loading, error }] = useUpdateReportAccessMetricsMutation({
 *   variables: {
 *      reportAccessKey: // value for 'reportAccessKey'
 *      topicGroupId: // value for 'topicGroupId'
 *      topSeen: // value for 'topSeen'
 *      bottomSeen: // value for 'bottomSeen'
 *      questionsSeen: // value for 'questionsSeen'
 *      questionsTotal: // value for 'questionsTotal'
 *      timeSpentInSec: // value for 'timeSpentInSec'
 *   },
 * });
 */
export function useUpdateReportAccessMetricsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportAccessMetricsMutation, UpdateReportAccessMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportAccessMetricsMutation, UpdateReportAccessMetricsMutationVariables>(UpdateReportAccessMetricsDocument, options);
      }
export type UpdateReportAccessMetricsMutationHookResult = ReturnType<typeof useUpdateReportAccessMetricsMutation>;
export type UpdateReportAccessMetricsMutationResult = Apollo.MutationResult<UpdateReportAccessMetricsMutation>;
export type UpdateReportAccessMetricsMutationOptions = Apollo.BaseMutationOptions<UpdateReportAccessMetricsMutation, UpdateReportAccessMetricsMutationVariables>;
export const GenerateOtpDocument = gql`
    mutation generateOtp($username: String!) {
  generateOtp(username: $username)
}
    `;
export type GenerateOtpMutationFn = Apollo.MutationFunction<GenerateOtpMutation, GenerateOtpMutationVariables>;

/**
 * __useGenerateOtpMutation__
 *
 * To run a mutation, you first call `useGenerateOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOtpMutation, { data, loading, error }] = useGenerateOtpMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGenerateOtpMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOtpMutation, GenerateOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOtpMutation, GenerateOtpMutationVariables>(GenerateOtpDocument, options);
      }
export type GenerateOtpMutationHookResult = ReturnType<typeof useGenerateOtpMutation>;
export type GenerateOtpMutationResult = Apollo.MutationResult<GenerateOtpMutation>;
export type GenerateOtpMutationOptions = Apollo.BaseMutationOptions<GenerateOtpMutation, GenerateOtpMutationVariables>;
export const RemoveRespondentFromSurveyGroupWithDateDocument = gql`
    mutation removeRespondentFromSurveyGroupWithDate($surveyGroupId: ID!, $respondentId: ID!, $dateFrom: Date!, $accessToken: String!) {
  removeRespondentFromSurveyGroupWithDate(
    surveyGroupId: $surveyGroupId
    respondentId: $respondentId
    dateFrom: $dateFrom
    accessToken: $accessToken
  )
}
    `;
export type RemoveRespondentFromSurveyGroupWithDateMutationFn = Apollo.MutationFunction<RemoveRespondentFromSurveyGroupWithDateMutation, RemoveRespondentFromSurveyGroupWithDateMutationVariables>;

/**
 * __useRemoveRespondentFromSurveyGroupWithDateMutation__
 *
 * To run a mutation, you first call `useRemoveRespondentFromSurveyGroupWithDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRespondentFromSurveyGroupWithDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRespondentFromSurveyGroupWithDateMutation, { data, loading, error }] = useRemoveRespondentFromSurveyGroupWithDateMutation({
 *   variables: {
 *      surveyGroupId: // value for 'surveyGroupId'
 *      respondentId: // value for 'respondentId'
 *      dateFrom: // value for 'dateFrom'
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useRemoveRespondentFromSurveyGroupWithDateMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRespondentFromSurveyGroupWithDateMutation, RemoveRespondentFromSurveyGroupWithDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRespondentFromSurveyGroupWithDateMutation, RemoveRespondentFromSurveyGroupWithDateMutationVariables>(RemoveRespondentFromSurveyGroupWithDateDocument, options);
      }
export type RemoveRespondentFromSurveyGroupWithDateMutationHookResult = ReturnType<typeof useRemoveRespondentFromSurveyGroupWithDateMutation>;
export type RemoveRespondentFromSurveyGroupWithDateMutationResult = Apollo.MutationResult<RemoveRespondentFromSurveyGroupWithDateMutation>;
export type RemoveRespondentFromSurveyGroupWithDateMutationOptions = Apollo.BaseMutationOptions<RemoveRespondentFromSurveyGroupWithDateMutation, RemoveRespondentFromSurveyGroupWithDateMutationVariables>;
export const DeleteRespondentDocument = gql`
    mutation DeleteRespondent($respondentId: ID!, $accessToken: String) {
  deleteRespondent(respondentId: $respondentId, accessToken: $accessToken)
}
    `;
export type DeleteRespondentMutationFn = Apollo.MutationFunction<DeleteRespondentMutation, DeleteRespondentMutationVariables>;

/**
 * __useDeleteRespondentMutation__
 *
 * To run a mutation, you first call `useDeleteRespondentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRespondentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRespondentMutation, { data, loading, error }] = useDeleteRespondentMutation({
 *   variables: {
 *      respondentId: // value for 'respondentId'
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useDeleteRespondentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRespondentMutation, DeleteRespondentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRespondentMutation, DeleteRespondentMutationVariables>(DeleteRespondentDocument, options);
      }
export type DeleteRespondentMutationHookResult = ReturnType<typeof useDeleteRespondentMutation>;
export type DeleteRespondentMutationResult = Apollo.MutationResult<DeleteRespondentMutation>;
export type DeleteRespondentMutationOptions = Apollo.BaseMutationOptions<DeleteRespondentMutation, DeleteRespondentMutationVariables>;
export const ReopenSurveyDocument = gql`
    mutation ReopenSurvey($input: ReopenSurveyInput!) {
  reopenSurvey(input: $input) {
    id
  }
}
    `;
export type ReopenSurveyMutationFn = Apollo.MutationFunction<ReopenSurveyMutation, ReopenSurveyMutationVariables>;

/**
 * __useReopenSurveyMutation__
 *
 * To run a mutation, you first call `useReopenSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenSurveyMutation, { data, loading, error }] = useReopenSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReopenSurveyMutation(baseOptions?: Apollo.MutationHookOptions<ReopenSurveyMutation, ReopenSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenSurveyMutation, ReopenSurveyMutationVariables>(ReopenSurveyDocument, options);
      }
export type ReopenSurveyMutationHookResult = ReturnType<typeof useReopenSurveyMutation>;
export type ReopenSurveyMutationResult = Apollo.MutationResult<ReopenSurveyMutation>;
export type ReopenSurveyMutationOptions = Apollo.BaseMutationOptions<ReopenSurveyMutation, ReopenSurveyMutationVariables>;
export const CreateSurveyDocument = gql`
    mutation CreateSurvey($input: CreateSurveyInput!) {
  createSurvey(input: $input) {
    id
  }
}
    `;
export type CreateSurveyMutationFn = Apollo.MutationFunction<CreateSurveyMutation, CreateSurveyMutationVariables>;

/**
 * __useCreateSurveyMutation__
 *
 * To run a mutation, you first call `useCreateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyMutation, { data, loading, error }] = useCreateSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurveyMutation, CreateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurveyMutation, CreateSurveyMutationVariables>(CreateSurveyDocument, options);
      }
export type CreateSurveyMutationHookResult = ReturnType<typeof useCreateSurveyMutation>;
export type CreateSurveyMutationResult = Apollo.MutationResult<CreateSurveyMutation>;
export type CreateSurveyMutationOptions = Apollo.BaseMutationOptions<CreateSurveyMutation, CreateSurveyMutationVariables>;
export const SendInvitationAgainDocument = gql`
    mutation SendInvitationAgain($surveyId: ID!, $respondentId: ID!, $templateUid: String, $accessToken: String) {
  sendInvitationAgain(
    surveyId: $surveyId
    respondentId: $respondentId
    templateUid: $templateUid
    accessToken: $accessToken
  )
}
    `;
export type SendInvitationAgainMutationFn = Apollo.MutationFunction<SendInvitationAgainMutation, SendInvitationAgainMutationVariables>;

/**
 * __useSendInvitationAgainMutation__
 *
 * To run a mutation, you first call `useSendInvitationAgainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitationAgainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitationAgainMutation, { data, loading, error }] = useSendInvitationAgainMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      respondentId: // value for 'respondentId'
 *      templateUid: // value for 'templateUid'
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useSendInvitationAgainMutation(baseOptions?: Apollo.MutationHookOptions<SendInvitationAgainMutation, SendInvitationAgainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvitationAgainMutation, SendInvitationAgainMutationVariables>(SendInvitationAgainDocument, options);
      }
export type SendInvitationAgainMutationHookResult = ReturnType<typeof useSendInvitationAgainMutation>;
export type SendInvitationAgainMutationResult = Apollo.MutationResult<SendInvitationAgainMutation>;
export type SendInvitationAgainMutationOptions = Apollo.BaseMutationOptions<SendInvitationAgainMutation, SendInvitationAgainMutationVariables>;
export const UpdateSurveyDocument = gql`
    mutation UpdateSurvey($surveyId: ID!, $input: UpdateSurveyInput!) {
  updateSurvey(surveyId: $surveyId, input: $input) {
    id
  }
}
    `;
export type UpdateSurveyMutationFn = Apollo.MutationFunction<UpdateSurveyMutation, UpdateSurveyMutationVariables>;

/**
 * __useUpdateSurveyMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyMutation, { data, loading, error }] = useUpdateSurveyMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyMutation, UpdateSurveyMutationVariables>(UpdateSurveyDocument, options);
      }
export type UpdateSurveyMutationHookResult = ReturnType<typeof useUpdateSurveyMutation>;
export type UpdateSurveyMutationResult = Apollo.MutationResult<UpdateSurveyMutation>;
export type UpdateSurveyMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>;
export const SendReportOpenMetricsDocument = gql`
    mutation sendReportOpenMetrics($reportAccessKey: String!, $channelIds: [ID!]!, $reportView: ReportOpenMetricsView!, $sysAdmin: Boolean!, $orgAdmin: Boolean!) {
  sendReportOpenMetrics(
    reportAccessKey: $reportAccessKey
    channelIds: $channelIds
    reportView: $reportView
    sysAdmin: $sysAdmin
    orgAdmin: $orgAdmin
  )
}
    `;
export type SendReportOpenMetricsMutationFn = Apollo.MutationFunction<SendReportOpenMetricsMutation, SendReportOpenMetricsMutationVariables>;

/**
 * __useSendReportOpenMetricsMutation__
 *
 * To run a mutation, you first call `useSendReportOpenMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReportOpenMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReportOpenMetricsMutation, { data, loading, error }] = useSendReportOpenMetricsMutation({
 *   variables: {
 *      reportAccessKey: // value for 'reportAccessKey'
 *      channelIds: // value for 'channelIds'
 *      reportView: // value for 'reportView'
 *      sysAdmin: // value for 'sysAdmin'
 *      orgAdmin: // value for 'orgAdmin'
 *   },
 * });
 */
export function useSendReportOpenMetricsMutation(baseOptions?: Apollo.MutationHookOptions<SendReportOpenMetricsMutation, SendReportOpenMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendReportOpenMetricsMutation, SendReportOpenMetricsMutationVariables>(SendReportOpenMetricsDocument, options);
      }
export type SendReportOpenMetricsMutationHookResult = ReturnType<typeof useSendReportOpenMetricsMutation>;
export type SendReportOpenMetricsMutationResult = Apollo.MutationResult<SendReportOpenMetricsMutation>;
export type SendReportOpenMetricsMutationOptions = Apollo.BaseMutationOptions<SendReportOpenMetricsMutation, SendReportOpenMetricsMutationVariables>;
export const UpdateRespondentDocument = gql`
    mutation UpdateRespondent($id: ID!, $input: UpdateRespondentFromReportInput!, $accessToken: String!) {
  updateRespondentFromReport(
    respondentId: $id
    input: $input
    accessToken: $accessToken
  ) {
    id
    firstname
    surname
  }
}
    `;
export type UpdateRespondentMutationFn = Apollo.MutationFunction<UpdateRespondentMutation, UpdateRespondentMutationVariables>;

/**
 * __useUpdateRespondentMutation__
 *
 * To run a mutation, you first call `useUpdateRespondentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRespondentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRespondentMutation, { data, loading, error }] = useUpdateRespondentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useUpdateRespondentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRespondentMutation, UpdateRespondentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRespondentMutation, UpdateRespondentMutationVariables>(UpdateRespondentDocument, options);
      }
export type UpdateRespondentMutationHookResult = ReturnType<typeof useUpdateRespondentMutation>;
export type UpdateRespondentMutationResult = Apollo.MutationResult<UpdateRespondentMutation>;
export type UpdateRespondentMutationOptions = Apollo.BaseMutationOptions<UpdateRespondentMutation, UpdateRespondentMutationVariables>;
export const SetUserSummaryNotificationsDocument = gql`
    mutation setUserSummaryNotifications($auth: OnePlaceAuthInput, $on: Boolean!) {
  setUserSummaryNotifications(auth: $auth, on: $on)
}
    `;
export type SetUserSummaryNotificationsMutationFn = Apollo.MutationFunction<SetUserSummaryNotificationsMutation, SetUserSummaryNotificationsMutationVariables>;

/**
 * __useSetUserSummaryNotificationsMutation__
 *
 * To run a mutation, you first call `useSetUserSummaryNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserSummaryNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserSummaryNotificationsMutation, { data, loading, error }] = useSetUserSummaryNotificationsMutation({
 *   variables: {
 *      auth: // value for 'auth'
 *      on: // value for 'on'
 *   },
 * });
 */
export function useSetUserSummaryNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<SetUserSummaryNotificationsMutation, SetUserSummaryNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserSummaryNotificationsMutation, SetUserSummaryNotificationsMutationVariables>(SetUserSummaryNotificationsDocument, options);
      }
export type SetUserSummaryNotificationsMutationHookResult = ReturnType<typeof useSetUserSummaryNotificationsMutation>;
export type SetUserSummaryNotificationsMutationResult = Apollo.MutationResult<SetUserSummaryNotificationsMutation>;
export type SetUserSummaryNotificationsMutationOptions = Apollo.BaseMutationOptions<SetUserSummaryNotificationsMutation, SetUserSummaryNotificationsMutationVariables>;
export const SetRespondentNewAnswersNotificationsDocument = gql`
    mutation setRespondentNewAnswersNotifications($auth: OnePlaceAuthInput, $respondentId: ID!, $notificationLevel: NotificationLevel!) {
  setRespondentNewAnswersNotifications(
    auth: $auth
    respondentId: $respondentId
    notificationLevel: $notificationLevel
  )
}
    `;
export type SetRespondentNewAnswersNotificationsMutationFn = Apollo.MutationFunction<SetRespondentNewAnswersNotificationsMutation, SetRespondentNewAnswersNotificationsMutationVariables>;

/**
 * __useSetRespondentNewAnswersNotificationsMutation__
 *
 * To run a mutation, you first call `useSetRespondentNewAnswersNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRespondentNewAnswersNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRespondentNewAnswersNotificationsMutation, { data, loading, error }] = useSetRespondentNewAnswersNotificationsMutation({
 *   variables: {
 *      auth: // value for 'auth'
 *      respondentId: // value for 'respondentId'
 *      notificationLevel: // value for 'notificationLevel'
 *   },
 * });
 */
export function useSetRespondentNewAnswersNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<SetRespondentNewAnswersNotificationsMutation, SetRespondentNewAnswersNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRespondentNewAnswersNotificationsMutation, SetRespondentNewAnswersNotificationsMutationVariables>(SetRespondentNewAnswersNotificationsDocument, options);
      }
export type SetRespondentNewAnswersNotificationsMutationHookResult = ReturnType<typeof useSetRespondentNewAnswersNotificationsMutation>;
export type SetRespondentNewAnswersNotificationsMutationResult = Apollo.MutationResult<SetRespondentNewAnswersNotificationsMutation>;
export type SetRespondentNewAnswersNotificationsMutationOptions = Apollo.BaseMutationOptions<SetRespondentNewAnswersNotificationsMutation, SetRespondentNewAnswersNotificationsMutationVariables>;
export const SendReactionDocument = gql`
    mutation sendReaction($accessToken: String!, $channelId: ID!, $messageId: ID, $text: String!) {
  sendReaction(
    accessToken: $accessToken
    channelId: $channelId
    messageId: $messageId
    text: $text
  ) {
    id
    channelId
    messageId
    respondentId
    text
    createdAt
  }
}
    `;
export type SendReactionMutationFn = Apollo.MutationFunction<SendReactionMutation, SendReactionMutationVariables>;

/**
 * __useSendReactionMutation__
 *
 * To run a mutation, you first call `useSendReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReactionMutation, { data, loading, error }] = useSendReactionMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      channelId: // value for 'channelId'
 *      messageId: // value for 'messageId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSendReactionMutation(baseOptions?: Apollo.MutationHookOptions<SendReactionMutation, SendReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendReactionMutation, SendReactionMutationVariables>(SendReactionDocument, options);
      }
export type SendReactionMutationHookResult = ReturnType<typeof useSendReactionMutation>;
export type SendReactionMutationResult = Apollo.MutationResult<SendReactionMutation>;
export type SendReactionMutationOptions = Apollo.BaseMutationOptions<SendReactionMutation, SendReactionMutationVariables>;
export const GetMessagesDocument = gql`
    query getMessages($channelId: ID!) {
  messages(channelId: $channelId) {
    id
    text
    createdAt
    isLast
    createdBy
    ... on FreeTextAnswer {
      question {
        definition {
          ...QuestionDefinition
        }
      }
    }
    ... on SelectAnswer {
      value
      question {
        definition {
          ...QuestionDefinition
        }
      }
    }
    ... on ScaleAnswer {
      value
      statementIndex
      comment
      question {
        definition {
          ...QuestionDefinition
        }
      }
    }
    anonymityLevel
    ... on Question {
      definition {
        ...QuestionDefinition
        optional
      }
    }
  }
}
    ${QuestionDefinitionFragmentDoc}`;

/**
 * __useGetMessagesQuery__
 *
 * To run a query within a React component, call `useGetMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, options);
      }
export function useGetMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, options);
        }
export function useGetMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, options);
        }
export type GetMessagesQueryHookResult = ReturnType<typeof useGetMessagesQuery>;
export type GetMessagesLazyQueryHookResult = ReturnType<typeof useGetMessagesLazyQuery>;
export type GetMessagesSuspenseQueryHookResult = ReturnType<typeof useGetMessagesSuspenseQuery>;
export type GetMessagesQueryResult = Apollo.QueryResult<GetMessagesQuery, GetMessagesQueryVariables>;
export const GetChannelDocument = gql`
    query getChannel($channelId: ID!) {
  channel(channelId: $channelId) {
    id
    anonymityLevel
    anonymityLocked
    isFinished
    isOpen
    createdAt
    endsAt
    topicName
    allowedLanguages {
      id
      code
    }
    allowedAnonymities
    reactions {
      id
      channelId
      messageId
      respondentId
      respondentFullName
      text
      createdAt
    }
    respondent {
      firstname
      surname
      user {
        username
        id
      }
      contacts {
        value
        type
        source
      }
      organization {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetChannelQuery__
 *
 * To run a query within a React component, call `useGetChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelQuery(baseOptions: Apollo.QueryHookOptions<GetChannelQuery, GetChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelQuery, GetChannelQueryVariables>(GetChannelDocument, options);
      }
export function useGetChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelQuery, GetChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelQuery, GetChannelQueryVariables>(GetChannelDocument, options);
        }
export function useGetChannelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChannelQuery, GetChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChannelQuery, GetChannelQueryVariables>(GetChannelDocument, options);
        }
export type GetChannelQueryHookResult = ReturnType<typeof useGetChannelQuery>;
export type GetChannelLazyQueryHookResult = ReturnType<typeof useGetChannelLazyQuery>;
export type GetChannelSuspenseQueryHookResult = ReturnType<typeof useGetChannelSuspenseQuery>;
export type GetChannelQueryResult = Apollo.QueryResult<GetChannelQuery, GetChannelQueryVariables>;
export const GetChannelSlugForIdNumberDocument = gql`
    query getChannelSlugForIdNumber($surveyId: ID!, $respondentIdNo: String!) {
  getChannelSlugForIdNumber(surveyId: $surveyId, respondentIdNo: $respondentIdNo)
}
    `;

/**
 * __useGetChannelSlugForIdNumberQuery__
 *
 * To run a query within a React component, call `useGetChannelSlugForIdNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelSlugForIdNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelSlugForIdNumberQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      respondentIdNo: // value for 'respondentIdNo'
 *   },
 * });
 */
export function useGetChannelSlugForIdNumberQuery(baseOptions: Apollo.QueryHookOptions<GetChannelSlugForIdNumberQuery, GetChannelSlugForIdNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelSlugForIdNumberQuery, GetChannelSlugForIdNumberQueryVariables>(GetChannelSlugForIdNumberDocument, options);
      }
export function useGetChannelSlugForIdNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelSlugForIdNumberQuery, GetChannelSlugForIdNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelSlugForIdNumberQuery, GetChannelSlugForIdNumberQueryVariables>(GetChannelSlugForIdNumberDocument, options);
        }
export function useGetChannelSlugForIdNumberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChannelSlugForIdNumberQuery, GetChannelSlugForIdNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChannelSlugForIdNumberQuery, GetChannelSlugForIdNumberQueryVariables>(GetChannelSlugForIdNumberDocument, options);
        }
export type GetChannelSlugForIdNumberQueryHookResult = ReturnType<typeof useGetChannelSlugForIdNumberQuery>;
export type GetChannelSlugForIdNumberLazyQueryHookResult = ReturnType<typeof useGetChannelSlugForIdNumberLazyQuery>;
export type GetChannelSlugForIdNumberSuspenseQueryHookResult = ReturnType<typeof useGetChannelSlugForIdNumberSuspenseQuery>;
export type GetChannelSlugForIdNumberQueryResult = Apollo.QueryResult<GetChannelSlugForIdNumberQuery, GetChannelSlugForIdNumberQueryVariables>;
export const IsAccessTokenValidDocument = gql`
    query isAccessTokenValid {
  isAccessTokenValid {
    expireAt
    status
    consent
    user {
      id
      marketingConsent
      username
      firstname
      systemRole
      surname
      summaryNotifications
      organization {
        id
        name
        systemName
        primaryLanguageCode
      }
      respondents {
        id
        firstname
        surname
        organizationRole
        isLeader
        isReportRecipient
        newAnswersNotifications
        language {
          id
          code
        }
        contacts {
          value
          type
          source
        }
        channels {
          id
          isOpen
          isFinished
          createdAt
          sendAt
          endsAt
          topicName
          surveyFinished
          disabled
          isFinishedByRespondent
          containsOriginalAnonymity
          reactions {
            id
          }
        }
        reports {
          accessKey
          survey {
            sendAt
            endsAt
          }
          topicName
          surveyGroup {
            from
            to
          }
          unreadMessages {
            count
            from
          }
        }
        organization {
          id
          name
          systemName
          productVersionHistory {
            product
            licenceCount
            validFrom
            validTo
          }
          companyId
          primaryLanguageCode
          languages {
            code
          }
          processNotificationsDefault
          processNotificationsLocked
          featureNames
        }
      }
    }
  }
}
    `;

/**
 * __useIsAccessTokenValidQuery__
 *
 * To run a query within a React component, call `useIsAccessTokenValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsAccessTokenValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsAccessTokenValidQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsAccessTokenValidQuery(baseOptions?: Apollo.QueryHookOptions<IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables>(IsAccessTokenValidDocument, options);
      }
export function useIsAccessTokenValidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables>(IsAccessTokenValidDocument, options);
        }
export function useIsAccessTokenValidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables>(IsAccessTokenValidDocument, options);
        }
export type IsAccessTokenValidQueryHookResult = ReturnType<typeof useIsAccessTokenValidQuery>;
export type IsAccessTokenValidLazyQueryHookResult = ReturnType<typeof useIsAccessTokenValidLazyQuery>;
export type IsAccessTokenValidSuspenseQueryHookResult = ReturnType<typeof useIsAccessTokenValidSuspenseQuery>;
export type IsAccessTokenValidQueryResult = Apollo.QueryResult<IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables>;
export const ChannelOverviewDocument = gql`
    query channelOverview($channelSlug: ID!, $languageCode: String) {
  channelOverview(channelSlug: $channelSlug, languageCode: $languageCode) {
    respondents {
      id
      firstname
      surname
      organizationRole
      isLeader
      isReportRecipient
      newAnswersNotifications
      channels {
        id
        isOpen
        isFinished
        createdAt
        sendAt
        endsAt
        topicName
        surveyFinished
        disabled
        isFinishedByRespondent
        containsOriginalAnonymity
        reactions {
          id
        }
      }
      reports {
        accessKey
        survey {
          sendAt
          endsAt
        }
        topicName
        surveyGroup {
          from
          to
        }
        unreadMessages {
          count
          from
        }
      }
      organization {
        id
        name
        processNotificationsDefault
        processNotificationsLocked
        featureNames
      }
    }
    user {
      id
      username
      firstname
      surname
      intercomHash
      summaryNotifications
    }
  }
}
    `;

/**
 * __useChannelOverviewQuery__
 *
 * To run a query within a React component, call `useChannelOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelOverviewQuery({
 *   variables: {
 *      channelSlug: // value for 'channelSlug'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useChannelOverviewQuery(baseOptions: Apollo.QueryHookOptions<ChannelOverviewQuery, ChannelOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelOverviewQuery, ChannelOverviewQueryVariables>(ChannelOverviewDocument, options);
      }
export function useChannelOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelOverviewQuery, ChannelOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelOverviewQuery, ChannelOverviewQueryVariables>(ChannelOverviewDocument, options);
        }
export function useChannelOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelOverviewQuery, ChannelOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChannelOverviewQuery, ChannelOverviewQueryVariables>(ChannelOverviewDocument, options);
        }
export type ChannelOverviewQueryHookResult = ReturnType<typeof useChannelOverviewQuery>;
export type ChannelOverviewLazyQueryHookResult = ReturnType<typeof useChannelOverviewLazyQuery>;
export type ChannelOverviewSuspenseQueryHookResult = ReturnType<typeof useChannelOverviewSuspenseQuery>;
export type ChannelOverviewQueryResult = Apollo.QueryResult<ChannelOverviewQuery, ChannelOverviewQueryVariables>;
export const ReportSequenceRespondentDetailQueryDocument = gql`
    query ReportSequenceRespondentDetailQuery($languageCode: String, $accessToken: String!, $publicAccess: Boolean, $respondentId: ID!, $seqDate: String) {
  getProcessReportRespondentDetail(
    languageCode: $languageCode
    accessToken: $accessToken
    publicAccess: $publicAccess
    respondentId: $respondentId
    seqDate: $seqDate
  ) {
    ...ProcessReportRespondentDetail
  }
}
    ${ProcessReportRespondentDetailFragmentDoc}`;

/**
 * __useReportSequenceRespondentDetailQueryQuery__
 *
 * To run a query within a React component, call `useReportSequenceRespondentDetailQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportSequenceRespondentDetailQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSequenceRespondentDetailQueryQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      accessToken: // value for 'accessToken'
 *      publicAccess: // value for 'publicAccess'
 *      respondentId: // value for 'respondentId'
 *      seqDate: // value for 'seqDate'
 *   },
 * });
 */
export function useReportSequenceRespondentDetailQueryQuery(baseOptions: Apollo.QueryHookOptions<ReportSequenceRespondentDetailQueryQuery, ReportSequenceRespondentDetailQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportSequenceRespondentDetailQueryQuery, ReportSequenceRespondentDetailQueryQueryVariables>(ReportSequenceRespondentDetailQueryDocument, options);
      }
export function useReportSequenceRespondentDetailQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportSequenceRespondentDetailQueryQuery, ReportSequenceRespondentDetailQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportSequenceRespondentDetailQueryQuery, ReportSequenceRespondentDetailQueryQueryVariables>(ReportSequenceRespondentDetailQueryDocument, options);
        }
export function useReportSequenceRespondentDetailQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportSequenceRespondentDetailQueryQuery, ReportSequenceRespondentDetailQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportSequenceRespondentDetailQueryQuery, ReportSequenceRespondentDetailQueryQueryVariables>(ReportSequenceRespondentDetailQueryDocument, options);
        }
export type ReportSequenceRespondentDetailQueryQueryHookResult = ReturnType<typeof useReportSequenceRespondentDetailQueryQuery>;
export type ReportSequenceRespondentDetailQueryLazyQueryHookResult = ReturnType<typeof useReportSequenceRespondentDetailQueryLazyQuery>;
export type ReportSequenceRespondentDetailQuerySuspenseQueryHookResult = ReturnType<typeof useReportSequenceRespondentDetailQuerySuspenseQuery>;
export type ReportSequenceRespondentDetailQueryQueryResult = Apollo.QueryResult<ReportSequenceRespondentDetailQueryQuery, ReportSequenceRespondentDetailQueryQueryVariables>;
export const SecureRespondentDetailDocument = gql`
    query SecureRespondentDetail($languageCode: String, $accessToken: String!, $seqDate: String) {
  getSecureRespondentDetail(
    languageCode: $languageCode
    accessToken: $accessToken
    seqDate: $seqDate
  ) {
    ...ProcessReportRespondentDetail
  }
}
    ${ProcessReportRespondentDetailFragmentDoc}`;

/**
 * __useSecureRespondentDetailQuery__
 *
 * To run a query within a React component, call `useSecureRespondentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecureRespondentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecureRespondentDetailQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      accessToken: // value for 'accessToken'
 *      seqDate: // value for 'seqDate'
 *   },
 * });
 */
export function useSecureRespondentDetailQuery(baseOptions: Apollo.QueryHookOptions<SecureRespondentDetailQuery, SecureRespondentDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SecureRespondentDetailQuery, SecureRespondentDetailQueryVariables>(SecureRespondentDetailDocument, options);
      }
export function useSecureRespondentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SecureRespondentDetailQuery, SecureRespondentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SecureRespondentDetailQuery, SecureRespondentDetailQueryVariables>(SecureRespondentDetailDocument, options);
        }
export function useSecureRespondentDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SecureRespondentDetailQuery, SecureRespondentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SecureRespondentDetailQuery, SecureRespondentDetailQueryVariables>(SecureRespondentDetailDocument, options);
        }
export type SecureRespondentDetailQueryHookResult = ReturnType<typeof useSecureRespondentDetailQuery>;
export type SecureRespondentDetailLazyQueryHookResult = ReturnType<typeof useSecureRespondentDetailLazyQuery>;
export type SecureRespondentDetailSuspenseQueryHookResult = ReturnType<typeof useSecureRespondentDetailSuspenseQuery>;
export type SecureRespondentDetailQueryResult = Apollo.QueryResult<SecureRespondentDetailQuery, SecureRespondentDetailQueryVariables>;
export const SurveyPublicInfoDocument = gql`
    query surveyPublicInfo($surveyId: ID!, $langCode: String) {
  surveyPublicInfo(surveyId: $surveyId, langCode: $langCode) {
    id
    topicGroupName
    organizationName
    endsAt
    status
  }
}
    `;

/**
 * __useSurveyPublicInfoQuery__
 *
 * To run a query within a React component, call `useSurveyPublicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyPublicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyPublicInfoQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      langCode: // value for 'langCode'
 *   },
 * });
 */
export function useSurveyPublicInfoQuery(baseOptions: Apollo.QueryHookOptions<SurveyPublicInfoQuery, SurveyPublicInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyPublicInfoQuery, SurveyPublicInfoQueryVariables>(SurveyPublicInfoDocument, options);
      }
export function useSurveyPublicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyPublicInfoQuery, SurveyPublicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyPublicInfoQuery, SurveyPublicInfoQueryVariables>(SurveyPublicInfoDocument, options);
        }
export function useSurveyPublicInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyPublicInfoQuery, SurveyPublicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyPublicInfoQuery, SurveyPublicInfoQueryVariables>(SurveyPublicInfoDocument, options);
        }
export type SurveyPublicInfoQueryHookResult = ReturnType<typeof useSurveyPublicInfoQuery>;
export type SurveyPublicInfoLazyQueryHookResult = ReturnType<typeof useSurveyPublicInfoLazyQuery>;
export type SurveyPublicInfoSuspenseQueryHookResult = ReturnType<typeof useSurveyPublicInfoSuspenseQuery>;
export type SurveyPublicInfoQueryResult = Apollo.QueryResult<SurveyPublicInfoQuery, SurveyPublicInfoQueryVariables>;
export const GetComparsionDataForProcessReportDocument = gql`
    query getComparsionDataForProcessReport($accessToken: String!, $periods: [DateRangeInput!]!, $teamsFilter: [String!]) {
  getComparsionDataForProcessReport(
    accessToken: $accessToken
    periods: $periods
    teamFilters: $teamsFilter
  ) {
    id
    stepStatistics {
      periodIndex
      stepId
      avgMetric
      statistics {
        withoutProblems {
          denominator
          numerator
        }
        responseRate {
          numerator
          denominator
        }
        anonymityRate {
          numerator
          denominator
        }
        finishedRate {
          numerator
          denominator
        }
      }
    }
  }
}
    `;

/**
 * __useGetComparsionDataForProcessReportQuery__
 *
 * To run a query within a React component, call `useGetComparsionDataForProcessReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComparsionDataForProcessReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComparsionDataForProcessReportQuery({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      periods: // value for 'periods'
 *      teamsFilter: // value for 'teamsFilter'
 *   },
 * });
 */
export function useGetComparsionDataForProcessReportQuery(baseOptions: Apollo.QueryHookOptions<GetComparsionDataForProcessReportQuery, GetComparsionDataForProcessReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetComparsionDataForProcessReportQuery, GetComparsionDataForProcessReportQueryVariables>(GetComparsionDataForProcessReportDocument, options);
      }
export function useGetComparsionDataForProcessReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetComparsionDataForProcessReportQuery, GetComparsionDataForProcessReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetComparsionDataForProcessReportQuery, GetComparsionDataForProcessReportQueryVariables>(GetComparsionDataForProcessReportDocument, options);
        }
export function useGetComparsionDataForProcessReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetComparsionDataForProcessReportQuery, GetComparsionDataForProcessReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetComparsionDataForProcessReportQuery, GetComparsionDataForProcessReportQueryVariables>(GetComparsionDataForProcessReportDocument, options);
        }
export type GetComparsionDataForProcessReportQueryHookResult = ReturnType<typeof useGetComparsionDataForProcessReportQuery>;
export type GetComparsionDataForProcessReportLazyQueryHookResult = ReturnType<typeof useGetComparsionDataForProcessReportLazyQuery>;
export type GetComparsionDataForProcessReportSuspenseQueryHookResult = ReturnType<typeof useGetComparsionDataForProcessReportSuspenseQuery>;
export type GetComparsionDataForProcessReportQueryResult = Apollo.QueryResult<GetComparsionDataForProcessReportQuery, GetComparsionDataForProcessReportQueryVariables>;
export const GetProcessReportRespondentsDocument = gql`
    query getProcessReportRespondents($accessToken: String!, $addedOnFrom: Date, $addedOnTo: Date, $teamsFilter: [String!], $pagination: Pagination, $searchQuery: String, $positionIds: [ID!], $recruiterIds: [ID!], $managerIds: [ID!], $withoutDeleted: Boolean, $showOnlyUnread: Boolean) {
  getProcessReportRespondents(
    accessToken: $accessToken
    addedOnFrom: $addedOnFrom
    addedOnTo: $addedOnTo
    teamFilters: $teamsFilter
    pagination: $pagination
    searchQuery: $searchQuery
    positionIds: $positionIds
    recruiterIds: $recruiterIds
    managerIds: $managerIds
    withoutDeleted: $withoutDeleted
    showOnlyUnread: $showOnlyUnread
  ) {
    data {
      metricQuestionsForRespondent {
        respondentId
        answers {
          topicGroupId
          value
        }
      }
      creditsToReturn {
        respondentId
        creditsToReturn
      }
      respondents {
        id
        preferredContactType
        firstname
        surname
        deleted
        contacts {
          type
          source
          value
          phoneNumber {
            countryCallingCode
            nationalNumber
          }
        }
      }
      addedOn
      surveys {
        id
        status
        sendAt
        endsAt
        topicGroup {
          id
        }
        respondentIds
        publicChannels {
          id
          respondentId
          lastRemindedAt
          maxAnonymousHighlightedLevel
          withAnswer
          isFinishedByRespondent
          finishedAt
        }
      }
      hiringSurveys {
        id
        status
        sendAt
        endsAt
        topicGroup {
          id
        }
        respondentIds
        publicChannels {
          id
          respondentId
          lastRemindedAt
          maxAnonymousHighlightedLevel
          withAnswer
          isFinishedByRespondent
          finishedAt
        }
      }
      hiringAdditionalData {
        respondentId
        position
        isHired
        isRejected
        recruiterName
      }
      deletedRespondents
      undeliveredInvitations {
        respondentId
        undeliveredSurveyInvitations {
          surveyId
          contact
          status
        }
      }
      hasUnreadMessages {
        respondentId
        unreadMessages
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetProcessReportRespondentsQuery__
 *
 * To run a query within a React component, call `useGetProcessReportRespondentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessReportRespondentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessReportRespondentsQuery({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      addedOnFrom: // value for 'addedOnFrom'
 *      addedOnTo: // value for 'addedOnTo'
 *      teamsFilter: // value for 'teamsFilter'
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *      positionIds: // value for 'positionIds'
 *      recruiterIds: // value for 'recruiterIds'
 *      managerIds: // value for 'managerIds'
 *      withoutDeleted: // value for 'withoutDeleted'
 *      showOnlyUnread: // value for 'showOnlyUnread'
 *   },
 * });
 */
export function useGetProcessReportRespondentsQuery(baseOptions: Apollo.QueryHookOptions<GetProcessReportRespondentsQuery, GetProcessReportRespondentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessReportRespondentsQuery, GetProcessReportRespondentsQueryVariables>(GetProcessReportRespondentsDocument, options);
      }
export function useGetProcessReportRespondentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessReportRespondentsQuery, GetProcessReportRespondentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessReportRespondentsQuery, GetProcessReportRespondentsQueryVariables>(GetProcessReportRespondentsDocument, options);
        }
export function useGetProcessReportRespondentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessReportRespondentsQuery, GetProcessReportRespondentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessReportRespondentsQuery, GetProcessReportRespondentsQueryVariables>(GetProcessReportRespondentsDocument, options);
        }
export type GetProcessReportRespondentsQueryHookResult = ReturnType<typeof useGetProcessReportRespondentsQuery>;
export type GetProcessReportRespondentsLazyQueryHookResult = ReturnType<typeof useGetProcessReportRespondentsLazyQuery>;
export type GetProcessReportRespondentsSuspenseQueryHookResult = ReturnType<typeof useGetProcessReportRespondentsSuspenseQuery>;
export type GetProcessReportRespondentsQueryResult = Apollo.QueryResult<GetProcessReportRespondentsQuery, GetProcessReportRespondentsQueryVariables>;
export const LastMessagesForRespondentDocument = gql`
    query lastMessagesForRespondent($surveyIds: [ID!]!, $respondentIds: [ID!]!, $accessToken: String) {
  lastMessagesForRespondent(
    surveyIds: $surveyIds
    respondentIds: $respondentIds
    accessToken: $accessToken
  ) {
    id
    messageStatus
    processed
    createdAt
    error
    surveyId
    respondentId
  }
}
    `;

/**
 * __useLastMessagesForRespondentQuery__
 *
 * To run a query within a React component, call `useLastMessagesForRespondentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastMessagesForRespondentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastMessagesForRespondentQuery({
 *   variables: {
 *      surveyIds: // value for 'surveyIds'
 *      respondentIds: // value for 'respondentIds'
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useLastMessagesForRespondentQuery(baseOptions: Apollo.QueryHookOptions<LastMessagesForRespondentQuery, LastMessagesForRespondentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastMessagesForRespondentQuery, LastMessagesForRespondentQueryVariables>(LastMessagesForRespondentDocument, options);
      }
export function useLastMessagesForRespondentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastMessagesForRespondentQuery, LastMessagesForRespondentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastMessagesForRespondentQuery, LastMessagesForRespondentQueryVariables>(LastMessagesForRespondentDocument, options);
        }
export function useLastMessagesForRespondentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LastMessagesForRespondentQuery, LastMessagesForRespondentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LastMessagesForRespondentQuery, LastMessagesForRespondentQueryVariables>(LastMessagesForRespondentDocument, options);
        }
export type LastMessagesForRespondentQueryHookResult = ReturnType<typeof useLastMessagesForRespondentQuery>;
export type LastMessagesForRespondentLazyQueryHookResult = ReturnType<typeof useLastMessagesForRespondentLazyQuery>;
export type LastMessagesForRespondentSuspenseQueryHookResult = ReturnType<typeof useLastMessagesForRespondentSuspenseQuery>;
export type LastMessagesForRespondentQueryResult = Apollo.QueryResult<LastMessagesForRespondentQuery, LastMessagesForRespondentQueryVariables>;
export const GetReportDocument = gql`
    query getReport($languageCode: String, $accessToken: String!, $reportDefinitionId: ID, $topicGroupId: ID, $addedOnFrom: Date, $addedOnTo: Date, $publicAccess: Boolean) {
  getReport(
    languageCode: $languageCode
    accessToken: $accessToken
    reportDefinitionId: $reportDefinitionId
    topicGroupId: $topicGroupId
    addedOnFrom: $addedOnFrom
    addedOnTo: $addedOnTo
    publicAccess: $publicAccess
  ) {
    ...ReportFragment
  }
}
    ${ReportFragmentFragmentDoc}`;

/**
 * __useGetReportQuery__
 *
 * To run a query within a React component, call `useGetReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      accessToken: // value for 'accessToken'
 *      reportDefinitionId: // value for 'reportDefinitionId'
 *      topicGroupId: // value for 'topicGroupId'
 *      addedOnFrom: // value for 'addedOnFrom'
 *      addedOnTo: // value for 'addedOnTo'
 *      publicAccess: // value for 'publicAccess'
 *   },
 * });
 */
export function useGetReportQuery(baseOptions: Apollo.QueryHookOptions<GetReportQuery, GetReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options);
      }
export function useGetReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportQuery, GetReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options);
        }
export function useGetReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportQuery, GetReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options);
        }
export type GetReportQueryHookResult = ReturnType<typeof useGetReportQuery>;
export type GetReportLazyQueryHookResult = ReturnType<typeof useGetReportLazyQuery>;
export type GetReportSuspenseQueryHookResult = ReturnType<typeof useGetReportSuspenseQuery>;
export type GetReportQueryResult = Apollo.QueryResult<GetReportQuery, GetReportQueryVariables>;
export const GetProcessReportDocument = gql`
    query getProcessReport($languageCode: String, $accessToken: String!, $addedOnFrom: Date, $addedOnTo: Date, $publicAccess: Boolean, $teamsFilter: [String!], $positionIds: [ID!], $recruiterIds: [ID!], $managerIds: [ID!], $withoutDeleted: Boolean, $showOnlyUnread: Boolean) {
  getProcessReport(
    languageCode: $languageCode
    accessToken: $accessToken
    addedOnFrom: $addedOnFrom
    addedOnTo: $addedOnTo
    publicAccess: $publicAccess
    teamFilters: $teamsFilter
    positionIds: $positionIds
    recruiterIds: $recruiterIds
    managerIds: $managerIds
    withoutDeleted: $withoutDeleted
    showOnlyUnread: $showOnlyUnread
  ) {
    ...ProcessReportFragment
  }
}
    ${ProcessReportFragmentFragmentDoc}`;

/**
 * __useGetProcessReportQuery__
 *
 * To run a query within a React component, call `useGetProcessReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessReportQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      accessToken: // value for 'accessToken'
 *      addedOnFrom: // value for 'addedOnFrom'
 *      addedOnTo: // value for 'addedOnTo'
 *      publicAccess: // value for 'publicAccess'
 *      teamsFilter: // value for 'teamsFilter'
 *      positionIds: // value for 'positionIds'
 *      recruiterIds: // value for 'recruiterIds'
 *      managerIds: // value for 'managerIds'
 *      withoutDeleted: // value for 'withoutDeleted'
 *      showOnlyUnread: // value for 'showOnlyUnread'
 *   },
 * });
 */
export function useGetProcessReportQuery(baseOptions: Apollo.QueryHookOptions<GetProcessReportQuery, GetProcessReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessReportQuery, GetProcessReportQueryVariables>(GetProcessReportDocument, options);
      }
export function useGetProcessReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessReportQuery, GetProcessReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessReportQuery, GetProcessReportQueryVariables>(GetProcessReportDocument, options);
        }
export function useGetProcessReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessReportQuery, GetProcessReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessReportQuery, GetProcessReportQueryVariables>(GetProcessReportDocument, options);
        }
export type GetProcessReportQueryHookResult = ReturnType<typeof useGetProcessReportQuery>;
export type GetProcessReportLazyQueryHookResult = ReturnType<typeof useGetProcessReportLazyQuery>;
export type GetProcessReportSuspenseQueryHookResult = ReturnType<typeof useGetProcessReportSuspenseQuery>;
export type GetProcessReportQueryResult = Apollo.QueryResult<GetProcessReportQuery, GetProcessReportQueryVariables>;
export const AiSurveySummaryQueryDocument = gql`
    query aiSurveySummaryQuery($languageCode: String!, $accessToken: String!, $systemMessage: String, $answers: [QuestionWithAnswer!]) {
  aiSurveySummary(
    languageCode: $languageCode
    accessToken: $accessToken
    systemMessage: $systemMessage
    answers: $answers
  ) {
    ...AiSurveySummaryFragment
  }
}
    ${AiSurveySummaryFragmentFragmentDoc}`;

/**
 * __useAiSurveySummaryQueryQuery__
 *
 * To run a query within a React component, call `useAiSurveySummaryQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiSurveySummaryQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiSurveySummaryQueryQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      accessToken: // value for 'accessToken'
 *      systemMessage: // value for 'systemMessage'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useAiSurveySummaryQueryQuery(baseOptions: Apollo.QueryHookOptions<AiSurveySummaryQueryQuery, AiSurveySummaryQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiSurveySummaryQueryQuery, AiSurveySummaryQueryQueryVariables>(AiSurveySummaryQueryDocument, options);
      }
export function useAiSurveySummaryQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiSurveySummaryQueryQuery, AiSurveySummaryQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiSurveySummaryQueryQuery, AiSurveySummaryQueryQueryVariables>(AiSurveySummaryQueryDocument, options);
        }
export function useAiSurveySummaryQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AiSurveySummaryQueryQuery, AiSurveySummaryQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AiSurveySummaryQueryQuery, AiSurveySummaryQueryQueryVariables>(AiSurveySummaryQueryDocument, options);
        }
export type AiSurveySummaryQueryQueryHookResult = ReturnType<typeof useAiSurveySummaryQueryQuery>;
export type AiSurveySummaryQueryLazyQueryHookResult = ReturnType<typeof useAiSurveySummaryQueryLazyQuery>;
export type AiSurveySummaryQuerySuspenseQueryHookResult = ReturnType<typeof useAiSurveySummaryQuerySuspenseQuery>;
export type AiSurveySummaryQueryQueryResult = Apollo.QueryResult<AiSurveySummaryQueryQuery, AiSurveySummaryQueryQueryVariables>;
export const ReportDefinitionsNewForSurveyDocument = gql`
    query ReportDefinitionsNewForSurvey($surveyId: ID!) {
  reportDefinitionsNewForSurvey(surveyId: $surveyId) {
    id
    name
    createdAt
    createdBy
    isPrimary
  }
}
    `;

/**
 * __useReportDefinitionsNewForSurveyQuery__
 *
 * To run a query within a React component, call `useReportDefinitionsNewForSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDefinitionsNewForSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDefinitionsNewForSurveyQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useReportDefinitionsNewForSurveyQuery(baseOptions: Apollo.QueryHookOptions<ReportDefinitionsNewForSurveyQuery, ReportDefinitionsNewForSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDefinitionsNewForSurveyQuery, ReportDefinitionsNewForSurveyQueryVariables>(ReportDefinitionsNewForSurveyDocument, options);
      }
export function useReportDefinitionsNewForSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDefinitionsNewForSurveyQuery, ReportDefinitionsNewForSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDefinitionsNewForSurveyQuery, ReportDefinitionsNewForSurveyQueryVariables>(ReportDefinitionsNewForSurveyDocument, options);
        }
export function useReportDefinitionsNewForSurveySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportDefinitionsNewForSurveyQuery, ReportDefinitionsNewForSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportDefinitionsNewForSurveyQuery, ReportDefinitionsNewForSurveyQueryVariables>(ReportDefinitionsNewForSurveyDocument, options);
        }
export type ReportDefinitionsNewForSurveyQueryHookResult = ReturnType<typeof useReportDefinitionsNewForSurveyQuery>;
export type ReportDefinitionsNewForSurveyLazyQueryHookResult = ReturnType<typeof useReportDefinitionsNewForSurveyLazyQuery>;
export type ReportDefinitionsNewForSurveySuspenseQueryHookResult = ReturnType<typeof useReportDefinitionsNewForSurveySuspenseQuery>;
export type ReportDefinitionsNewForSurveyQueryResult = Apollo.QueryResult<ReportDefinitionsNewForSurveyQuery, ReportDefinitionsNewForSurveyQueryVariables>;
export const ReportDefinitionsNewForTopicDocument = gql`
    query ReportDefinitionsNewForTopic($surveyId: ID!) {
  reportDefinitionsNewForTopic(surveyId: $surveyId) {
    id
    name
    createdAt
    createdBy
    isPrimary
  }
}
    `;

/**
 * __useReportDefinitionsNewForTopicQuery__
 *
 * To run a query within a React component, call `useReportDefinitionsNewForTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDefinitionsNewForTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDefinitionsNewForTopicQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useReportDefinitionsNewForTopicQuery(baseOptions: Apollo.QueryHookOptions<ReportDefinitionsNewForTopicQuery, ReportDefinitionsNewForTopicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDefinitionsNewForTopicQuery, ReportDefinitionsNewForTopicQueryVariables>(ReportDefinitionsNewForTopicDocument, options);
      }
export function useReportDefinitionsNewForTopicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDefinitionsNewForTopicQuery, ReportDefinitionsNewForTopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDefinitionsNewForTopicQuery, ReportDefinitionsNewForTopicQueryVariables>(ReportDefinitionsNewForTopicDocument, options);
        }
export function useReportDefinitionsNewForTopicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportDefinitionsNewForTopicQuery, ReportDefinitionsNewForTopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportDefinitionsNewForTopicQuery, ReportDefinitionsNewForTopicQueryVariables>(ReportDefinitionsNewForTopicDocument, options);
        }
export type ReportDefinitionsNewForTopicQueryHookResult = ReturnType<typeof useReportDefinitionsNewForTopicQuery>;
export type ReportDefinitionsNewForTopicLazyQueryHookResult = ReturnType<typeof useReportDefinitionsNewForTopicLazyQuery>;
export type ReportDefinitionsNewForTopicSuspenseQueryHookResult = ReturnType<typeof useReportDefinitionsNewForTopicSuspenseQuery>;
export type ReportDefinitionsNewForTopicQueryResult = Apollo.QueryResult<ReportDefinitionsNewForTopicQuery, ReportDefinitionsNewForTopicQueryVariables>;
export const ReportDefinitionNewForTopicDocument = gql`
    query ReportDefinitionNewForTopic($surveyId: ID!, $id: ID!) {
  reportDefinitionNewForTopic(surveyId: $surveyId, id: $id) {
    id
    name
    createdAt
    createdBy
    isPrimary
    definition
  }
}
    `;

/**
 * __useReportDefinitionNewForTopicQuery__
 *
 * To run a query within a React component, call `useReportDefinitionNewForTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDefinitionNewForTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDefinitionNewForTopicQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportDefinitionNewForTopicQuery(baseOptions: Apollo.QueryHookOptions<ReportDefinitionNewForTopicQuery, ReportDefinitionNewForTopicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDefinitionNewForTopicQuery, ReportDefinitionNewForTopicQueryVariables>(ReportDefinitionNewForTopicDocument, options);
      }
export function useReportDefinitionNewForTopicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDefinitionNewForTopicQuery, ReportDefinitionNewForTopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDefinitionNewForTopicQuery, ReportDefinitionNewForTopicQueryVariables>(ReportDefinitionNewForTopicDocument, options);
        }
export function useReportDefinitionNewForTopicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportDefinitionNewForTopicQuery, ReportDefinitionNewForTopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportDefinitionNewForTopicQuery, ReportDefinitionNewForTopicQueryVariables>(ReportDefinitionNewForTopicDocument, options);
        }
export type ReportDefinitionNewForTopicQueryHookResult = ReturnType<typeof useReportDefinitionNewForTopicQuery>;
export type ReportDefinitionNewForTopicLazyQueryHookResult = ReturnType<typeof useReportDefinitionNewForTopicLazyQuery>;
export type ReportDefinitionNewForTopicSuspenseQueryHookResult = ReturnType<typeof useReportDefinitionNewForTopicSuspenseQuery>;
export type ReportDefinitionNewForTopicQueryResult = Apollo.QueryResult<ReportDefinitionNewForTopicQuery, ReportDefinitionNewForTopicQueryVariables>;
export const ReportDefinitionNewForSurveyDocument = gql`
    query ReportDefinitionNewForSurvey($surveyId: ID!, $id: ID!) {
  reportDefinitionNewForSurvey(surveyId: $surveyId, id: $id) {
    id
    name
    createdAt
    createdBy
    isPrimary
    definition
  }
}
    `;

/**
 * __useReportDefinitionNewForSurveyQuery__
 *
 * To run a query within a React component, call `useReportDefinitionNewForSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDefinitionNewForSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDefinitionNewForSurveyQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportDefinitionNewForSurveyQuery(baseOptions: Apollo.QueryHookOptions<ReportDefinitionNewForSurveyQuery, ReportDefinitionNewForSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDefinitionNewForSurveyQuery, ReportDefinitionNewForSurveyQueryVariables>(ReportDefinitionNewForSurveyDocument, options);
      }
export function useReportDefinitionNewForSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDefinitionNewForSurveyQuery, ReportDefinitionNewForSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDefinitionNewForSurveyQuery, ReportDefinitionNewForSurveyQueryVariables>(ReportDefinitionNewForSurveyDocument, options);
        }
export function useReportDefinitionNewForSurveySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportDefinitionNewForSurveyQuery, ReportDefinitionNewForSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportDefinitionNewForSurveyQuery, ReportDefinitionNewForSurveyQueryVariables>(ReportDefinitionNewForSurveyDocument, options);
        }
export type ReportDefinitionNewForSurveyQueryHookResult = ReturnType<typeof useReportDefinitionNewForSurveyQuery>;
export type ReportDefinitionNewForSurveyLazyQueryHookResult = ReturnType<typeof useReportDefinitionNewForSurveyLazyQuery>;
export type ReportDefinitionNewForSurveySuspenseQueryHookResult = ReturnType<typeof useReportDefinitionNewForSurveySuspenseQuery>;
export type ReportDefinitionNewForSurveyQueryResult = Apollo.QueryResult<ReportDefinitionNewForSurveyQuery, ReportDefinitionNewForSurveyQueryVariables>;
export const GetNewReportDocument = gql`
    query GetNewReport($accessToken: String!, $languageCode: String, $publicAccess: Boolean) {
  getNewReport(
    accessToken: $accessToken
    languageCode: $languageCode
    publicAccess: $publicAccess
  ) {
    id
    reportRoots
    totalRespondents
    teams {
      id
      teamName
      directMembers
      memberTeams
      teamLeader
    }
    anonymityEnabled
    anonymityForced
    anonymitySettings {
      default
      allowedLevels
    }
    surveys {
      public
      status
    }
    questions {
      id
      index
      reportIndex
      text
      type
      selectedRange
      answersLocal
      statementsLocal
      showEscapeOption
      isRankingScale
      metrics
      reportOrder
      answersToHighlight
    }
    responses {
      id
      respondentId
      surveyId
      topicGroupId
      anonymous
      finished
      additionallyAnonymized
      originalAnonymous
      messages {
        id
        questionDefinitionIndex
        statementIndex
        text
        value
        comment
        relevance
        anonymous
        originalAnonymous
        date
      }
    }
    respondents {
      id
      firstname
      surname
      addedOn
    }
    metadata {
      surveyStart
      surveyEnd
      status
      organizationDepth
      language {
        id
        code
      }
      adminEmails
      topicGroupId
      organization {
        id
        name
        systemName
        featureNames
        languages {
          code
        }
      }
    }
    topicGroup {
      translations {
        language {
          code
        }
        value
        description
      }
    }
    questionLabels {
      questionDefinitionIndex
      questionLabelComments {
        label
        commentIds
      }
    }
    surveyId
    reportDefinition {
      id
      definition
    }
  }
}
    `;

/**
 * __useGetNewReportQuery__
 *
 * To run a query within a React component, call `useGetNewReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewReportQuery({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      languageCode: // value for 'languageCode'
 *      publicAccess: // value for 'publicAccess'
 *   },
 * });
 */
export function useGetNewReportQuery(baseOptions: Apollo.QueryHookOptions<GetNewReportQuery, GetNewReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewReportQuery, GetNewReportQueryVariables>(GetNewReportDocument, options);
      }
export function useGetNewReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewReportQuery, GetNewReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewReportQuery, GetNewReportQueryVariables>(GetNewReportDocument, options);
        }
export function useGetNewReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNewReportQuery, GetNewReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNewReportQuery, GetNewReportQueryVariables>(GetNewReportDocument, options);
        }
export type GetNewReportQueryHookResult = ReturnType<typeof useGetNewReportQuery>;
export type GetNewReportLazyQueryHookResult = ReturnType<typeof useGetNewReportLazyQuery>;
export type GetNewReportSuspenseQueryHookResult = ReturnType<typeof useGetNewReportSuspenseQuery>;
export type GetNewReportQueryResult = Apollo.QueryResult<GetNewReportQuery, GetNewReportQueryVariables>;
export const ReportSubscriptionDocument = gql`
    subscription ReportSubscription($languageCode: String, $accessToken: String!, $reportDefinitionId: ID, $topicGroupId: ID, $addedOnFrom: Date, $addedOnTo: Date, $publicAccess: Boolean) {
  getReport(
    languageCode: $languageCode
    accessToken: $accessToken
    reportDefinitionId: $reportDefinitionId
    topicGroupId: $topicGroupId
    addedOnFrom: $addedOnFrom
    addedOnTo: $addedOnTo
    publicAccess: $publicAccess
  ) {
    ...ReportFragment
  }
}
    ${ReportFragmentFragmentDoc}`;

/**
 * __useReportSubscriptionSubscription__
 *
 * To run a query within a React component, call `useReportSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReportSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSubscriptionSubscription({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      accessToken: // value for 'accessToken'
 *      reportDefinitionId: // value for 'reportDefinitionId'
 *      topicGroupId: // value for 'topicGroupId'
 *      addedOnFrom: // value for 'addedOnFrom'
 *      addedOnTo: // value for 'addedOnTo'
 *      publicAccess: // value for 'publicAccess'
 *   },
 * });
 */
export function useReportSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<ReportSubscriptionSubscription, ReportSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ReportSubscriptionSubscription, ReportSubscriptionSubscriptionVariables>(ReportSubscriptionDocument, options);
      }
export type ReportSubscriptionSubscriptionHookResult = ReturnType<typeof useReportSubscriptionSubscription>;
export type ReportSubscriptionSubscriptionResult = Apollo.SubscriptionResult<ReportSubscriptionSubscription>;
export const ReportSequenceSubscriptionDocument = gql`
    subscription ReportSequenceSubscription($languageCode: String, $accessToken: String!, $addedOnFrom: Date, $addedOnTo: Date, $publicAccess: Boolean, $teamsFilter: [String!], $positionIds: [ID!], $recruiterIds: [ID!], $managerIds: [ID!], $withoutDeleted: Boolean, $showOnlyUnread: Boolean) {
  getProcessReport(
    languageCode: $languageCode
    accessToken: $accessToken
    addedOnFrom: $addedOnFrom
    addedOnTo: $addedOnTo
    publicAccess: $publicAccess
    teamFilters: $teamsFilter
    positionIds: $positionIds
    recruiterIds: $recruiterIds
    managerIds: $managerIds
    withoutDeleted: $withoutDeleted
    showOnlyUnread: $showOnlyUnread
  ) {
    ...ProcessReportFragment
  }
}
    ${ProcessReportFragmentFragmentDoc}`;

/**
 * __useReportSequenceSubscriptionSubscription__
 *
 * To run a query within a React component, call `useReportSequenceSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReportSequenceSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSequenceSubscriptionSubscription({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      accessToken: // value for 'accessToken'
 *      addedOnFrom: // value for 'addedOnFrom'
 *      addedOnTo: // value for 'addedOnTo'
 *      publicAccess: // value for 'publicAccess'
 *      teamsFilter: // value for 'teamsFilter'
 *      positionIds: // value for 'positionIds'
 *      recruiterIds: // value for 'recruiterIds'
 *      managerIds: // value for 'managerIds'
 *      withoutDeleted: // value for 'withoutDeleted'
 *      showOnlyUnread: // value for 'showOnlyUnread'
 *   },
 * });
 */
export function useReportSequenceSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<ReportSequenceSubscriptionSubscription, ReportSequenceSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ReportSequenceSubscriptionSubscription, ReportSequenceSubscriptionSubscriptionVariables>(ReportSequenceSubscriptionDocument, options);
      }
export type ReportSequenceSubscriptionSubscriptionHookResult = ReturnType<typeof useReportSequenceSubscriptionSubscription>;
export type ReportSequenceSubscriptionSubscriptionResult = Apollo.SubscriptionResult<ReportSequenceSubscriptionSubscription>;
export const AiSurveySummarySubscriptionDocument = gql`
    subscription aiSurveySummarySubscription($languageCode: String!, $accessToken: String!, $systemMessage: String, $answers: [QuestionWithAnswer!]) {
  aiSurveySummary(
    languageCode: $languageCode
    accessToken: $accessToken
    systemMessage: $systemMessage
    answers: $answers
  ) {
    ...AiSurveySummaryFragment
  }
}
    ${AiSurveySummaryFragmentFragmentDoc}`;

/**
 * __useAiSurveySummarySubscriptionSubscription__
 *
 * To run a query within a React component, call `useAiSurveySummarySubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAiSurveySummarySubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiSurveySummarySubscriptionSubscription({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      accessToken: // value for 'accessToken'
 *      systemMessage: // value for 'systemMessage'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useAiSurveySummarySubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<AiSurveySummarySubscriptionSubscription, AiSurveySummarySubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AiSurveySummarySubscriptionSubscription, AiSurveySummarySubscriptionSubscriptionVariables>(AiSurveySummarySubscriptionDocument, options);
      }
export type AiSurveySummarySubscriptionSubscriptionHookResult = ReturnType<typeof useAiSurveySummarySubscriptionSubscription>;
export type AiSurveySummarySubscriptionSubscriptionResult = Apollo.SubscriptionResult<AiSurveySummarySubscriptionSubscription>;
export const AiSurveySummaryAbTestSubscriptionDocument = gql`
    subscription aiSurveySummaryAbTestSubscription($languageCode: String!, $accessToken: String!, $defaultSystemMessage: String!, $answers: [QuestionWithAnswer!]) {
  aiSurveySummaryAbTest(
    languageCode: $languageCode
    accessToken: $accessToken
    defaultSystemMessage: $defaultSystemMessage
    answers: $answers
  ) {
    mode
    experimentId
    layout
    left {
      text
      done
      variantKey
      hash
    }
    right {
      text
      done
      variantKey
      hash
    }
    single {
      text
      done
      hash
    }
  }
}
    `;

/**
 * __useAiSurveySummaryAbTestSubscriptionSubscription__
 *
 * To run a query within a React component, call `useAiSurveySummaryAbTestSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAiSurveySummaryAbTestSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiSurveySummaryAbTestSubscriptionSubscription({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      accessToken: // value for 'accessToken'
 *      defaultSystemMessage: // value for 'defaultSystemMessage'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useAiSurveySummaryAbTestSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<AiSurveySummaryAbTestSubscriptionSubscription, AiSurveySummaryAbTestSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AiSurveySummaryAbTestSubscriptionSubscription, AiSurveySummaryAbTestSubscriptionSubscriptionVariables>(AiSurveySummaryAbTestSubscriptionDocument, options);
      }
export type AiSurveySummaryAbTestSubscriptionSubscriptionHookResult = ReturnType<typeof useAiSurveySummaryAbTestSubscriptionSubscription>;
export type AiSurveySummaryAbTestSubscriptionSubscriptionResult = Apollo.SubscriptionResult<AiSurveySummaryAbTestSubscriptionSubscription>;
export const GetProcessKeywordsSubscriptionDocument = gql`
    subscription getProcessKeywordsSubscription($languageCode: String!, $accessToken: String!, $questionIdx: String!, $answersIds: [String!]!, $generate: Boolean!) {
  getProcessKeywords(
    languageCode: $languageCode
    accessToken: $accessToken
    questionIdx: $questionIdx
    answersIds: $answersIds
    generate: $generate
  ) {
    keywords {
      label
      commentIds
    }
    done
  }
}
    `;

/**
 * __useGetProcessKeywordsSubscriptionSubscription__
 *
 * To run a query within a React component, call `useGetProcessKeywordsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessKeywordsSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessKeywordsSubscriptionSubscription({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      accessToken: // value for 'accessToken'
 *      questionIdx: // value for 'questionIdx'
 *      answersIds: // value for 'answersIds'
 *      generate: // value for 'generate'
 *   },
 * });
 */
export function useGetProcessKeywordsSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetProcessKeywordsSubscriptionSubscription, GetProcessKeywordsSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetProcessKeywordsSubscriptionSubscription, GetProcessKeywordsSubscriptionSubscriptionVariables>(GetProcessKeywordsSubscriptionDocument, options);
      }
export type GetProcessKeywordsSubscriptionSubscriptionHookResult = ReturnType<typeof useGetProcessKeywordsSubscriptionSubscription>;
export type GetProcessKeywordsSubscriptionSubscriptionResult = Apollo.SubscriptionResult<GetProcessKeywordsSubscriptionSubscription>;